export const en = {
  // Previously a separate, untyped "analytics" i18next namespace
  // (AVAC-Dashboard/public/locales/*/analytics.json); merged in here so all
  // analytics translation keys get the same compile-time checking as everything else.
  ANALYTICS: {
    DATE: {
      CUSTOM: "Custom",
      CUSTOM_FROM_TO: "{{FROM}} - {{TO}}",
      TODAY: "Today",
      YESTERDAY: "Yesterday",
      LAST_7_DAYS: "Last 7 Days",
      LAST_30_DAYS: "Last 30 Days",
    },
    CHART: {
      BAR_CHART: "Bar Chart",
      PIE_CHART: "Pie Chart",
      TIME_SERIES: "Time Series",
    },
    COLUMN: {
      CARRIER: "Carrier",
      EQUIPMENT_TYPE: "Vehicle Type",
      GATE_ACCESS_TYPE: "Access Control Method",
      GATE_ACTIVITY_TYPE: "Gate Transaction Type",
      GATE_ACTIVITY_FAILURE_TYPE: "Gate Exception Type",
      GATE_ACTIVITY_STATUS: "Gate Transaction Status",
    },
    COMMAND: {
      ADD_CHARTS: "Add Charts",
      CLEAR: "Clear",
      DESELECT_ALL: "Deselect all",
      DONE: "Done",
      EXPORT_TO_PDF: "Export to PDF",
      HIDE_FILTERS: "Hide Filters",
      REMOVE: "Remove",
      SELECT_ALL: "Select all",
      SHOW_FILTERS: "Show Filters",
      VIEW_CHARTS_one: "View Chart ({{count}})",
      VIEW_CHARTS: "View Charts ({{count}})",
      VIEW_CHARTS_few: "View Charts ({{count}})",
      VIEW_CHARTS_many: "View Charts ({{count}})",
    },
    ERROR: {
      LOAD_FAILED: "Failed to load analytics configuration",
      LOAD_DATA_FAILED: "Failed to load data for analytics",
      SAVE_FAILED: "Failed to save analytics configuration",
    },
    GATE: {
      CATEGORY: {
        "Traffic Volume and Throughput": "Traffic Volume and Throughput",
        "Dwell & Engagement Time": "Dwell & Engagement Time",
        "Access Control Methods": "Access Control Methods",
        "Gate Transaction Status": "Gate Transactions Status",
        "Gate Transaction Type": "Gate Transaction Type",
        "Gate Exception Type": "Gate Exception Type",
      },
      DESC: {
        "Traffic Volume and Throughput":
          "Volume and distribution of inbound and outbound traffic.",
        "Dwell & Engagement Time":
          "Duration of driver engagement and vehicle dwell time at the gate.",
        "Access Control Methods":
          "Usage statistics for automated vs. manual access control methods.",
        "Gate Transaction Status":
          "Distribution of success and failure rates of gate transactions.",
        "Gate Transaction Type":
          "Traffic volume broken down by transaction type (e.g., Load, Unload).",
        "Gate Exception Type": "Trends and Reasons of gate transaction exceptions.",
      },
      KPI: {
        "Avg. Inbound Traffic": "Avg. Inbound Traffic",
        "Avg. Outbound Traffic": "Avg. Outbound Traffic",
        "Avg. Total Traffic": "Avg. Total Traffic",
        "Avg. Inbound Traffic (%)": "Avg. Inbound Traffic (%)",
        "Avg. Outbound Traffic (%)": "Avg. Outbound Traffic (%)",
        "Avg. Total Traffic (%)": "Avg. Total Traffic (%)",

        "Avg. Inbound Driver Engagement Time (Sec)":
          "Avg. Inbound Driver Engagement Time (Sec)",
        "Avg. Outbound Driver Engagement Time (Sec)":
          "Avg. Outbound Driver Engagement Time (Sec)",
        "Avg. Total Driver Engagement Time (Sec)":
          "Avg. Total Driver Engagement Time (Sec)",
        "Avg. Inbound Gate Dwell Time (Sec)": "Avg. Inbound Gate Dwell Time (Sec)",
        "Avg. Outbound Gate Dwell Time (Sec)": "Avg. Outbound Gate Dwell Time (Sec)",
        "Avg. Total Gate Dwell Time (Sec)": "Avg. Total Gate Dwell Time (Sec)",

        "Avg. # of Inbound {{TYPE}}": "Avg. # of Inbound {{TYPE}}",
        "Avg. # of Outbound {{TYPE}}": "Avg. # of Outbound {{TYPE}}",
        "Avg. # of Total {{TYPE}}": "Avg. # of Total {{TYPE}}",
        "Avg. % of Inbound {{TYPE}}": "Avg. % of Inbound {{TYPE}}",
        "Avg. % of Outbound {{TYPE}}": "Avg. % of Outbound {{TYPE}}",
        "Avg. % of Total {{TYPE}}": "Avg. % of Total {{TYPE}}",
      },
      TITLE: {
        "Inbound Traffic Volume": "Inbound Traffic Volume",
        "Outbound Traffic Volume": "Outbound Traffic Volume",
        "Total Traffic Volume": "Total Traffic Volume",
        "Inbound Vehicle Distribution (%)": "Inbound Vehicle Distribution (%)",
        "Outbound Vehicle Distribution (%)": "Outbound Vehicle Distribution (%)",
        "Total Vehicle Distribution (%)": "Total Vehicle Distribution (%)",

        "Inbound Driver Engagement Time (Sec)": "Inbound Driver Engagement Time (Sec)",
        "Outbound Driver Engagement Time (Sec)": "Outbound Driver Engagement Time (Sec)",
        "Total Driver Engagement Time (Sec)": "Total Driver Engagement Time (Sec)",
        "Inbound Gate Dwell Time (Sec)": "Inbound Gate Dwell Time (Sec)",
        "Outbound Gate Dwell Time (Sec)": "Outbound Gate Dwell Time (Sec)",
        "Total Gate Dwell Time (Sec)": "Total Gate Dwell Time (Sec)",

        "Inbound Volume by Access Type": "Inbound Volume by Access Type",
        "Outbound Volume by Access Type": "Outbound Volume by Access Type",
        "Total Volume by Access Type": "Total Volume by Access Type",
        "Inbound Access Type Distribution (%)": "Inbound Access Type Distribution (%)",
        "Outbound Access Type Distribution (%)": "Outbound Access Type Distribution (%)",
        "Total Access Type Distribution (%)": "Total Access Type Distribution (%)",

        "Inbound Volume by Transaction Status": "Inbound Volume by Transaction Status",
        "Outbound Volume by Transaction Status": "Outbound Volume by Transaction Status",
        "Total Volume by Transaction Status": "Total Volume by Transaction Status",
        "Inbound Transaction Status Distribution (%)":
          "Inbound Transaction Status Distribution (%)",
        "Outbound Transaction Status Distribution (%)":
          "Outbound Transaction Status Distribution (%)",
        "Total Transaction Status Distribution (%)":
          "Total Transaction Status Distribution (%)",

        "Inbound Volume by Transaction Type": "Inbound Volume by Transaction Type",
        "Outbound Volume by Transaction Type": "Outbound Volume by Transaction Type",
        "Total Volume by Transaction Type": "Total Volume by Transaction Type",
        "Inbound Transaction Type Distribution (%)":
          "Inbound Transaction Type Distribution (%)",
        "Outbound Transaction Type Distribution (%)":
          "Outbound Transaction Type Distribution (%)",
        "Total Transaction Type Distribution (%)":
          "Total Transaction Type Distribution (%)",

        "Inbound Volume by Exception Type": "Inbound Volume by Exception Type",
        "Outbound Volume by Exception Type": "Outbound Volume by Exception Type",
        "Total Volume by Exception Type": "Total Volume by Exception Type",
        "Inbound Exception Distribution (%)": "Inbound Exception Distribution (%)",
        "Outbound Exception Distribution (%)": "Outbound Exception Distribution (%)",
        "Total Exception Distribution (%)": "Total Exception Distribution (%)",
      },
    },
    GROUP: {
      GATE_EFFICIENCY: "Gate Efficiency",
      YARD_EFFICIENCY: "Yard Efficiency",
    },
    LABEL: {
      CHOOSE_CHARTS: "Choose your customized Charts",
      COUNT: "Count",
      GROUP_BY: "Group By",
      KPIS: "KPIs",
      NO_OPTIONS: "No Options",
      N_SELECTIONS_two: "{{count}} Selections",
      N_SELECTIONS_few: "{{count}} Selections",
      N_SELECTIONS_many: "{{count}} Selections",
      N_SELECTIONS_other: "{{count}} Selections",
      NO_DATA: "No Data",
      REMAINDER_two: "Remainder ({{count}})",
      REMAINDER_few: "Remainder ({{count}})",
      REMAINDER_many: "Remainder ({{count}})",
      REMAINDER_other: "Remainder ({{count}})",
      PERCENT: "Percent",
      PERCENT_short: "Pct.",
      SERIES: "Data Segmentation",
      TIME_RANGE: "Time Range",
      TITLE_N_SELECTED_zero: "{{TITLE}}",
      TITLE_N_SELECTED: "{{TITLE}} ({{count}} selected)",
      TOTAL: "Total",
      VIEW_BREAKDOWN: "View Full Breakdown",
    },
    MENU: {
      CHART: {
        SHOW_KPI: "Show KPI",
        HIDE_KPI: "Hide KPI",
        SAVE_PNG: "Save as PNG",
        SAVE_JPG: "Save as JPEG",
        EXPORT_CSV: "Export data to CSV",
        EXPORT_XLSX: "Export data to XLSX",
        REMOVE_CHART: "Remove chart",
      },
      PAGE: {
        REMOVE_ALL: "Remove All",
      },
    },
    SERIES: {
      CARRIER: "Separate data by carrier",
      CARRIER_short: "Carrier",
      ENTRY_TYPE_short: "Direction",
      ENTRY_TYPE: "Separate into inbound and outbound traffic",
      EQUIPMENT_TYPE_short: "Vehicle",
      EQUIPMENT_TYPE: "Separate data by type of vehicle",
      GATE_ACCESS_TYPE: "Separate data by access type",
      GATE_ACCESS_TYPE_short: "Type",
      GATE_ACTIVITY_TYPE: "Separate data by gate transaction type",
      GATE_ACTIVITY_TYPE_short: "Type",
      GATE_ACTIVITY_FAILURE_TYPE: "Separate data by gate exception type",
      GATE_ACTIVITY_FAILURE_TYPE_short: "Type",
      GATE_ACTIVITY_STATUS: "Separate data by gate activity status",
      GATE_ACTIVITY_STATUS_short: "Status",
      NONE_short: "None",
      NONE: "Do not separate the data into series",
    },
    SUBTITLE: {
      CARRIER_few: "Carriers ({{count}})",
      CARRIER_many: "Carriers ({{count}})",
      CARRIER_other: "Carriers ({{count}})",
      EQUIPMENT_TYPE_few: "Vehicles ({{count}})",
      EQUIPMENT_TYPE_many: "Vehicles ({{count}})",
      EQUIPMENT_TYPE_other: "Vehicles ({{count}})",
      GATE_ACCESS_TYPE_few: "Access Types ({{count}})",
      GATE_ACCESS_TYPE_many: "Access Types ({{count}})",
      GATE_ACCESS_TYPE_other: "Access Types ({{count}})",
      GATE_ACTIVITY_FAILURE_TYPE_few: "Failure Types ({{count}})",
      GATE_ACTIVITY_FAILURE_TYPE_many: "Failure Types ({{count}})",
      GATE_ACTIVITY_FAILURE_TYPE_other: "Failure Types ({{count}})",
      GATE_ACTIVITY_STATUS_few: "Activity Statuses ({{count}})",
      GATE_ACTIVITY_STATUS_many: "Activity Statuses ({{count}})",
      GATE_ACTIVITY_STATUS_other: "Activity Statuses ({{count}})",
      GATE_ACTIVITY_TYPE_few: "Access Types ({{count}})",
      GATE_ACTIVITY_TYPE_many: "Access Types ({{count}})",
      GATE_ACTIVITY_TYPE_other: "Access Types ({{count}})",
    },
    GROUP_BY: {
      HOUR: "Group by hour of the day",
      HOUR_short: "Hour",
      DAY: "Group by day of the week",
      DAY_short: "Day",
      WEEK: "Group by week of the year",
      WEEK_short: "Week",
      MONTH: "Group by month of the year",
      MONTH_short: "Month",
    },
    YARD: {},
    Y_AXIS: {
      All: "All",
      "All Carriers": "All Carriers",
      "All Statuses": "All Statuses",
      "All Exceptions": "All Exceptions",
      "All Types": "All Types",
      "All Vehicles": "All Vehicles",

      Bobtail: "Bobtail",
      "Regular Vehicle": "Regular Vehicle",
      Chassis: "Chassis",
      "Multi Trailer": "Multi Trailer",
      Trailer: "Trailer",
      "Trailer/Tanker": "Trailer",

      "QR Code": "QR Code",
      Kiosk: "Kiosk",
      Manual: "Manual",

      Success: "Success",
      Failure: "Failure",
      Approved: "Approved",

      Other: "Other",
      null: "null",

      "Temperature is missing": "Temperature is missing",
    },
  },
  APP: {
    DEVELOPED_BY_EAIGLE: "Developed by EAIGLE",
    INVALID_FACILITY: "FACILITY NOT FOUND!",
    PAGE_NOT_FOUND: "Page Not Found. Invalid Parameters",
    PLEASE_ROTATE: "Please rotate your device to portrait mode to use this application.",
    POWERED_BY_EAIGLE: "Powered by <LOGO/> eaigle.com",
  },
  AGENT_DASHBOARD: {
    DAMAGE_REVIEW: {
      TITLE: "Damage Review",
      DAMAGE: "Damage",
      EXPAND_DAMAGE_LABEL: "Expand damage image {{id}}",
      REJECT_DAMAGE: "Reject",
      CONFIRM_DAMAGE: "Confirm",
      CHANGE_REVIEW: "Change review",
      LAST_CHANGED_BY: "Last changed by {{changedBy}}",
      POSSIBLE_DAMAGE: "Possible damage",
      AWAITING_REVIEW: "Awaiting review",
      DETECTED_DAMAGE: "Detected damage",
      CONFIRMED_DAMAGE: "Confirmed damage",
      REJECTED_DAMAGE: "Rejected damage",
      LOAD_ERROR: "Couldn't load damage annotations.",
      SAVE_ERROR: "Couldn't save your review. Try again.",
    },
    GATE_LOG_DETAILS: {
      LOADING: "Loading event details...",
      LOAD_ERROR: "Error loading event details. Redirecting to Gate Log...",
      SAVE_ERROR: "Failed to save changes",
      ANNOTATIONS: "Annotations",
      EVENTS: "Events",
      EVENT_DETAILS: "Event Details",
      SAVE_CHANGES: "Save Changes",
      TAG_DAMAGE: "Tag damage",
      REVIEW_STATUS: {
        LABEL: "Review Status:",
        NOT_REVIEWED: "Not Reviewed",
        NEEDS_REVIEW: "Needs Review",
        REVIEWED: "Reviewed",
        AUDITED: "Audited",
        REJECTED: "Rejected",
      },
      BATCH: {
        SELECTED_COUNT: "{{n}} selected",
        DAMAGE_TYPES: "Damage types",
        DAMAGE_TYPES_COUNT: "{{n}} damage types",
        APPLY_TAGS: "Apply tags",
        APPLYING: "Applying...",
        DONE: "Done",
        UPDATED_COUNT_one: "Updated {{count}} image",
        UPDATED_COUNT_other: "Updated {{count}} images",
        UPDATED_PARTIAL: "Updated {{count}} of {{total}} images",
        NOTHING_SELECTED: "Select at least one image to tag",
        NO_TYPES_CHOSEN: "Choose at least one damage type",
        NOTHING_TO_APPLY: "Choose a damage type to add, or remove one from an image",
        REMOVE_TAG: "Remove {{tag}}",
        RESTORE_TAG: "Restore {{tag}}",
      },
      IMAGE_HIDING: {
        HIDE_IMAGE: "Hide image",
        HIDDEN_FROM_CLIENT: "Hidden from client",
        UNHIDE: "Unhide",
        SAVE_ERROR: "Failed to update image visibility",
      },
      MEDIA: {
        VEHICLE_IMAGE_ALT: "Vehicle {{n}}",
        VEHICLE_VIDEO_ALT: "Vehicle video {{n}}",
        SELECT_VEHICLE_IMAGE: "Select vehicle image {{n}}",
        SELECT_DAMAGE_IMAGE: "Select damage image {{id}}",
        EXPAND_LOAD_DETAIL: "Expand {{imageType}}",
        NO_VEHICLE_MEDIA: "No vehicle media available",
        NO_LOAD_DETAIL_IMAGES: "No load detail images available",
        CLICK_OUTSIDE_TO_CLOSE: "Click outside to close",
        VIDEO_UNSUPPORTED: "Your browser does not support the video tag.",
      },
      TRAILER: {
        TITLE: "Trailer Details",
        // Labelled "Trailer Plate Number" though it binds to Chassis.PlateNumber;
        // keeping the wording the agents and the PM already use.
        PLATE_NUMBER: "Trailer Plate Number",
        TYPE: "Type",
        SELECT_A_CARRIER: "Select a carrier",
        NO_INFO: "No trailer information available",
      },
      POWER_UNIT: {
        TITLE: "Power Unit Details",
        UNIT_NUMBER: "Unit Number",
        NO_INFO: "No power unit information available",
        // Keyed off the entries in powerUnitParameters. These rendered as raw
        // camelCase parameter keys before.
        PARAMETER: {
          USDOTNumber: "USDOT Number",
          CVORNumber: "CVOR Number",
          MCNumber: "MC Number",
          CarrierName: "Carrier Name",
        },
      },
      EVENT_INFO: {
        TITLE: "Event Information",
        EVENT_ID: "Event ID",
        LANE_ID: "Lane ID",
        EVENT_TYPE: "Event Type",
        START_TIME: "Start Time",
        END_TIME: "End Time",
        EVENT_STATUS: "Event Status",
      },
    },
  },
  ATTACHMENT: {
    CAMERA_ERROR: "Unable to access the camera.",
    COMMAND: {
      CLOSE: "Close",
      CAMERA: "Take photo",
      CAPTURE: "Capture",
      REMOVE: "Remove",
      UPLOAD: "Upload file",
    },
    LIMIT_REACHED: "Maximum number of files reached.",
    UNSUPPORTED_TYPE: "This file type is not supported.",
  },
  AVAC: {
    ASSET_LOG: {
      LABEL: "Asset Log",
      TITLE: "Asset List",
      DETAILS_TITLE: "Asset Details",
      BACK_TO_LIST: "Back to Asset List",
      BACK_TO_DETAILS: "Back to Asset Detail",
      FILTER: {
        KIND: "Asset Type",
        ASSET_NUMBER: "Asset ID",
        ASSET_PLATE: "License Plate",
        SEAL_NUMBER: "Seal ID",
        CARRIER: "Carrier",
        FACILITY: "Location",
        FROM_FACILITY: "From Facility",
        TO_FACILITY: "To Facility",
        ACTIVITY: "Timeframe",
      },
      KIND: {
        BOBTAIL: "Bobtail",
        VAN: "Van",
        REGULARVEHICLE: "Regular Vehicle",
        CHASSIS: "Chassis",
        TRAILER: "Trailer",
        CONTAINER: "Container",
        "TRAILER/TANKER": "Trailer/Tanker",
        CHILLER: "Chiller",
        GENERATOR: "Generator",
        OTHER: "Other",
      },
      LIST_TABLE: {
        ASSET_ID: "Asset ID",
        ASSET_TYPE: "Asset Type",
        LICENSE_PLATE: "License Plate",
        SEAL_ID: "Seal ID",
        CARRIER: "Carrier",
        LOCATION: "Location",
        FROM_DEPARTURE: "From / Departure",
        LAST_TO_ARRIVAL: "Last To / Arrival",
        TRIP_STATUS: "Trip / Status",
      },
      SUMMARY: {
        CARRIER: "Carrier",
        LICENSE_PLATE: "License Plate",
        LAST_SEEN: "Last Seen",
        LAST_LOCATION: "Last Location",
      },
      HISTORY: {
        COMPARE_SLOT: "A/B",
        DATE: "Date",
        NETWORK: "Network",
        FACILITY: "Facility Name",
        FACILITY_LOCATION: "Facility Location",
        GATE: "Gate",
        LANE: "Lane",
        STATUS: "Status",
        SEAL_ID: "Seal ID",
        TRUCK_ID: "Truck ID",
        CARRIER: "Carrier",
        LICENSE_PLATE: "License Plate",
        USDOT: "USDOT",
        MC: "MC",
      },
      LIST_EMPTY: "No results found.",
      LIST_TABLE_CAPTION: "Asset List",
      HISTORY_TABLE_CAPTION: "Asset history",
      HISTORY_EMPTY: "No history for this asset",
      HISTORY_LOAD_FAILED: "Couldn't load this asset's history",
      HISTORY_OPEN_GATE_LOG: "Open the gate log event",
      EXTERNAL: "External",
      EXTERNAL_TOOLTIP: "This event is from another network",
      PORT_OF_ENTRY: "Port of Entry",
      PORT_OF_ENTRY_BADGE: "POE",
      EXTERNAL_EVENT_UNAVAILABLE:
        "This event cannot be viewed because it is from another network",
      COMPARE: {
        ASSET_ID: "Asset ID",
        LICENSE_PLATE: "License Plate",
        USDOT: "USDOT",
        MC: "MC",
        CVOR: "CVOR",
        ISO: "ISO",
        MAP_TAB: "Map",
        COMPARE_TAB: "Compare",
        PIN_CARD: "Pin {{slot}}",
        UNPIN_CARD: "Unpin {{slot}}",
        PICK_FIRST_EVENT: "Select an event below",
        PICK_SECOND_EVENT: "Select a second event",
        EVENT_WILL_APPEAR: "The event will appear here for comparison",
        CARRIER: "Carrier",
        NETWORK: "Network",
        GATE: "Gate",
        LANE: "Lane",
        SEAL_ID: "Seal ID",
        TRUCK: "Truck",
        TRAILER: "Trailer",
        EVIDENCE: "Evidence",
        PHOTOS: "Photos",
        MEDIA_UNAVAILABLE: "Not available for asset log events yet",
        MORE_IMAGES: "View {{more}} more",
        PLAY_VIDEO: "Play video",
        COLLAPSE: "Hide compare",
        EXPAND: "Show compare",
        RECORD_MOVED: "This event is no longer available",
        RECORD_LOAD_FAILED: "Couldn't load this event",
        IMAGES_UNAVAILABLE: "Images unavailable",
        EXTERNAL_IMAGES_UNAVAILABLE_DESCRIPTION:
          "External network records don't include images",
      },
      LOAD_FAILED: "Couldn't load this asset.",
      ASSET_GONE: "This asset is no longer available",
      ROUTE_STATUS: {
        ARRIVED: "Arrived",
        DEPARTED: "Departed",
      },
      LANE_TYPE: {
        INBOUND: "Inbound",
        OUTBOUND: "Outbound",
      },
      ASSET_SUMMARY: "Asset Summary",
    },
    APPOINTMENTS_LIST: {
      TITLE: "Appointments",
      RECORD_COUNT_one: "{{count}} record",
      RECORD_COUNT_other: "{{count}} records",
      LOADING: "Loading appointments…",
      PLEASE_WAIT: "Please wait",
      ERROR_POPUP_BLOCKED: "Allow pop-ups for this site to print the release form.",
      FAILED_TO_LOAD: "Failed to load appointments.",
      FAILED_TO_UPDATE_STATUS: "Failed to update appointment status.",
      FAILED_TO_UPDATE: "Failed to update appointment.",
      NO_APPOINTMENTS: "No appointments found",
      NO_APPOINTMENTS_HINT: "Appointments will appear here when created",
      NO_COLUMNS: "No appointment list columns configured",
      NO_COLUMNS_HINT: "Configure columns in Settings under Appointment list columns",
      NO_IMAGE: "—",
      UPLOAD_PHOTO: "Upload",
      CHANGE_PHOTO: "Change",
      FAILED_TO_UPLOAD_PHOTO: "Failed to upload photo.",
      COLUMN_CREATED: "Created",
      COLUMN_TYPE: "Type",
      COLUMN_REFERENCE: "Reference",
      COLUMN_SCAC: "SCAC",
      COLUMN_OTP: "OTP",
      COLUMN_EXPIRY_DATE: "Expiry date",
      COLUMN_STATUS: "Status",
      COLUMN_CREATED_BY: "Created by",
      COLUMN_ACTIONS: "Actions",
      COLUMN_TRAILER_NUMBER: "Trailer #",
      COLUMN_SEAL_NUMBER: "Seal #",
      COLUMN_SEAL_PHOTO: "Seal photo",
      COLUMN_DESTINATION: "Destination (Store/FC)",
      COLUMN_MSC_NUMBER: "MSC/Pick Up #",
      STATUS_ACTIVE: "Active",
      STATUS_PENDING: "Pending",
      STATUS_INACTIVE: "Inactive",
      STATUS_VALID: "Valid",
      STATUS_EXPIRED: "Expired",
      ACTION_ACTIVATE: "Activate",
      ACTION_DEACTIVATE: "Deactivate",
      ACTION_SAVE: "Save",
      ACTION_RELEASE_FORM: "Release Form",
      VIEW_APPOINTMENTS: "View Appointments",
      UPDATING: "Updating…",
    },
    AREA: {
      ISO: "ISO",
      TANK_WASH: "Tank Wash",
    },
    CALENDAR: {
      DISCARD_CHANGES_TITLE: "Discard changes",
      DISCARD_CHANGES_MESSAGE: "Switching will discard your changes.",
      DISCARD_CHANGES_HELPER: "Are you sure you want to switch?",
      DISCARD_CHANGES_CONFIRM: "Discard changes",
      TODAY: "Today",
      MORE: "more",
      DISCARD: "Discard",
      SAVE: "Save",
      SCHEDULE_SETTINGS: "Schedule Settings",
      NO_BLOCKS_SCHEDULED: "No blocks scheduled",
      FAILED_TO_LOAD: "Failed to load. Refresh to retry.",
      ADD_TIME_BLOCK: "Add time block",
      FACILITY_SCHEDULE: "Facility Schedule",
      DEFINE_OPERATIONAL_HOURS:
        "Define operational hours. Unmarked time is non-operational.",
      TIME_SCALE: "Time scale",
      TIME_SCALE_MINUTES: "{{minutes, number}} min",
      FACILITY_DATA_NOT_READY: "Facility data not ready. Please try again.",
      GROUP_DATA_NOT_READY: "Group data not ready. Please try again.",
      COMPANY_DATA_NOT_READY: "Company data not ready. Please try again.",
      TIMEZONE_UPDATED: "Timezone updated.",
      FAILED_TO_UPDATE_TIMEZONE: "Failed to update timezone.",
      TIME_ZONE: "Time zone",
      SELECT_TIME_ZONE: "Select time zone",
      SCHEDULE_TYPE: "Schedule type",
      SELECT_FACILITY: "Select facility",
      STATES_LEGEND: "States / Legend",
      OPERATIONAL: "Operational",
      WEEKLY_RECURRING: "Weekly recurring",
      SCHEDULE_FOR: "Schedule for",
      SCHEDULE: "Schedule",
      TIME_BLOCKS: "Time blocks",
      NON_OPERATIONAL_UNMARKED: "Non-operational (unmarked)",
      SCHEDULE_SAVED: "Schedule saved.",
      FAILED_TO_SAVE_SCHEDULE: "Failed to save schedule.",
      SLOT_POPOVER: {
        ADD_TITLE: "Add time block",
        START_TIME: "Start time",
        END_TIME: "End time",
        SELECT_END_TIME: "Select end time",
        APPLY_TO_DAYS: "Apply to days",
        CANCEL_BUTTON: "Cancel",
        APPLY_BUTTON: "Apply",
        DELETE_BUTTON: "Delete",
        EDIT_TITLE: "Edit time block",
      },
    },
    CIMENTOS: {
      KEPWARE_SIMULATION: "Kepware Simulation",
      KEPWARE_STATUS: "Kepware Status",
      LOADING_COMPLETE: "Loading Complete",
      LOADING_IS_COMPLETE: "Complete",
      LOADING_NOT_COMPLETE: "Not Complete",
      LOADING_START_FAILED: "Loading Not Started",
      LOADING_STARTED: "Loading Started",
      LOADING_STOP_FAILED: "Loading Not Stopped",
      LOADING_STOPPED: "Loading Stopped",
      LOADING_UNKNOWN: "Unknown",
      MANUAL_LOADING_CONTROL: "Manual Loading Control",
      MANUAL_LOADING_CONTROL_DESCRIPTION:
        "Manually drive a lane's loading sequence against the live PLC.",
      NO_SILOS_AVAILABLE: "No silos available for this lane",
      PHASE_IDLE: "Idle",
      PHASE_LOADING: "Loading In Progress",
      PHASE_POSITIONING: "Positioning Spout…",
      PHASE_STARTING: "Starting Loading…",
      PHASE_STOPPING: "Stopping…",
      POSITION_SPOUT: "Position Spout",
      SCALE_SECONDS: "Seconds",
      SCALE_SECONDS_STABLE: "Seconds stable",
      SCALE_VARIANCE: "Variance",
      SCALE_WEIGHT: "Weight",
      SELECT_LANE: "Lane",
      SELECT_SILO: "Silo",
      SILO_NOT_UPDATED: "Silo Not Updated",
      SPOUT_NOT_READY: "Not Ready",
      SPOUT_POSITIONED: "Spout Positioned",
      SPOUT_POSITION_FAILED: "Spout Not Positioned",
      SPOUT_READY: "Ready",
      SPOUT_STATUS: "Spout Status",
      START_LOADING: "Start Loading",
      STOP_LOADING_AND_REMOVE_SPOUT: "Stop Loading & Remove Spout",
      TARGET_WEIGHT: "Target Weight (tonnes)",
      UPDATE_WEIGHT: "Update Weight",
      WEIGHT_NOT_UPDATED: "Weight Not Updated",
      WEIGHT_UPDATED: "Weight Updated",
    },
    CTPAT: {
      BACK: "Back",
      CONTINUE: "Continue",
      NEXT: "Next",
      COMPLIANT: "Compliant",
      NON_COMPLIANT: "Non-Compliant",
      INSPECTION_TYPE: {
        SevenPoint: "7-Point Inspection",
        SeventeenPoint: "17-Point Inspection",
      },

      FAILED_TO_LOAD_LANE_EVENT: "Failed to load lane event",
      LANE_EVENT_DETAILS_LOADING: "Loading lane event details",
      INSPECTION_OVERVIEW: {
        TITLE: "Inspection Overview",
        DESC: "Review the asset information before starting the inspection.",
        HEADING: "Equipment",
        BACK_TO_GATE_LOG: "Back to Gate Log",
        START_INSPECTION: "Start Inspection",
        CONTINUE_INSPECTION: "Continue Inspection",
        POWER_UNIT: "Truck",
        TRAILER: "Trailer",
        CHASSIS: "Chassis",
        ISO_CODE: "ISO Code",
        NO_EQUIPMENT: "No equipment recorded for this event",
      },
      INSPECTION_CHECKLIST: {
        TITLE: "Inspection Checklist",
        DESC: "Review each security requirement and select a status.",
        NEXT_DESC: "Review security and procedural requirements",
        HEADING: "Security Requirements",
        ERROR_TITLE: "Inspection checklist is incomplete",
        ERROR_DESC: "{{missing}} selections missing.",
        ERROR_ACTION: "Complete selections",
        CONVEYANCES_AND_INSTRUMENTS:
          "Conveyances and Instruments of International Traffic (IIT) must be stored in a secure area to prevent unauthorized access or changes that could compromise the structure, seals, or doors.",
        INCLUDES_PROCEDURES:
          "The CTPAT inspection process must include written procedures for both security and agricultural inspections.",
        PEST_CONTAMINATION:
          "If visible pest contamination is found during an IIT inspection, the conveyance must be washed or vacuumed to remove the contamination. Documentation must be retained for one year.",
        SELECT_A_STATUS: "Select a status for this requirement",
        MISSING_SELECTIONS: "Select a status for every requirement",
        RANDOM_SEARCHES:
          "Based on risk, management personnel should conduct random searches after transportation staff have completed IIT inspections.",
      },
      EQUIPMENT_INSPECTION: {
        TITLE: "Equipment Inspection",
        NEXT_DESC: "Review the vehicle and inspection points",
        UNIT_POSITION: "Unit {{current}} of {{total}}",
        ADD_UNIT: "Add unit",
        ADD_UNIT_FAILED: "Couldn't add a unit. Try again.",
        PHOTOGRAPHED: "Photographed",
        NOT_PHOTOGRAPHED: "Not photographed yet",
        INCOMPLETE_TITLE: "Container inspection is incomplete",
        INCOMPLETE_BODY_one:
          "{{count}} inspection point still needs review. Complete it before continuing.",
        INCOMPLETE_BODY_other:
          "{{count}} inspection points still need review. Complete them before continuing.",
        REVIEW_CONTAINER: "Review Container",
      },
      CHECKPOINT_DETAIL: {
        PHOTO: "Photo",
        COMPLIANCE: "Compliance",
        MARK_STATUS: "Mark Status",
        NOTES: "Notes",
        NOTES_PLACEHOLDER: "Add note about this area",
        PHOTO_REQUIRED_TITLE: "A photo is needed first",
        PHOTO_REQUIRED_BODY:
          "Compliance and notes are recorded against the photo, so take or upload one before continuing.",
        UPLOAD_FAILED_TITLE: "Couldn't save the photo",
        UPLOAD_FAILED_BODY:
          "The photo is still here. Check the connection and send it again.",
        SAVE_FAILED_TITLE: "Couldn't save this checkpoint",
        SAVE_FAILED_BODY:
          "The compliance status and note weren't saved. Check the connection and try again.",
        TRY_AGAIN: "Try again",
        NO_PHOTO_YET: "No Photo Yet",
        TAKE_OR_UPLOAD: "Take a photo or upload one to view here",
        PHOTOS: "Photos",
      },
      AUTOMATED_VERIFICATION: {
        TITLE: "Automated Verification",
        DESC: "Review the security requirements verified automatically by the system.",
        NEXT_DESC: "Review system-verified security requirements",
        HEADING: "Security Categories",
        VERIFIED: "Verified",
        REQUIREMENT_COUNT_one: "{{count}} requirement",
        REQUIREMENT_COUNT_other: "{{count}} requirements",
        CATEGORY: {
          PHYSICAL_SECURITY: {
            TITLE: "Physical Security",
            REQUIREMENT: {
              STAGED_CARGO:
                "When cargo is staged overnight or for an extended period, measures must be taken to secure it from unauthorized access.",
            },
          },
          SECURITY: {
            TITLE: "Security",
            REQUIREMENT: {
              LOCKING_HARDWARE:
                "Conveyances and Instruments of International Traffic (as appropriate) must be equipped with external hardware that can reasonably withstand attempts to remove it. The door, handles, rods, hasps, rivets, brackets, and all other parts of a container’s locking mechanism must be fully inspected to detect tampering and any hardware inconsistencies prior to the attachment of any sealing device.",
              INSPECTION_CHECKLIST:
                "The inspection of all conveyances and empty Instruments of International Traffic should be recorded on a checklist. The following elements should be documented on the checklist: Container/Trailer/Instruments of International Traffic number; date of inspection; time of inspection; name of employee conducting the inspection; and specific areas of the Instruments of International Traffic that were inspected.",
              TRACKING_LOG:
                "A tracking and monitoring activity log or equivalent technology, such as GPS, must be used to track the conveyance while it is en route to the United States. If driver logs are used, the driver must record any stops and note that inspections of the conveyance, Instruments of International Traffic (IIT), and the seal were conducted.",
              TRANSPORTATION_PROVIDERS:
                "CTPAT Members should work with their transportation providers to track conveyances from origin to final destination point. Specific requirements for tracking, reporting, and sharing of data should be incorporated within terms of service agreements with service providers.",
              NO_STOP_POLICY:
                "For land border shipments that are in proximity to the United States border, a “no-stop” policy should be implemented with regard to unscheduled stops.",
              GPS_COUPLING:
                "If a GPS tracking system is used, carriers should use a sensor coupling/connector or equivalent technology from the tractor to the trailer to ensure the trailer is also monitored and tracked.",
              DISPATCH_LOGS:
                "Carriers should use electronic dispatch logs; the logs should be recorded and kept for audit purposes. Captured through integration of EAIGLE gate and telematics and visibility platforms, i.e. P44, FourKites.",
              TRANSIT_ROUTES:
                "For cross-border shipments, pre-designated transit routes must be established, which include anticipated transit times between waypoints. Once the time between the assigned points has been determined, for both peak and non-peak times, these times must be recorded and incorporated into the tracking process.",
              ROUTE_DEVIATIONS:
                "Carriers must have systems or written procedures in place to respond to significant route deviations and late arrivals to the loading dock/area, transfer points, or the final destination. Drivers must notify the dispatcher of any significant route delays due to weather, traffic, and/or rerouting. Dispatch must independently verify the cause of the delay.",
              LAST_CHANCE_VERIFICATION:
                "In areas of high risk, and immediately prior to arrival at the border crossing, CTPAT Members should incorporate a “last chance” verification process for U.S.-bound shipments for checking conveyances/Instruments of International Traffic for signs of tampering, including visual inspections of conveyances and the VVTT seal verification process. Properly trained individuals should conduct the inspections.\nV – View: View seal and container locking mechanisms; ensure they are OK.\nV – Verify: Verify seal number against shipment documents for accuracy.\nT – Tug: Tug on seal to make sure it is affixed properly.\nT – Twist: Twist and turn the bolt seal to make sure its components do not unscrew, separate from one another, or any part of the seal becomes loose.",
              POST_INSPECTION_ANOMALIES:
                "Drivers must report and record any anomalies or unusual structural modifications found on the conveyance following a Government inspection. Captured through integration of EAIGLE gate and telematics and visibility platforms, i.e. P44, FourKites.",
              RANDOM_REVIEWS:
                "Management must regularly conduct random reviews of the tracking and monitoring procedures. The review findings must be recorded. The review must cover verification of the tracking log against time-indicative documents and internal systems; unaccounted transit time lapses must also be included. Management should conduct periodic random verifications en route.",
              DELAY_NOTIFICATION:
                "CTPAT highway carriers should notify appropriate parties (e.g., shipper, consignee, and importer) of any significant delays, including mechanical failures during transit.",
              THREAT_ALERT:
                "If a credible or detected threat to the security of a shipment or conveyance is discovered, the Member must alert, as soon as feasibly possible, any business partners in the supply chain that may be affected and any law enforcement agencies, as appropriate",
            },
          },
        },
      },
      SEAL_SECURITY: {
        TITLE: "Seal Security",
        DESC: "Enter the seal number and add photo evidence.",
        NEXT_DESC: "Add seal and photo evidence",
        SUBMIT_INSPECTION: "Submit Inspection",
        SUBMIT_DESC: "Review and submit the inspection",
        UNIT: "Unit {{sequence}}",
        SEAL_NUMBER: "Seal number",
        SEAL_NUMBER_PLACEHOLDER: "Placeholder",
        PHOTO_EVIDENCE: "Photo Evidence",
        NO_PHOTO_YET: "No photo yet",
        TAKE_OR_UPLOAD: "Take a photo or upload one to view here",
        ADD_UNIT: "Add Unit",
        ADD_UNIT_CONFIRM_TITLE: "Add another unit?",
        ADD_UNIT_CONFIRM_BODY:
          "A new unit has to be photographed and sealed before the inspection can be submitted, and it cannot be removed.",
        ADD_UNIT_FAILED_TITLE: "Couldn't add a unit",
        ADD_UNIT_FAILED_BODY: "Check the connection and try again.",
        SEAL_SAVE_FAILED_TITLE: "Couldn't save the seal",
        SEAL_SAVE_FAILED_BODY:
          "The seal number and photo weren't saved. Check the connection and try again.",
        SUBMIT_FAILED_TITLE: "Couldn't submit the inspection",
        SUBMIT_FAILED_BODY:
          "The gate has not been opened. Check the connection and try again.",
        INCOMPLETE_TITLE: "Inspection is incomplete",
        SUBMITTED: "Inspection Submitted",
        SUBMITTED_DESC: "You can return to the gate log",
        RETURN_TO_GATE_LOG: "Return to Gate Log",
        BLOCKED_SEAL_one: "Unit {{units}} still needs a seal number and photo.",
        BLOCKED_SEAL_other: "Units {{units}} still need a seal number and photo.",
        BLOCKED_CHECKPOINTS_one: "Unit {{units}} still needs its inspection points.",
        BLOCKED_CHECKPOINTS_other: "Units {{units}} still need their inspection points.",
      },
      ALERT: {
        TRY_AGAIN: "Try again",
        GOT_IT: "Got it",
      },
      PHOTO: {
        EXPAND_PHOTO: "Expand photo",
        CAPTURE: "Capture",
        REPLACE: "Replace",
        UPLOAD: "Upload",
        TAKE_PHOTO: "Take photo",
        SWITCH_CAMERA: "Switch camera",
        USE_DEVICE_CAMERA: "Use device camera",
        REPLACE_CONFIRM_TITLE: "Replace photo?",
        REPLACE_CONFIRM_BODY: "The current photo will be replaced by the new one.",
      },
    },
    DETAILS: {
      ATTACHMENTS: {
        TITLE: "Appointment Attachments",
        DOWNLOAD: "Download",
        SHOW_SYSTEM: "Show system attachments",
        PREVIEW_UNAVAILABLE: "Preview unavailable. Use download instead.",
        UPLOADER: {
          DRIVER: "Driver",
          AGENT: "Agent",
          SYSTEM: "System",
        },
        KIND: {
          SEAL: "Seal",
          BOL: "BOL",
          QRCODE: "QR Code",
        },
      },
      ACTUAL_TEMPERATURE: "Actual Temperature",
      ACTUAL_TEMPERATURE_NOSE: "Actual Temperature Nose",
      ACTUAL_TEMPERATURE_MIDDLE: "Middle",
      ACTUAL_TEMPERATURE_TAIL: "Tail",
      ADDITIONAL_COMMENTS: "Additional Comments",
      ALLOCATED_PAD_YARD_LOCATION_DOOR: "Allocated PAD / Yard Location / Door",
      APPOINTMENT_AND_DRIVER_INFORMATION: "Appointment and Driver Information",
      APPOINTMENT_INFORMATION: "Appointment Information",
      APPOINTMENT_NUMBER: "Appointment Number",
      APPOINTMENT_NUMBER_PO_OR_LOAD_ID: "Appointment #/ PO #/ Load ID",
      APPOINTMENT_TIME: "Appointment Time",
      APPOINTMENT_TYPE: "Appointment Type",
      ASSET: "Asset",
      ASSET_ID: "Asset Id",
      ASSET_LICENSE_PLATE: "Asset License Plate",
      ASSET_TYPE: "Asset Type",
      ASSIGNED_LOCATION: "Assigned Location",
      AVAC_EVENT: "AVAC Event",
      BOL_NUMBER: "BOL Number",
      BOOKING_NUMBER: "Booking Number",
      BRE_STATUS: "BRE Status",
      BROKER: "Broker",
      CARRIER: "Carrier",
      CARRIER_NAME: "Carrier Name",
      CARRIER_REVIEW: "Carrier Review",
      CARRIER_RELIABILITY_SCORE: "Reliability Score",
      CARRIER_REVIEW_UPDATED_AT: "Last Updated",
      CARRIER_REVIEW_DETAILS: "View FMCSA Details",
      CATEGORY: "Category",
      CHASSIS_NUMBER: "Chassis Number",
      CHILD_SCAC: "Child SCAC",
      COMMENT: "Comment",
      COMMENTS: "Comments",
      COMMODITY: "Commodity",
      COMPANY: "Company",
      CONTACT: "Contact",
      COUNT: "Count",
      CREATED_BY: "Created By",
      CV_DETAILS: "CV Details",
      CV_EVENT_ID: "CV Event ID",
      CV_EVENT_N: "CV Event {{N}}",
      CVIP_DATE: "CVIP Date",
      DELIVERY_NOTE: "Delivery Note",
      DESCRIPTION: "Description",
      DESTINATION: "Destination",
      DESTINATION_ADDRESS: "Destination Address",
      DOOR_NUMBER: "Door Number",
      DAMAGE_IMAGES: "Damage Images",
      DRIVER_ENGAGEMENT_TIME: "Driver Engagement Time (Sec)",
      DRIVER_INFORMATION: "Driver Information",
      DRIVER_NAME: "Driver Name",
      DRIVER_SEAL_NUMBER: "Driver Seal Number",
      DRIVER_TRACTOR_NUMBER: "Driver Tractor Number",
      DRIVER_TRAILER_NUMBER: "Driver Trailer Number",
      DUNNAGE: "Dunnage",
      DWELL_TIMES: "Dwell Times",
      EXPAND_IMAGE: "Expand image",
      EBOL_ID: "EBOL ID",
      EBOL_STATUS: "EBOL Status",
      ENTRY_MODE: "Entry Mode",
      ENTRY_SUBTYPE: "Entry SubType",
      ENTRY_TYPE: "Entry Type",
      EQUIPMENT_LENGTH: "Equipment Length",
      EQUIPMENT_LOADED_STATUS: "Equipment Loaded Status",
      EQUIPMENT_TYPE: "Equipment Type",
      EQUIPMENT_TYPE_ID: "Equipment Type ID",
      EVENT_ID: "Event ID",
      EVENT_INFORMATION: "Event Information",
      EVENT_TIME: "Event Time",
      EVENT_TYPE: "Event Type",
      FAILURE_REASON: "Failure Reason",
      STANDARD_ERROR_DESCRIPTION: "Standard Error Description",
      FIRST_NAME: "First Name",
      FUEL_LEVEL: "Fuel Level",
      GATE_CHECKIN_TIME: "Gate Check-in Time",
      GATE_ENGAGEMENT_TIME: "Gate Engagement Time (Sec)",
      HAS_DAMAGE: "Has Damage",
      ID: "ID",
      ID_EXPIRY: "ID Expiry date",
      IMAGES: "Images",
      LANE_ID: "Lane ID",
      LANE_NAME: "Lane Name",
      LAST_NAME: "Last Name",
      LICENSE_PLATE: "License Plate",
      LIVE_DROP: "Live/Drop",
      LOAD_CARRIER: "Load Carrier",
      LOAD_ID: "Load ID",
      LOAD_INFORMATION: "Load Information",
      LOAD_TYPE: "Load Type",
      LOADED_WEIGHT: "Loaded Weight",
      LTL: "LTL",
      MC_NUMBER: "MC Number",
      MSC_NUMBER: "MSC Number",
      OCR_TRAILER: "OCR Trailer",
      OCR_TRUCK_INFORMATION: "OCR Truck Information",
      OTP_CODE: "OTP Code",
      OPERATOR: "Operator",
      OPERATOR_COMMENT: "Operator Comment",
      OPERATOR_COMMENTS: "Operator Comments",
      ORDER_NUMBER: "Order Number",
      PARENT_SCAC: "Parent SCAC",
      PHONE_NUMBER: "Phone Number",
      PICKUP_TRAILER_NUMBER: "Pickup Trailer Number",
      SECOND_PICKUP_TRAILER_NUMBER: "Second Pickup Trailer Number",
      SPECIFICATIONS: "Specifications",
      PLATE_NUMBER: "Plate Number",
      PO: "PO",
      POINT_OF_CONTACT: "Point of Contact",
      PO_LOAD_DETAILS: "PO / Load Details",
      PO_LOAD_DETAILS_AND_ASSIGNED_LOCATIONS: "PO / Load Details and Assigned Locations",
      PO_NUMBER: "PO Number",
      PRODUCT: "Product",
      PRODUCT_TEMPERATURE: "Product Temperature (°C)",
      RAIL_CARS: "Rail Cars",
      REFERENCE: "Reference",
      REFERENCE_NUMBER: "Reference Number",
      REQUESTED_PRODUCT_WEIGHT: "Requested Product Weight (Tons)",
      ROW: "Row",
      REQUESTED_GROSS_WEIGHT: "Requested Gross Weight (Tons)",
      TARE_WEIGHT: "Tare Weight",
      CAR_MOVE_FO_TU_NUMBER: "Car Move / FO / TU #",
      CAR_MOVE_VALIDITY: "Car Move Validity",
      CAR_MOVE_VALID: "Valid",
      CAR_MOVE_INVALID: "Invalid",
      APPOINTMENT_DATA: "Appointment Data",
      APPOINTMENT_TRAILER_NUMBER: "Appointment Trailer Number",
      ORIGIN: "Origin",
      RESULT: "Result",
      SCAC: "SCAC",
      QR_SOURCE: "QR Source",
      YMS_INFORMATION: "YMS Information",
      YMS_APPOINTMENT_NUMBER: "YMS Appointment Number",
      YMS_TRAILER_NUMBER: "YMS Trailer Number",
      YMS_ZONE: "YMS Zone",
      YMS_SPOT: "YMS Spot",
      YMS_CHECKIN_ZONE: "YMS Check-in Zone",
      YMS_CHECKIN_SPOT: "YMS Check-in Spot",
      YMS_CHECKIN_MESSAGE: "YMS Check-in Message",
      ERROR_INFORMATION: "Error Information",
      ERROR_REASON: "Error Reason",
      ERROR_RESPONSE: "Error Response",
      TRAILER_VALIDATION: "Trailer Validation",
      BOBTAIL_VALIDATION: "Bobtail Validation",
      CV_DETECTION: "Detected Vehicle Type",
      SEAL_NUMBER: "Seal Number",
      NO_IMAGE_AVAILABLE: "No image available",
      NEW: "New",
      SEAL_STATUS: "Seal Status",
      SET_TEMPERATURE: "Set Temperature",
      SET_TEMPERATURE_NOSE: "Set Temperature Nose",
      SET_TEMPERATURE_MIDDLE: "Middle",
      SET_TEMPERATURE_TAIL: "Tail",
      SHIPMENT_DETAILS: "Shipment Details",
      SHIPMENT_TYPE: "Shipment Type",
      SPOT: "Spot",
      SPOT_MEDIA: "Spot Media",
      SPOT_NUMBER: "Spot Number",
      SUB_TAG: "Sub-tag",
      START_TIME: "Start Time",
      STATUS: "Status",
      TAG: "Tag",
      TAMPER_STATUS: "Seal status",
      TEMPERATURE: "Temperature",
      TEMPERATURE_AND_FUEL_LEVELS: "Temperature and Fuel Levels",
      TIMESTAMP: "Timestamp",
      TIMESTAMPS: "Timestamps",
      TIME_OF_ENTRY: "Time of Entry",
      TRACTOR_ID: "Tractor ID",
      TRACTOR_NUMBER: "Tractor Number",
      TRAILER: "Trailer",
      TRAILER_INFORMATION: "Trailer Information",
      TRAILER_NUMBER: "Trailer Number",
      TRAILER_NUMBER1: "Trailer Number 1",
      TRAILER_NUMBER2: "Trailer Number 2",
      TRAILER_TYPE: "Trailer Type",
      TRAILER_TYPE1: "First Trailer Type",
      TRAILER_TYPE2: "Second Trailer Type",
      TRUCK_INFORMATION: "Truck Information",
      TRUCK_NUMBER: "Truck Number",
      TYPE: "Type",
      UNIT: "Unit",
      UNIT_1: "Unit 1",
      UNIT_2: "Unit 2",
      UNIT_ID: "Unit ID",
      UNIT_NUMBER: "Unit Number",
      UNIT_TYPE: "Unit Type",
      USDOT_NUMBER: "USDOT Number",
      VEHICLE: "Vehicle",
      VEHICLE_MEDIA: "Vehicle Media",
      CTPAT_MEDIA: "CTPAT",
      CTPAT_NOTE: "Note",
      VEHICLE_TYPE: "Vehicle Type",
      VIDEOS: "Videos",
      WAC: "WAC",
      WEIGHT: "Weight",
      YMS_INITIATION_STATUS: "YMS Initiation Status",
      YMS_CV_TRAILER: "YMS (CV) Trailer",
      YMS_STATUS: "YMS Status",
      YMS_TRAILER: "YMS Trailer",
      ZONE: "Zone",
    },
    ERROR: {
      ACCESS_DENIED: "Access Denied",
      ACCESS_DENIED_DETAILS: "You do not have access to this module.",
      AUTH_ERROR: "Authentication Error: {{ERROR}}",
      COMPANY_NOT_FOUND: "Company info wasn't loaded properly",
      CONTACT_ADMIN: "Please contact your administrator for permission.",
      ERROR_CREATING_DRIVER: "An error occurred while creating the driver",
      LOADING_EVENT_DETAILS_AVAC: "Error loading event details. Redirecting to AVAC...",
      LOADING_EVENT_DETAILS_GATE_LOG:
        "Error loading event details. Redirecting to Gate Log...",
      ERROR_UPDATING_DRIVER: "An error occurred while updating the driver",
      ERROR_UPDATING_COMPANY: "An error occurred while updating the company",
      ERROR_UPDATING_ESCALATION: "An error occurred while updating the escalation",
      ERROR_UPDATING_FACILITY: "An error occurred while updating the facility",
      FAILED_TO_CREATE_DRIVER: "Failed to create driver",
      FAILED_TO_FETCH_CARRIERS: "Failed to fetch carriers",
      FAILED_TO_FETCH_DRIVER_FORM_FIELDS: "Failed to fetch driver form fields",
      FAILED_TO_FETCH_APPOINTMENT_LIST_COLUMNS:
        "Failed to fetch appointment list columns",
      FAILED_TO_FETCH_DRIVER_MAPPINGS: "Failed to fetch driver mappings",
      FAILED_TO_FETCH_DRIVER_TYPES: "Failed to fetch driver types",
      FAILED_TO_FETCH_FACILITIES: "Failed to fetch facilities",
      FAILED_TO_FETCH_FACILITY_PARAMETERS: "Failed to fetch facility parameters",
      FAILED_TO_FETCH_GATES: "Failed to fetch gates",
      FAILED_TO_FETCH_GATE_LOG_COLUMNS: "Failed to fetch gate log columns",
      FAILED_TO_FETCH_GATE_LOG_DETAILS: "Failed to fetch gate log details",
      FAILED_TO_FETCH_LANES: "Failed to fetch lanes",
      FAILED_TO_FETCH_TRAILER_GROUPS: "Failed to fetch trailer groups",
      FAILED_TO_FETCH_TRAILER_LISTS: "Failed to fetch trailer lists",
      FAILED_TO_UPDATE_DRIVER: "Failed to update driver",
      MISSING_EMAIL_AND_PHONE_NUMBER:
        "Please provide either an email address or phone number",
      NO_COMPANY_SELECTED: "No company selected",
      NO_DRIVERS_FOR_FACILITY: "No drivers for this facility.",
      NO_FACILITY_SELECTED: "No facility selected",
      NO_LANES_AVAILABLE: "No lanes available",
      TRAILER_NOT_CHECKED_IN: "Trailer not checked in: {{MESSAGE}}",
      WEBSOCKET_ERROR: "WebSocket error: {{ERROR}}",
    },
    TAG_SELECTOR: {
      TAG_LABEL: "Tag:",
      SUBTAG_LABEL: "Sub-tag:",
      ADD_TAG: "Add Tag",
      UPDATE_TAG: "Update Tag",
      SELECT_TAG_PLACEHOLDER: "Select tag…",
      NO_SUBTAG_PLACEHOLDER: "No sub-tag",
      SEARCH_PLACEHOLDER: "Search tags…",
      REMOVE_SUBTAG: "Remove sub-tag",
      REMOVING_SUBTAG: "Removing sub-tag…",
      REMOVE_TAG: "Remove tag",
      REMOVING_TAG: "Removing tag…",
      ASSIGN: "Assign",
      ASSIGNING: "Assigning…",
    },
    TAGS_SECTION: {
      NO_TAGS_YET: "No tags yet.",
      SUBTAG_COUNT_one: "{{count}} sub-tag",
      SUBTAG_COUNT_other: "{{count}} subtags",
      ERROR_MESSAGE: "Oops something went wrong, check your tag and try once more.",
      SUBTAG_NAME_PLACEHOLDER: "Sub-tag name",
      ADD: "Add",
      CANCEL: "Cancel",
      ADD_SUBTAG: "Add sub-tag",
      NEW_TAG_NAME_PLACEHOLDER: "New tag name",
      ADD_TAG: "Add tag",
    },
    MODULE: {
      ANALYTICS: "Analytics",
      AVAC: "AVAC",
      ASSETS: "Assets",
      ASSETLOG: "Asset Log",
      C3YMS: "C3 YMS",
      DRIVERS: "Drivers",
      EBOL: "EBOL",
      EDITGATELOG: "Edit Gate Log",
      INVENTORY: "Yard Inventory",
      EDITINVENTORY: "Edit Yard Inventory",
      REGISTRATION: "Registration",
      SEASONALITY: "Seasonality",
      SIMULATION: "Simulation",
      CARRIERMANAGEMENT: "Carrier Management",
      CARRIERASSETMAP: "Carrier Asset Map",
      FACILITYSCHEDULE: "Facility Schedule",
    },
    NEW_DRIVER: {
      PIN_SENT: "The PIN has been sent to the driver's email and phone number.",
      QR_CODE_SENT: "The QR code has been sent to the driver's email and phone number.",
      QR_CODE_AND_PIN_SENT:
        "The QR code and PIN have been sent to the driver's email and phone number.",
    },
    SETTINGS: {
      ADDRESS: "Address Line 1",
      ADDRESS_2: "Address Line 2",
      ADD_COLUMN: "Add Column",
      ADD_CUSTOM_EXPRESSION: "Add Custom Expression",
      ADD_DETAIL: "Add Detail",
      ADD_DRIVER_FORM_FIELD: "Add Driver Form Field",
      ADD_DRIVER_MAPPING: "Add Driver Mapping",
      ADD_DRIVER_TYPE: "Add Driver Type",
      ADD_REPLACEMENT: "Add Replacement",
      ADD_TRAILER_GROUP: "Add Trailer Group",
      ADD_TRAILER: "Add Trailer",
      AGENT_PARAMETERS: "Agent parameters",
      AGENT_PARAMETERS_DESC:
        "Configuration for the agent dashboard: gate log columns and trailer types.",
      AUTOMATED_ENTRY: "Automated Entry",
      AVAC_PARAMETERS: "AVAC Parameters",
      AVAC_PARAMETERS_DESC:
        "Core details like supported languages, logo image, etc. for the AVAC module.",
      AVAILABLE: "Available",
      ASSIGNED_ASSETS: "Assigned {{ASSET}} Assets",
      AVAILABLE_ASSETS: "Available {{ASSET}} Assets",
      ASSET: "Asset",
      ASSET_DETAILS: "Asset Details",
      ASSET_ID: "Asset Id",
      ASSET_TYPE: "Asset Type",
      ASSET_MAP: {
        ADD_SUCCESS: "Asset added to carrier.",
        ADD_FAILED: "Failed to add asset to carrier.",
        REMOVE_SUCCESS: "Asset removed from carrier.",
        REMOVE_FAILED: "Failed to remove asset from carrier.",
        ADD_ARIA: "Add {{ASSET}}",
        REMOVE_ARIA: "Remove {{ASSET}}",
        EMPTY_TITLE: "No assets found",
        EMPTY_SEARCH_SUBTITLE: "Try a different asset ID or clear the search.",
        ASSIGNED_PAGINATION: "Assigned {ASSET} pagination",
        AVAILABLE_PAGINATION: "Available {ASSET} pagination",
      },
      BACKUP: "Backup",
      CHASSIS_NUMBER: "Chassis Number",
      CARRIERMANAGEMENT: "Carrier Management",
      CARRIERASSETMAP: "Carrier Asset Map",
      COLUMN_NAME: "Column Name",
      DISPLAY_NAME: "Display Name",
      COMPANY: "Company",
      GATE_LOG_COLUMNS: "Gate log columns",
      GATE_LOG_COLUMNS_DESC:
        "Choose which fields show up as columns on the agent dashboard's gate log table.",
      GATE_LOG_TABS: "Gate log tabs",
      GATE_LOG_TABS_DESC:
        "Choose which tabs are shown on the agent dashboard's gate log table.",
      GATE_LOG_DETAILS_FIELDS: "Gate log details fields",
      GATE_LOG_DETAILS_FIELDS_DESC:
        "Choose which fields show within each section above. Fields for a disabled section can't be toggled.",
      TRAILER_TYPES_DESC:
        "Choose which trailer types are offered on the agent dashboard when reviewing a trailer.",
      YARD_SIGHTINGS_TAB: "Yard Sightings Tab",
      YARD_SIGHTINGS_TAB_DESC:
        "Show the Yard Sightings tab next to Gate Log on the agent dashboard. Gate Log is always shown.",
      IMAGE_HIDING: "Image Hiding",
      IMAGE_HIDING_DESC:
        "Let agents hide individual images from the gate log details page on the agent dashboard.",
      IMAGE_HIDING_TOGGLE: "Enable Image Hiding",
      IMAGE_HIDING_TOGGLE_DESC:
        "Hidden images are excluded from what AVAC and the AVAC Dashboard receive, but stay visible (marked hidden) on the agent dashboard so a reviewer can undo an accidental hide.",
      GROUP: "Group",
      COMPANY_IS_AUTOMATED: "Automated Entry enabled for Company",
      TRAILER_TYPES: "Trailer Types",
      COMPANY_NAME: "Company Name",
      COMPANY_NAME_PLACEHOLDER: "Enter company name",
      COMPANY_PARAMETERS: "Company Parameters",
      COMPANY_PARAMETERS_DESC:
        "Configure company-level parameters. These are applied across all facilities unless overridden.",
      CUSTOM_EXPRESSION: "Custom Expression",
      CURRENT_CARRIER: "Current Carrier",
      CV_PARAMETERS: "CV Parameters",
      CV_PARAMETERS_DESC: "Computer vision / CV engine specific configuration.",
      PORT_OF_ENTRY_ENABLED: "Enabled",
      PORT_OF_ENTRY_INBOUND_COUNTRY: "Inbound events enter:",
      PORT_OF_ENTRY_OUTBOUND_COUNTRY: "Outbound events leave for:",
      PORT_OF_ENTRY_COUNTRY_PLACEHOLDER: "Search or select a country",
      PORT_OF_ENTRY_NO_COUNTRY_RESULTS: "No countries match your search.",
      PORT_OF_ENTRY_ENABLE_HINT: "Choose both countries before enabling.",
      APPOINTMENT_LIST_COLUMNS: "Appointment list columns",
      ADD_APPOINTMENT_LIST_COLUMN: "Add appointment list column",
      COLUMN_KEY: "Column key",
      COLUMN_TYPE: "Column type",
      SORT_ORDER: "Sort order",
      FAILED_TO_SAVE_APPOINTMENT_LIST_COLUMNS:
        "Failed to save appointment list columns. Please try again later.",
      DRIVER_FORM_FIELDS: "Driver Form Fields",
      DRIVER_TYPE: "Driver Type",
      DRIVER_TYPES: "Driver Types",
      DRIVER_MAPPINGS: "Driver Mappings",
      EDITABLE: "Editable",
      EMAIL: "Email",
      ESCALATION: "Escalation",
      EVENT_TAGS: "Event tags",
      EVENT_TAGS_DESC: "Configure tags to categorize your events",
      EXPRESSION_HINT:
        'An expression which triggers automated entry when it returns TRUE, similar to BRE expressions.  For example:\npowerUnit.parameters.CarrierName.ToString() == "UPS"',
      FACILITIES: "Facilities",
      FACILITY: "Facility",
      NO_FACILITY_OR_GROUPS_FOUND: "No facilities or groups found.",
      CREATE_GROUP_TO_START_ADDING_FACILITIES:
        "Create a group to start adding/managing facilities.",
      FACILITY_IS_AUTOMATED: "Automated Entry enabled for Facility",
      FACILITY_NAME: "Facility Name",
      FACILITY_PARAMETERS: "Facility Parameters",
      FACILITY_PARAMETERS_DESC:
        "Core details like name, address and timezone for the Facility module.",
      FACILITY_GROUP_DETAILS: "Facility group details",
      FACILITY_GROUP_DETAILS_DESC:
        "View and manage settings for the selected facility group.",
      FACILITY_USES_COMPANY: "Facility uses Company settings",
      INHERITS_FROM: "Inherits from {{scope}}",
      USE_PARENT_VALUE: "Use parent value",
      OVERRIDDEN: "Overridden",
      IS_ASSETS_ENABLED: "Assets enabled",
      SEASONALITY_PARAMETERS: "Seasonality & Temperature",
      SEASONALITY_PARAMETERS_DESC: "Seasonality and temperature specific configuration.",
      SEASONALITY: {
        TITLE: "Seasonality & Temperature",
        TAB_COMMODITY: "Commodity Configuration",
        TAB_EQUIPMENT_TYPES: "Equipment Type Configuration",
        RULES_SECTION_TITLE: "Seasonality Rules",
        ADD_COMMODITY: "Add Commodity",
        ADD_EQUIPMENT_TYPE: "Add Equipment Type",
        ADD_RULE: "Add Rule",
        COMMODITY_IN_USE: "In use - cannot delete",
        CONFIRM_DELETE: "Are you sure you want to delete this item?",
        NO_EQUIPMENT_TYPES_CONFIGURED: "No equipment types configured",
        NO_RULES_CONFIGURED: "No seasonality rules configured",
        NO_COMMODITIES_CONFIGURED: "No commodities configured",
        TEMPERATURE_OUT_OF_RANGE_MIN: "Temperature must be >= {{min}}",
        TEMPERATURE_OUT_OF_RANGE_MAX: "Temperature must be <= {{max}}",
        SELECT_END_DATE: "Select end date to complete the range",
        COLUMNS: {
          ACTIVE: "Active",
          COMMODITY: "Commodity",
          EQUIPMENT_TYPE: "Equipment Type",
          NAME: "Name",
          DESCRIPTION: "Description",
          USED_IN_RULES: "Used in rules",
          EQUIP_CODE: "Equip Code",
          UNIT_TYPE: "Unit Type",
          DOOR_TYPE: "Door Type",
          LENGTH: "Length",
          ORIGIN: "Origin",
          DESTINATION: "Destination",
          SEASON: "Season",
          DATE_RANGE: "Season Date Range",
          SET_TEMP_F: "Set Temp °F",
          MIN_TEMP_F: "Min Temp °F",
          MAX_TEMP_F: "Max Temp °F",
          MODE: "Mode",
          SHOW_IN_OPERATIONAL_VIEWS: "Show in operational views",
        },
      },
      SEASONS: {
        ALL: "All seasons",
        WINTER: "Winter",
        SPRING: "Spring",
        SUMMER: "Summer",
        FALL: "Fall",
      },
      FIELD: {
        CHECKBOX: "Checkbox",
        DATE: "Date",
        DAYS_OF_WEEK: "Days of week",
        EMAIL: "Email Address",
        MULTI_SELECT: "Multi-select",
        SELECT: "Select",
        STRING: "String",
        TEL: "Telephone Number",
        TEXT: "Text",
        TIME_INTERVALS: "Time intervals",
      },
      FILTER_TYPE: "Filter Type",
      GATE_LOG: "Gate Log",
      GATE_LOG_DETAIL: "Gate Log Detail",
      GATE_LOG_COLUMNS_EMPTY:
        "No columns configured - the agent dashboard falls back to its default set.",
      HEADER: "Header",
      GATE_LOG_COLUMN_HEADER_PLACEHOLDER: "Column Header",
      GATE_LOG_COLUMN_ADD_PLACEHOLDER: "Search fields to add as a column",
      GATE_LOG_COLUMN_NO_MORE_FIELDS: "All fields added.",
      KEY: "Key",
      KEYS: "Keys",
      LABEL: "Label (key or text)",
      LAST_UPDATED: "Last Updated",
      LOADING_GROUPS: "Loading facility groups…",
      MAPPING_STATUS: "Mapping Status",
      MODULE: "Module",
      MODULES: "Modules",
      NAME: "Name",
      NO_DEPRECATED_PARAMETERS: "No deprecated parameters to remove",
      ORDER: "Order",
      PARAMETER_ALREADY_EXISTS:
        "This parameter is already present. Edit the existing row instead of adding it again.",
      PARAMETER_KEY_LABEL: "Key",
      PARENT_NAME: "Parent",
      POSITION: "Position",
      REMOVE_CONFIRM:
        "Are you sure you want to remove the deprecated parameters?{{PARAMS}}",
      REPLACEMENT: "Replacement",
      REQUIRED: "Required",
      SEARCH: "Search",
      SPECIFICATIONS: "Specifications",
      SORTABLE: "Sortable",
      TIMEZONE: "Timezone",
      TITLE: "Title",
      TYPE: "Type",
      TRAILER: "Trailer",
      TRAILER_GROUP: "Trailer Group",
      TRAILER_GROUPS: "Trailer Groups",
      TRAILER_LIST: "Trailer List",
      TRAILER_LISTS: "Trailer Lists",
      UNSAVED_CHANGES_CONFIRM:
        "You have unsaved changes. Are you sure you want to switch facilities without saving?",
      USAGE: "Usage",
      VALUES: "Values",
      WEB_UI: "Web UI",
      WEIGHT: "Weight",
      WORKFLOW_ID: "Workflow Id",
      YARD_INVENTORY: "Yard Inventory",
      YARD_ROUTE: "Yard Route",
      YARD_INVENTORY_COLUMN: {
        FIELD: "Field",
        TEXT: "Text",
        SELECT: "Select",
      },
      GROUP_PARAMETERS_INVALID_JSON: "Parameters must be valid JSON.",
      GROUP_SAVE_SUCCESS: "Facility group saved successfully.",
      GROUP_SAVE_FAILED:
        "Couldn't save facility group. Please delete the group and try again.",
      GROUP_DELETE_SUCCESS: "Facility group deleted successfully.",
      GROUP_DELETE_FAILED: "Couldn't delete facility group. Try again.",
      GROUP_ASSIGN_SUCCESS: "Facility assigned to group successfully.",
      GROUP_ASSIGN_FAILED: "Couldn't assign facility to group. Try again.",
      GROUP_UNASSIGN_SUCCESS: "Facility removed from group successfully.",
      GROUP_UNASSIGN_FAILED: "Couldn't remove facility from group. Try again.",
      GROUP_NAME: "Group name",
      GROUP_NAME_PLACEHOLDER: "Enter group name",
      GROUP_NAME_REQUIRED: "Group name is required to save.",
      GROUP_DUPLICATE_NAME: "A group with this name already exists.",
      GROUP_FACILITIES: "Facilities in this group",
      GROUP_ADD_FACILITY_PLACEHOLDER: "Search facilities to add",
      GROUP_NO_AVAILABLE_FACILITIES: "No more facilities available to add.",
      GROUP_NO_FACILITIES: "No facilities are currently assigned to this group.",
      GROUP_REMOVE_FACILITY_TITLE: "Remove facility from group?",
      GROUP_REMOVE_FACILITY_MESSAGE:
        "This will unassign the facility from this group. The facility itself will not be deleted.",
      GROUP_PARAMETERS_ERROR: "Invalid parameters",
      COMPANY_EXPORT_SUCCESS: "Company parameters export generated.",
      COMPANY_SAVE_FAILED: "Couldn't save company. Try again.",
      COMPANY_SAVE_SUCCESS: "Company parameters saved successfully.",
      COMPANY_CANCELLED: "Changes discarded.",
      FACILITY_EXPORT_SUCCESS: "Facility parameters export generated.",
      FACILITY_IMPORT_SUCCESS: "Facility parameters import generated.",
      FACILITY_SAVE_SUCCESS: "Facility parameters saved successfully.",
      TIMEZONE_SEARCH_PLACEHOLDER: "Search or select a timezone",
      NO_TIMEZONE_RESULTS: "No timezones match your search.",
      PARAMETER_ALREADY_EXISTS_TITLE: "Parameter already exists",
      PARAMETER_VALUE_LABEL: "Parameter value",
      PARAMETER_TAG_PLACEHOLDER: "Add…",
      FACILITY_SELECT_PLACEHOLDER:
        "Select a facility group from the left to view its details.",
      ERROR_LOADING_FACILITY_GROUPS: "Error loading facility groups: {{ERROR}}",
      UNSAVED_CHANGES_TITLE: "Unsaved changes",
      FACILITY_UNSAVED_CHANGES_CONFIRM:
        "You have unsaved changes. Are you sure you want to switch facilities without saving?",
      GROUP_DELETE_TITLE: "Delete facility group?",
      GROUP_DELETE_MESSAGE:
        "This will delete the group. Facilities will remain but will no longer be assigned to this group.",
      LANE_CONFIGURATION: "Lane Configuration",
      SEARCH_LANE_PARAMETERS_PLACEHOLDER: "Search lane parameters",
      LANE_LEVEL_SETTINGS: "Lane-level settings",
      LANE_LEVEL_SETTINGS_DESC: "Changes apply only to the selected lane.",
      LANE_NAME: "Lane Name",
      LANE_TYPE: "Lane Type",
      DANGER_ZONE: "Danger Zone",
      REMOVE_LANE: "Remove Lane",
      REMOVE_LANE_TITLE: "Remove lane?",
      REMOVE_LANE_MESSAGE: "Are you sure you want to remove {{name}}?",
      REMOVE_LANE_HELPER: "This action cannot be undone.",
      LANE_SAVE_SUCCESS: "Lane parameters saved successfully.",
      LANE_SAVE_FAILED: "Couldn't save lane. Try again.",
      LANE_REMOVE_SUCCESS: "Lane removed.",
      LANE_REMOVE_FAILED: "Couldn't remove lane. Try again.",
      GATE_CONFIGURATION: "Gate Configuration",
      SEARCH_GATE_PARAMETERS_PLACEHOLDER: "Search gate parameters",
      GATE_LEVEL_SETTINGS: "Gate-level settings",
      GATE_LEVEL_SETTINGS_DESC: "Changes apply only to the selected gate.",
      GATE_NAME: "Gate Name",
      LANES: "Lanes",
      GO_TO_LANE: "Go to lane",
      ADD_LANE: "Add Lane",
      ADD_LANE_DEFAULT_NAME: "New Lane",
      REMOVE_GATE: "Remove Gate",
      REMOVE_GATE_TITLE: "Remove gate?",
      REMOVE_GATE_MESSAGE: "Are you sure you want to remove {{name}}?",
      REMOVE_GATE_HELPER: "This action cannot be undone.",
      GATE_SAVE_SUCCESS: "Gate parameters saved successfully.",
      GATE_SAVE_FAILED: "Couldn't save gate. Try again.",
      GATE_REMOVE_SUCCESS: "Gate removed.",
      GATE_REMOVE_FAILED: "Couldn't remove gate. Try again.",
      COMPANY_CONFIGURATION: "Company Configuration",
      SEARCH_COMPANY_PARAMETERS_PLACEHOLDER: "Search company parameters",
      FACILITY_CONFIGURATION: "Facility Configuration",
      SEARCH_FACILITY_PARAMETERS_PLACEHOLDER: "Search facility parameters",
      GROUP_CONFIGURATION: "Group Configuration",
      SEARCH_GROUP_PARAMETERS_PLACEHOLDER: "Search group parameters",
      LANE_ADD_SUCCESS: "Lane added.",
      LANE_ADD_FAILED: "Couldn't add lane. Try again.",
      GATE_SELECT_PLACEHOLDER: "Select a gate from the left to view its parameters.",
      CARRIER_MANAGEMENT: {
        CARRIERS: "Carriers",
        ADD_CARRIER: "Add carrier",
        ADD_CARRIER_DESCRIPTION:
          "Create a new carrier with SCAC and optional parent SCAC.",
        ADD_CARRIER_OUTCOME: {
          SUCCESS: "Carrier added",
          ERROR: "Failed to add carrier",
        },
        EDIT_CARRIER_OUTCOME: {
          SUCCESS: "{{SCAC}} updated",
          ERROR: "Update failed",
        },
        DELETE_CARRIER_OUTCOME: {
          SUCCESS: "{{SCAC}} removed",
          ERROR: "Removal failed",
        },
        ADD_NEW_CARRIER: "Add new carrier",
        EDIT_CARRIER: "Edit {{carrier}}",
        EDIT_CARRIER_LABEL: "Edit Carrier",
        CARRIER_INFORMATION: "Carrier information",
        CARRIER_PARAMETERS: "Carrier parameters",
        ADD_PARAMETER: "Add parameter",
        EDIT_PARAMETER_TYPES: "Edit parameter types",
        SCAC_LOCKED_HINT: "SCAC can't be changed after a carrier is created",
        PARAM_KEY_PLACEHOLDER: "Enter parameter name",
        PARAM_VALUE_PLACEHOLDER: "Enter value",
        PARAM_NUMBER_PLACEHOLDER: "Enter number",
        DELETE_CARRIER: "Delete Carrier {{carrier}}",
        DELETE_CARRIER_ALERT: {
          TITLE: "Delete Carrier?",
          DESC: "This carrier will be removed. This action cannot be undone.",
        },
        NAME_REQUIRED: "Carrier name is required",
        SCAC_REQUIRED: "Carrier SCAC is required",
        PARAM_VALUE_REQUIRED: "A value is required",
        PARAM_NUMBER_INVALID: "Must be a number",
        PARAM_VALUE_INVALID: "Invalid value",
        CARRIER_NAME_PLACEHOLDER: "Enter carrier name",
        PARAM_KEY_REQUIRED: "Parameter name is required",
        PARAM_DUPLICATE: "Duplicate parameter name",
        PARAMETER_LABELS: {
          NUMBER: "Number",
        },
        CARRIER_SCAC_PLACEHOLDER: "Enter SCAC",
        CARRIER_PARENT_SCAC_PLACEHOLDER: "Enter parent SCAC",
        PARENT_SCAC_OPTIONAL: "Parent SCAC (optional)",
        SELECT_CARRIER: "Select a carrier from the sidebar.",
        DELIVERY_LOCATION_DETAILS: "Delivery location details",
        MAPPED_DELIVERY_LOCATIONS: "Delivery locations",
        AVAILABLE_DELIVERY_LOCATIONS: "Available delivery locations",
        NO_MAPPED_DELIVERY_LOCATIONS: "No mapped delivery locations.",
        NO_AVAILABLE_DELIVERY_LOCATIONS: "No available delivery locations.",
        OPEN_DETAILS: "Open details",
        DETAILS: "Details",
        GENERAL: "General",
        GENERAL_INFO: "General Info",
        PARAMETERS: "Parameters",
        NO_PARAMETERS: "No parameters",
        ADDRESS: "Address",
        BUSINESS_INFO: "Business Info",
      },
      LOCATIONS: {
        ADDRESS: "Address",
        BUSINESS_INFO: "Business Info",
        CREDIT_STATUS: "Credit Status",
        BILL_TO_KEY: "Bill To Key",
        CARRIERS: "Carriers",
        PARAMETERS: "Parameters",
        NO_PARAMETERS: "No parameters",
        ADD_SUCCESS: "Delivery location added to carrier.",
        ADD_FAILED: "Failed to add delivery location to carrier.",
        REMOVE_SUCCESS: "Delivery location removed from carrier.",
        REMOVE_FAILED: "Failed to remove delivery location from carrier.",
      },
      LABELS: {
        FACILITY_PARAMETERS: "Parameters",
        YARD_INVENTORY: "Yard Inventory",
        GATE_LOG: "Gate Log",
        YARD_ROUTE: "Yard Route",
        AUTOMATED_ENTRY: "Automated Entry",
        DRIVER_TYPES: "Driver Types",
        GATE_LOG_COLUMNS: "Gate Log Columns",
        CARRIER_MANAGEMENT: "Carrier Management",
        CARRIER_LOCATION_MAP: "Carrier Location Map",
        CARRIER_ASSET_MAP: "Carrier Asset Map",
        RESTORE: "Restore",
        FACILITY_SCHEDULE: "Facility Schedule",
      },
      TOOLTIPS: {
        ANALYTICS_CACHE_ENABLED:
          "Cache analytics chart results for this facility so repeated dashboard requests reuse a recent computation. TTL and capacity are still controlled by server configuration.",
        APPOINTMENT_EXPIRY: "How long an appointment remains valid.",
        ASSET_LOG_CONFIGURABLE_COLUMNS:
          "Optional asset log list columns shown for this facility. None are shown when nothing is selected.",
        ASSET_LOG_PROCESSABLE_ASSET_KINDS:
          "Asset kinds the asset log tracks for this facility. All kinds are tracked when none are selected.",
        ASSET_LOG_PROCESSABLE_REVIEW_STATUSES:
          "Review statuses whose ended lane events produce asset log records. Defaults to Reviewed when none are selected.",
        PORT_OF_ENTRY_CONFIGURATION:
          "Track when assets cross the border at this facility. Choose both countries before enabling. Inbound/Outbound correspond to Lane types.",
        AUTOMATED_DRIVER_TYPES:
          "Comma-separated driver types that are handled automatically.",
        AUTOMATED_KIOSK_TIMEOUT:
          "Seconds from last heartbeat to consider a kiosk functioning properly.",
        AUTOMATED_LANE_EVENT_STALE:
          "Seconds after which a lane event is considered stale and will not be automated.",
        AUTOMATED_RESUME_MAX_HOURS:
          "Hours after which a paused lane event won't be searched for to find a match at another lane.",
        AUTOMATED_TRIGGER_BRE_DIRECTLY:
          "Trigger the BRE workflow directly, instead of relying on Kiosk.",
        BRE_PAUSE_ON_ERROR: "Pause BRE workflow execution when failure happens",
        BOL_EMAIL_UNSIGNED_ADDRESS: "Email address to send unsigned BOLs to.",
        BOL_EMAIL_UNSIGNED_AGE_MINUTES:
          "Age in minutes before an unsigned BOL is emailed.",
        BOL_SIGNED_EXPORT_INTERVAL_MINUTES:
          "Interval in minutes between BOL signed export runs.",
        CARRIER_SOURCE:
          "Source of the carrier information. Defaults to the AVAC system when left blank.",
        CAMPUS: "Campus parameter for YMS integration.",
        CONTAINER_CHECK_CHASSIS:
          "Check chassis number when determining if this is a container.",
        CTPAT_ENABLED:
          "Require a CTPAT security inspection at gate-in. The gate workflow pauses until a guard completes it.",
        CTPAT_INSPECTION_TYPE:
          "Which checklist of photo checkpoints the inspection uses: SevenPoint or SeventeenPoint. Only SevenPoint has checkpoints configured today.",
        DRIVER_APP_NEEDS_PASSCODE:
          "Require drivers to enter a passcode in the mobile app.",
        EMPLOYEE_PIN_LENGTH: "Employee pin length",
        EMPLOYEE_QR_CODE: "Generate QR codes for employees?",
        EMPLOYEE_PIN: "Generate PINs for employees?",
        ENABLE_DRIVER_ASSIST:
          "Allow guard staff to assist or override kiosk registrations.",
        ENABLE_KIOSK_REGISTRATION: "Enable Kiosk registration",
        FUZZY_MATCH_CROSS_FIELDS:
          "Attempt to match different field types (ie. Power Unit Plate against Chassis Plate).",
        FUZZY_MATCH_THRESHOLD:
          "Percentage threshold that at least one attribute must match by to consider vehicles the same.",
        FAILED_STATUSES:
          "EventStatus values included in the Avac Failed table. When unset, only Failure is shown. Example: Failure, Paused.",
        NON_COMPLIANT_STATUS_ENABLED:
          "Show CV events with no kiosk (AVAC) interaction as non-compliant (amber) in the gate log instead of Success. These are drivers who entered without using the kiosk.",
        NON_COMPLIANT_STATUS_LABEL:
          'Status text shown for non-compliant CV-only events. Defaults to "Non-Compliant" when left blank.',
        HOLIDAYS: "List of company holidays that override normal operating hours.",
        IGNORED_SEASONS:
          "Seasons in which temperature checks and related rules are skipped.",
        IS_AUTOMATED: "Enable fully automated gate entry for this facility.",
        IS_AUDIT_BASED_FACILITY:
          "Enables the Needs Review status and configures this facility as audit-based.",
        IS_EXTERNAL_FACILITY: "This facility represents an external manufacturer.",
        LANGUAGES_SUPPORTED:
          "Language codes supported for driver-facing flows (for example, en-US).",
        LANGUAGE_DEFAULT: "Default language used when no preference is provided.",
        LANGUAGES_SUPPORTED_FOR_AVAC_DASHBOARD:
          "Language codes available in the AVAC dashboard UI.",
        LANGUAGE_DEFAULT_FOR_AVAC_DASHBOARD:
          "Default language for the AVAC dashboard UI.",
        LOADING_TIMEOUT_SECONDS:
          "Number of seconds to wait for loading to complete before aborting",
        LOGO_IMAGE: "Company logo shown in Drivers App and Kiosk.",
        MIN_SILO_LEVEL: "Minimum product level required in the silo to queue a truck.",
        MODULES: "Enabled AVAC modules for this facility or company.",
        NEW_GATE_ENGAGEMENT_TIME_CALCULATION_START_DATE:
          "Date when the new gate engagement time calculation takes effect.",
        NEEDS_KALERIS_ASSIGNMENT: "Enable Kaleris assignment for this facility.",
        BUSINESS_HOURS: "Business hours",
        OPERATING_HOURS_FOR_DAY: "Business hours for {{day}} in local facility time.",
        OTP_CODE_ENABLED: "Turn OTP validation on or off for registrations.",
        OTP_LENGTH: "Number of characters in the generated OTP code.",
        OTP_ALL_NUMBERS: "Use only numeric characters when generating OTP codes.",
        OPERATOR_WAIT_TIMEOUT_SECONDS:
          "Seconds the kiosk shows the wait-for-operator message before returning home while the event stays paused for approval. Default 300.",
        SPOUT_POSITIONING_SIGNAL: "Spout positioning signal",
        TRAFFIC_LIGHT_SIGNAL: "Traffic light signal",
        TEMPERATURE_READ_DELAY_SECONDS:
          "Number of seconds to delay reading the spout temperature after initiating loading",
        TEMPERATURE_MIN: "Minimum spout temperature to be considered valid",
        TEMPERATURE_MAX: "Maximum spout temperature to be considered valid",
        REFERENCE_LABEL: "Custom text shown in Drivers App appointment message.",
        RENTAL_RECIPIENT_EMAIL:
          "Comma-separated email addresses that receive rental notifications.",
        RENTAL_SUBJECT: "Subject line template used for rental notification emails.",
        RENTAL_BODY: "Body text template used for rental notification emails.",
        REPRINT_MAX_HOURS: "Hours after which a BOL can't be reprinted at another lane.",
        REQUIRED_SITE_CODE: "Site code for Kaleris integration.",
        KRAFT_APPOINTMENT_DATE_VALIDATION:
          "Enable validation for Kraft shipment plan appointment dates",
        KRAFT_APPOINTMENT_MAX_DAYS_AHEAD:
          "Maximum number of days the appointment date can be ahead of the facility local date",
        KRAFT_APPOINTMENT_DATE_CHECK_EXCLUDED_SUB_TYPE:
          "Shipment plan sub-type that should skip the Kraft appointment date check",
        ROLES_ASSIGNED: "Comma-separated roles that have access to this configuration.",
        RULE: "Rule JSON filename if not using inline ACP.",
        RESUME_ACP:
          "When enabled, ACPs are resumed instead of started fresh in this lane.",
        LANE_INTERCOM_URL: "URL the intercom button dials on this lane's kiosk.",
        LANE_KIOSK_WAIT_TIME:
          "Seconds the kiosk waits on this lane before timing out back to the start.",
        LANE_SUCCESS_SCREEN_TIMEOUT_SECONDS:
          "Seconds the success screen remains visible on this lane before auto-returning to home. Overrides the facility default when set.",
        LANE_TEST_PRINT_OTP: "Special OTP to test printing.",
        LANE_SILENT_RELOAD_INTERVAL_MINUTES:
          "Minutes between silent reloads of this lane's kiosk tab, applied only when idle on the home screen. Defaults to 60 when unset or 0.",
        LANE_GATE_ARMS: "Lane gate arms",
        LANE_ESCALATION: "Lane escalation",
        SEND_CHASSIS_AS_TRAILER: "Send the chassis number as the trailer number.",
        SETUP_TIMEOUT_SECONDS:
          "Number of seconds to wait for loading to start before aborting",
        TRUCK_CODE:
          'SAP truck/carrier code for the Cimentos BOL signed export (e.g. "3012" for Canada, "3032" for US).',
        USE_V2_KIOSK_FLOW:
          "Enable the v2 single-page kiosk flow where the backend drives every screen transition via PubSub.",
        SUCCESS_SCREEN_TIMEOUT_SECONDS:
          "Seconds the success screen remains visible before auto-returning to home. Defaults to 300 (5 minutes) in the Kiosk v2.",
        SIGNATURE_KIND:
          'Selects which Bill of Lading signing flow the Drivers App renders for this facility. Use "On-Session" for the live ceremony or "Automated" for off-session capture (in-app signature pad).',
        SHOW_CV_EVENTS: "Show computer-vision events in the dashboard.",
        SHOW_INTERNAL_CV_EVENTS:
          "Show internal or system-only CV events in the dashboard.",
        DISABLE_CARRIER_FOR_INTERNAL_EVENTS:
          "Disable the carrier selector in the agent dashboard for internal/in-Zone events, since they have no carrier to assign.",
        YARD_INVENTORY_CHECK_IN:
          "Show the check-in row at the top of the Yard Inventory table.",
        YARD_INVENTORY_FILTER_GROUP:
          "Trailer groups to include when generating yard inventory reports.",
        YARD_INVENTORY_LANGUAGE:
          "Locale code used for yard inventory emails (for example, en-US).",
        YARD_INVENTORY_MINIMUM_AGE:
          "Number of hours a trailer must be in the yard before it is included in the report.",
        YARD_INVENTORY_INCLUDE_CHECKED_IN:
          "Include checked in trailers in inventory email.",
        YARD_INVENTORY_INCLUDE_CHECKED_OUT:
          "Include checked out trailers in inventory email.",
        YARD_INVENTORY_RECIPIENT_EMAIL:
          "Comma-separated list of recipients for yard inventory emails.",
        YARD_INVENTORY_REPORT_FORMAT:
          "File format for yard inventory reports (xls or csv).",
        YARD_INVENTORY_SEND_EMPTY:
          "Send a report even when no trailers match the filters.",
        YARD_INVENTORY_SEND_TIME:
          "Local facility time to send the daily yard inventory report (for example, 01:00).",
        YARD_INVENTORY_SHOW_CHECKED_IN:
          "Show checked-in trailers in the yard inventory web UI.",
        YARD_INVENTORY_SHOW_YARD_MAP: "Show the yard map in the yard inventory web UI.",
        YARD_INVENTORY_SORT_ORDER:
          "Sort keys used when ordering rows in yard inventory reports.",
        YMS_FACILITY_ID: "Facility identifier used by the connected YMS.",
        EBOL_FACILITY_INTERNAL_ID: "Internal ID of the facility in the EBOL System",
        ENABLE_EBOL: "Collect EBOL signatures in the driver's app.",
        EBOL_ALLOW_SIGNING_SKIP_ON_ERROR:
          "Let drivers skip digital signing if it errors. When off, signing is enforced.",
        SMART_LOCKER_ENABLED: "Enable Koloni smart-locker integration for this facility.",
        SMART_LOCKER_HARDWARE_TYPE:
          "Hardware type filter sent to the smart-locker API when listing devices (for example, virtual or kerong).",
        SMART_LOCKER_EXTERNAL_LOCATION_ID:
          "External location ID sent to the smart-locker API as id_location when listing devices.",
        SMART_LOCKER_PROVIDER: "Smart locker provider (for example, Koloni or ParcelOne)",
        REGISTRATION_EXPIRY_LIMIT:
          "Maximum number of days a driver registration stays valid.",
        MAX_LOAD_WEIGHT_TONNES:
          "Maximum net load weight (tonnes) drivers may enter in the driver app for this facility.",
        ONLY_SHOW_DRIVER_ASSIST:
          "When enabled (default), the AVAC Dashboard appointments list only shows appointments created via staff-assisted Registration. Disable to also show self-service appointments created through the kiosk or drivers app.",
        ALLOW_APPOINTMENT_LIST_EDITING:
          "When enabled, form data cells on the AVAC Dashboard registration appointments list can be edited. Built-in fields (OTP, status, created date, created by) stay read-only.",
        ALLOWED_CARRIERS_FOR_REGISTRATION_EXPIRY_DATE:
          "Carriers allowed to register even with an expired date.",
        USE_COMMANDER_FOR_GATE_OPERATIONS:
          "Send gate open/close commands through the Commander integration.",
        ALLOWED_CV_REVIEW_STATUS:
          "CV review statuses required for a lane event to be shown in the gate log.",
        ALLOWED_VEHICLE_TYPES:
          "Vehicle types allowed to be shown in the gate log. Leave empty to show all vehicle types.",
        APPROVE_AND_OPEN_GATE_STATUSES:
          "EventStatus values that show a single Approve & Open Gate button on Details (calls resume) instead of separate Approve and Open Gate. Example: Paused.",
        EVENT_COMMENT_FIELDS:
          "Optional field names shown with Approve & Open Gate (e.g. Spot, Zone). Sent as ExtraFields on gate/operation.",
        ENABLE_GATE_OPEN:
          "Allow operators to trigger physical gate-open commands from AVAC.",
        KALERIS_CHECK_IN_WINDOW_MINUTES:
          "Minutes before appointment time that Kaleris check-in is accepted.",
        KALERIS_CHECK_OUT_WINDOW_MINUTES:
          "Minutes after completion that Kaleris check-out is accepted.",
        IS_GATELOG_LIVE_MODE_ENABLED: "Enable live-mode updates in the Gate Log view.",
        GATE_OPEN_COOLDOWN_SECONDS:
          "Minimum seconds between consecutive gate-open commands.",
        DEFAULT_KIOSK_INTERACTION_TYPE:
          "Default interaction mode used by kiosks at this facility.",
        CUSTOMER_SITE_CODE: "Site code that must match BOL for entry to this site.",
        DEADMAN_TIMEOUT_SECONDS: "Timeout (in seconds) for deadman mode at the Kiosk.",
        DECORATION_BOUNDING_BOX_FONT_SCALE:
          "Scale factor applied to bounding box text size.",
        DECORATION_BOUNDING_BOX_BORDER_SIZE:
          "The thickness of the borders of each bounding box.",
        DECORATION_FONT_BACKGROUND:
          "Background color or brush used when rendering overlay text.",
        DECORATION_FONT_BRUSH:
          "Foreground color or brush used when rendering overlay text.",
        DECORATION_FONT_SCALE: "Scale factor applied to overlay text size.",
        DECORATION_LOGO_SIZE: "Relative size used when drawing overlay logos.",
        DEFAULT_TRAILER_TYPE: "Fallback trailer type when no specific type is available.",
        YARD_INVENTORY_MAXIMUM_HOURS: "Maximum trailer age to include in yard inventory.",
        YARD_INVENTORY_MODE: "Reporting mode used when generating yard inventory data.",
        DASHBOARD_VIDEO_TYPES: "Only the selected video types appear on the dashboards.",
        DECORATION_IMAGE_TYPES: "Image types that should receive overlay decorations.",
        ENABLE_AUTOMATED_FEATURES: "Is automated entry enabled?",
        LANE_EVENT_HTTP_CLIENT_ID: "Client ID",
        LANE_EVENT_HTTP_CLIENT_SECRET: "Client Secret",
        LANE_EVENT_HTTP_RETRY_COUNT: "Retry Count",
        LANE_EVENT_HTTP_SCOPE: "Scope",
        LANE_EVENT_HTTP_TOKEN_URL: "Token URL",
        LANE_EVENT_HTTP_URL: "URL",
        LANE_EVENT_HTTP_REVIEW_STATUS_FILTER:
          "Review statuses that trigger HTTP push (e.g. Reviewed).",
        LANE_EVENT_HTTP_EVENT_STATUS_FILTER:
          "Event statuses that trigger HTTP push (e.g. Ended).",
        LANE_EVENT_HTTP_EXCLUDE_MEDIA:
          "When on, send a flat lane event JSON without media. When off, send the legacy laneEvent + media wrapper.",
        CUSTOMER_SITE_NAME:
          "Customer-facing site name included in the HTTP push payload.",
        PLANT_CODE: "Plant code for SAP BOL upload",
        PRINT_COPIES: "Print this many copies",
        SHOW_SELECT_PAGE: "Show the facility selection page in Drivers App and Kiosk.",
        SHOW_DECORATED_IMAGES:
          "Show the decorated version of event images, with bounding boxes, timestamp, facility caption and logo drawn on them. When off, the clean original images are shown.",
        SHOW_DAMAGE_IMAGES:
          "Show images that highlight potential damage on the gate log details page.",
        SHOW_GATE_LOG_APPOINTMENT_CARD: "Show appointment card on gate log details.",
        SAP_TXT_FTP_ENDPOINT:
          "SFTP endpoint used for SAP TXT file delivery (credentials are managed in backend app settings).",
        C3_YMS_URL: "URL opened in a new tab when the C3 YMS navbar button is clicked.",
        IS_DEVELOPMENT:
          "Flag this tenant as a development environment for AVAC features.",
      },
      FRIENDLY_NAME: {
        ANALYTICS_CACHE_ENABLED: "Analytics cache enabled",
        APPOINTMENT_EXPIRY_TIME: "Appointment Expiry Time",
        ASSET_LOG_CONFIGURABLE_COLUMNS: "Asset log optional columns",
        ASSET_LOG_PROCESSABLE_ASSET_KINDS: "Asset log asset kinds",
        ASSET_LOG_PROCESSABLE_REVIEW_STATUSES: "Asset log review statuses",
        PORT_OF_ENTRY_CONFIGURATION: "Port of entry",
        AUTOMATED_DRIVER_TYPES: "Automated Driver Types",
        AUTOMATED_KIOSK_TIMEOUT: "Automated Kiosk Timeout",
        AUTOMATED_LANE_EVENT_STALE: "Automated Lane Event Stale",
        AUTOMATED_RESUME_MAX_HOURS: "Automated Resume Maximum Hours",
        AUTOMATED_TRIGGER_BRE_DIRECTLY: "Automated Trigger BRE Directly",
        BOL_EMAIL_UNSIGNED_ADDRESS: "BOL Email unsigned address",
        BOL_EMAIL_UNSIGNED_AGE_MINUTES: "BOL Email unsigned age minutes",
        BOL_SIGNED_EXPORT_INTERVAL_MINUTES: "BOL signed export interval minutes",
        BRE_PAUSE_ON_ERROR: "BRE pause on error",
        CAMPUS: "Campus",
        CARRIER_SOURCE: "Carrier source",
        CONTAINER_CHECK_CHASSIS: "Check chassis container",
        CTPAT_ENABLED: "CTPAT inspection enabled",
        CTPAT_INSPECTION_TYPE: "CTPAT inspection type",
        DRIVER_APP_NEEDS_PASSCODE: "Driver app needs passcode",
        EMPLOYEE_QR_CODE: "Employee QR code",
        EMPLOYEE_PIN: "Employee pin",
        EMPLOYEE_PIN_LENGTH: "Employee pin length",
        ENABLE_DRIVER_ASSIST: "Enable driver assist",
        ENABLE_KIOSK_REGISTRATION: "Enable Kiosk registration",
        FUZZY_MATCH_CROSS_FIELDS: "Fuzzy match across fields",
        FUZZY_MATCH_THRESHOLD: "Fuzzy match threshold",
        FAILED_STATUSES: "Failed statuses",
        NON_COMPLIANT_STATUS_ENABLED: "Flag non-compliant entries",
        NON_COMPLIANT_STATUS_LABEL: "Non-compliant status label",
        HOLIDAYS: "Holidays",
        IGNORED_SEASONS: "Ignored seasons",
        IS_AUTOMATED: "Is automated",
        IS_AUDIT_BASED_FACILITY: "Audit-based facility",
        IS_EXTERNAL_FACILITY: "Is external facility",
        LANGUAGES_SUPPORTED: "Languages supported",
        LANGUAGE_DEFAULT: "Language default",
        LANGUAGES_SUPPORTED_FOR_AVAC_DASHBOARD: "Languages supported for AVAC dashboard",
        LANGUAGE_DEFAULT_FOR_AVAC_DASHBOARD: "Language default for AVAC dashboard",
        LOADING_TIMEOUT_SECONDS: "Loading timeout seconds",
        LOGO_IMAGE: "Logo image",
        MIN_SILO_LEVEL: "Minimum silo level",
        MODULES: "Modules",
        NEW_GATE_ENGAGEMENT_TIME_CALCULATION_START_DATE:
          "New gate engagement time calculation start date",
        OTP_CODE_ENABLED: "OTP code enabled",
        OTP_LENGTH: "OTP length",
        OTP_ALL_NUMBERS: "All numbers",
        OPERATOR_WAIT_TIMEOUT_SECONDS: "Operator wait timeout (seconds)",
        SPOUT_POSITIONING_SIGNAL: "Spout positioning signal",
        TRAFFIC_LIGHT_SIGNAL: "Traffic light signal",
        TEMPERATURE_READ_DELAY_SECONDS: "Temperature read delay seconds",
        TEMPERATURE_MIN: "Temperature minimum allowed",
        TEMPERATURE_MAX: "Temperature maximum allowed",
        REFERENCE_LABEL: "Reference label",
        RENTAL_RECIPIENT_EMAIL: "Rental recipient email",
        RENTAL_SUBJECT: "Rental subject",
        RENTAL_BODY: "Rental body",
        REPRINT_MAX_HOURS: "Reprint Maximum Hours",
        REQUIRED_SITE_CODE: "Required site code",
        KRAFT_APPOINTMENT_DATE_VALIDATION: "Kraft appointment date validation",
        KRAFT_APPOINTMENT_MAX_DAYS_AHEAD: "Kraft appointment max days ahead",
        KRAFT_APPOINTMENT_DATE_CHECK_EXCLUDED_SUB_TYPE:
          "Kraft appointment date check excluded sub-type",
        ROLES_ASSIGNED: "Roles assigned",
        RULE: "Rule",
        RESUME_ACP: "Resume ACP",
        LANE_INTERCOM_URL: "Intercom URL",
        LANE_KIOSK_WAIT_TIME: "Kiosk wait time (seconds)",
        LANE_SUCCESS_SCREEN_TIMEOUT_SECONDS: "Success screen timeout (seconds)",
        LANE_TEST_PRINT_OTP: "Test Print OTP",
        LANE_SILENT_RELOAD_INTERVAL_MINUTES: "Silent reload interval (minutes)",
        LANE_GATE_ARMS: "Lane gate arms",
        LANE_ESCALATION: "Lane escalation",
        GATE_AUTOMATION_MODE: "Loading line mode",
        SEND_CHASSIS_AS_TRAILER: "Send chassis number as trailer number",
        SETUP_TIMEOUT_SECONDS: "Setup timeout seconds",
        TRUCK_CODE: "SAP truck/carrier code",
        USE_V2_KIOSK_FLOW: "Use V2 kiosk flow",
        SUCCESS_SCREEN_TIMEOUT_SECONDS: "Success screen timeout (seconds)",
        SIGNATURE_KIND: "EBOL: Signature flow",
        SHOW_CV_EVENTS: "Show CV events",
        SHOW_INTERNAL_CV_EVENTS: "Show internal CV events",
        DISABLE_CARRIER_FOR_INTERNAL_EVENTS:
          "Disable carrier selector for internal events",
        YARD_INVENTORY_CHECK_IN: "Yard Inventory: Show Check-in row",
        YARD_INVENTORY_FILTER_GROUP:
          "Yard Inventory: List of Trailer Groups to include in the report",
        YARD_INVENTORY_LANGUAGE: "Yard Inventory: Language to send emails in (ie. en-US)",
        YARD_INVENTORY_MINIMUM_AGE:
          "Yard Inventory: Minimum detention time of trailer to include in report",
        YARD_INVENTORY_INCLUDE_CHECKED_IN: "Yard Inventory: Include checked in trailers",
        YARD_INVENTORY_INCLUDE_CHECKED_OUT:
          "Yard Inventory: Include checked out trailers",
        YARD_INVENTORY_RECIPIENT_EMAIL: "Yard Inventory: email addresses",
        YARD_INVENTORY_REPORT_FORMAT: "Yard Inventory: Report Format",
        YARD_INVENTORY_SEND_EMPTY: "Yard Inventory: Send empty reports?",
        YARD_INVENTORY_SEND_TIME:
          "Yard Inventory: Local facility time to send report (ie. 01:00)",
        YARD_INVENTORY_SHOW_CHECKED_IN:
          "Yard Inventory: Show checked in trailers in the web UI?",
        YARD_INVENTORY_SHOW_YARD_MAP: "Yard Inventory: Show yard map in the web UI?",
        YARD_INVENTORY_SORT_ORDER:
          "Yard Inventory: List of sort keys for report (ie: trailer.trailerNumber)",
        YMS_FACILITY_ID: "YMS facility ID",
        EBOL_FACILITY_INTERNAL_ID: "EBOL: Internal Facility ID",
        ENABLE_EBOL: "EBOL: Enable E-Signature",
        EBOL_ALLOW_SIGNING_SKIP_ON_ERROR: "EBOL: Allow skipping EBOL signing on error",
        SMART_LOCKER_ENABLED: "Smart locker enabled",
        SMART_LOCKER_HARDWARE_TYPE: "Smart locker hardware type",
        SMART_LOCKER_EXTERNAL_LOCATION_ID: "Smart locker external location ID",
        SMART_LOCKER_PROVIDER: "Smart locker provider",
        REGISTRATION_EXPIRY_LIMIT: "Registration expiry limit",
        MAX_LOAD_WEIGHT_TONNES: "Maximum load weight (tonnes)",
        ONLY_SHOW_DRIVER_ASSIST: "Only show driver assist appointment",
        ALLOW_APPOINTMENT_LIST_EDITING: "Allow appointment list editing",
        ALLOWED_CARRIERS_FOR_REGISTRATION_EXPIRY_DATE:
          "Allowed carriers for registration expiry date",
        USE_COMMANDER_FOR_GATE_OPERATIONS: "Use commander for gate operations",
        ALLOWED_CV_REVIEW_STATUS: "Allowed CV review status",
        ALLOWED_VEHICLE_TYPES: "Allowed vehicle types",
        APPROVE_AND_OPEN_GATE_STATUSES: "Approve & Open Gate statuses",
        EVENT_COMMENT_FIELDS: "Event comment fields",
        ENABLE_GATE_OPEN: "Enable gate open",
        KALERIS_CHECK_IN_WINDOW_MINUTES: "Kaleris check in window minutes",
        KALERIS_CHECK_OUT_WINDOW_MINUTES: "Kaleris check out window minutes",
        IS_GATELOG_LIVE_MODE_ENABLED: "Is gatelog live mode enabled",
        GATE_OPEN_COOLDOWN_SECONDS: "Gate open cooldown seconds",
        DEFAULT_KIOSK_INTERACTION_TYPE: "Default kiosk interaction type",
        CUSTOMER_SITE_CODE: "Customer site code",
        NEEDS_KALERIS_ASSIGNMENT: "Needs kaleris assignment",
        DEADMAN_TIMEOUT_SECONDS: "Deadman Timeout (in seconds)",
        DECORATION_BOUNDING_BOX_FONT_SCALE: "Bounding box text scale",
        DECORATION_BOUNDING_BOX_BORDER_SIZE: "Bounding box border size",
        DECORATION_FONT_BACKGROUND: "Decoration font background",
        DECORATION_FONT_BRUSH: "Decoration font brush",
        DECORATION_FONT_SCALE: "Decoration font scale",
        DECORATION_LOGO_SIZE: "Decoration logo size",
        DEFAULT_TRAILER_TYPE: "Default trailer type",
        YARD_INVENTORY_MAXIMUM_HOURS: "Yard inventory maximum hours",
        YARD_INVENTORY_MODE: "Yard inventory mode",
        DASHBOARD_VIDEO_TYPES: "Dashboard video types",
        DECORATION_IMAGE_TYPES: "Decoration image types",
        ENABLE_AUTOMATED_FEATURES: "Enable automated features",
        LANE_EVENT_HTTP_CLIENT_ID: "Lane Events to HTTP Endpoint: Client ID",
        LANE_EVENT_HTTP_CLIENT_SECRET: "Lane Events to HTTP Endpoint: Client Secret",
        LANE_EVENT_HTTP_RETRY_COUNT: "Lane Events to HTTP Endpoint: Retry Count",
        LANE_EVENT_HTTP_SCOPE: "Lane Events to HTTP Endpoint: Scope",
        LANE_EVENT_HTTP_TOKEN_URL: "Lane Events to HTTP Endpoint: Token URL",
        LANE_EVENT_HTTP_URL: "Lane Events to HTTP Endpoint: URL",
        LANE_EVENT_HTTP_REVIEW_STATUS_FILTER:
          "Lane Events to HTTP Endpoint: Review Status Filter",
        LANE_EVENT_HTTP_EVENT_STATUS_FILTER:
          "Lane Events to HTTP Endpoint: Event Status Filter",
        LANE_EVENT_HTTP_EXCLUDE_MEDIA: "Lane Events to HTTP Endpoint: Exclude media",
        CUSTOMER_SITE_NAME: "Customer site name",
        PLANT_CODE: "Plant code for SAP BOL upload",
        PRINT_COPIES: "Print this many copies",
        SHOW_SELECT_PAGE: "Show select page",
        SHOW_DECORATED_IMAGES: "Show decorated images",
        SHOW_DAMAGE_IMAGES: "Show damage images",
        SHOW_GATE_LOG_APPOINTMENT_CARD: "Show appointment card on gate log details",
        SAP_TXT_FTP_ENDPOINT: "SAP TXT SFTP endpoint (endpoint only)",
        C3_YMS_URL: "C3 YMS URL",
        IS_DEVELOPMENT: "Is development",
      },
    },
    TOAST: {
      APPROVE_EVENT_FAILED: "Failed to approve event. Please try again.",
      EVENT_APPROVED: 'Event approved successfully! Click on "Open Gate" button.',
      EVENT_REJECTED: "Event rejected.",
      GATE_OPENED: "Gate opened successfully!",
      GATE_ARM_OPEN_INITIATED_MESSAGE:
        "Gate Arm Open command initiated for {{lane}} {{gateArm}}",
      GATE_ARM_OPEN_FAILED_MESSAGE:
        "Failed to initiate open Gate Arm for {{lane}} {{gateArm}}.",
      OPEN_GATE_FAILED: "Failed to open gate. Please try again or contact support.",
      REJECT_EVENT_FAILED: "Failed to reject event. Please try again.",
      RESUME_FAILED: "Failed to resume workflow. Please try again.",
      WORKFLOW_RESUMED: "Workflow resumed successfully!",
      FAILED_TO_LOAD_SEASONALITY_DATA: "Failed to load seasonality data",
      COMMODITY_ADDED: "Commodity added successfully!",
      COMMODITY_UPDATED: "Commodity updated successfully!",
      COMMODITY_DELETED: "Commodity deleted successfully!",
      EQUIPMENT_TYPE_ADDED: "Equipment type added successfully!",
      EQUIPMENT_TYPE_UPDATED: "Equipment type updated successfully!",
      EQUIPMENT_TYPE_DELETED: "Equipment type deleted successfully!",
      RULE_ADDED: "Rule added successfully!",
      RULE_UPDATED: "Rule updated successfully!",
      RULE_DELETED: "Rule deleted successfully!",
      OPERATION_FAILED: "Operation failed",
    },
    FILTER: {
      LABEL: {
        BETWEEN: "between",
        CONTAINS: "contains",
        DAYS: "Days",
        EQUAL_TO: "equals",
        GREATER_THAN: "greater than",
        HOURS: "Hours",
        IS: "is",
        IS_NOT: "is not",
        LESS_THAN: "less than",
        MAX: "Max",
        MIN: "Min",
        MINUTES: "Minutes",
        NOT_CONTAINS: "does not contain",
        NOT_EQUAL_TO: "does not equal",
      },
      TAG: {
        BETWEEN: "<F/>: between <V1/> and <V2/>",
        CONTAINS: "<F/>: contains <V/>",
        DAYS: "<F/>: between <V1/> and <V2/> days",
        EQUAL_TO: "<F/>: equals <V/>",
        GREATER_THAN: "<F/>: is greater than <V/>",
        HOURS: "<F/>: between <V1/> and <V2/> hours",
        IS: "<F/>: is <V/>",
        IS_IN_SET_one: "<F/>: is <V/>",
        IS_IN_SET_other: "<F/>: is one of <V/>",
        IS_NOT: "<F/>: is not <V/>",
        LESS_THAN: "<F/>: less than <V/>",
        MINUTES: "<F/>: between <V1/> and <V2/> minutes",
        NOT_CONTAINS: "<F/>: does not contain <V/>",
        NOT_EQUAL_TO: "<F/>: does not equal <V/>",
      },
      BLANK_VALUE: "(Blank)",
      ROWS_zero: "no rows",
      ROWS_one: "{{count}} row",
      ROWS_two: "{{count}} rows",
      ROWS_few: "{{count}} rows",
      ROWS_many: "{{count}} rows",
      ROWS_other: "{{count}} rows",
      FILTER_WIP: {
        FILTER_MENU_WIP: {
          MORE_FILTERS: "More Filters",
          FILTERS: {
            TAB: "Filters",
            TITLE: "More Filters",
            DESCRIPTION: "Refine table results",
          },
          VISIBILITY: {
            TAB: "Visibility",
            TITLE: "More Filters",
            DESCRIPTION: "Choose where each filter appears",
            FILTER_HEADER: "Quick Filter",
            CARD_HEADER: "KPI Card",
          },
        },
        FILTER_COLUMN_MENU: {
          LABEL: "Columns",
          TITLE: "Columns",
          DESCRIPTION: "Toggle columns",
          OFF: "Off",
        },
        SELECT: "Select...",
        SELECT_OPTION: "Select an option",
        SELECTED: "Selected",
        SEARCH: "Search...",
        SEARCH_OPTIONS: "Search options",
        NO_RESULTS: "No results.",
        NO_OPTIONS: "No options.",
        CLEAR_FILTER: "Clear filter",
        DATE_RANGE: {
          START_DATE: " Start Date",
          END_DATE: "End Date",
          START_TIME: "Start Time",
          END_TIME: "End Time",
          TIME_ZONE: "Time Zone",
        },
        DONE: "Done",
        CLEAR: "Clear",
        CANCEL: "Cancel",
        RESET: "Reset",
        APPLY: "Apply",
      },
    },
    WIZARD: {
      RESOLUTION_STEPS_HEADER: "Resolution Steps",
      RESOLVE_FOR_PREVIOUS_APPOINTMENT: "Resolve error for previous appointment",
      GO_BACK_TO_PREVIOUS_APPOINTMENT: "Go back to previous appointment",
      COMMENT_COPIED_FEEDBACK: "Comment copied",
      HAVING_ISSUES: "Having issues?",
      HAVING_ISSUES_MESSAGE: "Shows a comment box with Approve / Reject actions",
    },
    ADD_COMMENT_HEADER: "Add Comment (Required)",
    ADD_RESOLUTION_COMMENT: "Add Resolution Comment",
    CHOOSE_COLUMN: "Choose a Column",
    CHOOSE_FILTER: "Choose a Filter",
    COMMENT_HERE: "Add your comment here...",
    COMMENT_SUBMITTED: "Comment submitted",
    CONFIRM_DELETE_DRIVER_PROMPT:
      "Are you sure you want to delete {{NAME}}? This action cannot be undone.",
    DRIVER_ASSIST: "Driver Assist",
    DRIVER_CREATED: "Driver created successfully!",
    DRIVER_PIN: "Driver PIN:",
    DRIVER_QR_CODE: "Driver QR Code",
    DRIVER_UPDATED: "Driver updated successfully!",
    EDIT: "Edit",
    FACILITY: "Facility",
    FAILED_EVENTS: "Failed Events",
    FILTER_VALUE: "Filter Value",
    HISTORICAL_EVENTS: "Historical Events (Last 24 hours)",
    RESIZE_PANELS: "Drag to resize panels",
    IMAGE_MODAL_INSTRUCTIONS: "Scroll to zoom • Drag to pan when zoomed",
    LOADING: "Loading...",
    VIDEO_MODAL_INSTRUCTIONS: "Use video controls to play/pause",
    NO_APPROVED_EVENTS: "No approved events found for the selected date range",
    NO_EVENTS: "No events available",
    NO_FAILED_EVENTS: "No failed events found in the last 24 hours",
    NO_LANES: "No lanes available.",
    NO_NON_FAILURE_EVENTS: "No non-failure events found in the last 24 hours",
    NO_INVENTORY: "No inventory items found.",
    NO_MATCHES: "No matches found",
    NO_VEHICLE_MEDIA: "No vehicle media available",
    OPEN_GATE: "Open Gate",
    OPEN_GATE_COOLDOWN: "Open Gate ({{seconds}})",
    EBOL: {
      DIRECTION: {
        INBOUND: "Inbound",
        OUTBOUND: "Outbound",
      },
      ACTIVITY_TRACKER: "Activity Tracker",
      ACTOR: {
        AUTOMATIC: "Automatic",
        MOTC: "MOTC",
      },
      ACTIVITY: {
        ORIGIN_EVENT: "Origin",
        TIME_DATE: "Time/Date",
        WHO: "Who",
      },
      ADDITIONAL_STOPS: "Additional Stops",
      SHIPMENT: "Shipment",
      SHIPMENT_COUNT_one: "{{count}} Shipment",
      SHIPMENT_COUNT_other: "{{count}} Shipments",
      SHIPMENT_DETAILS_SECTION: "Shipment Details",
      SHIPMENT_DOCUMENTS: "Shipment documents",
      SHIPMENT_KIND_DROP: "Drop",
      SIGNATURE_SUBMITTING: "Submitting Signature...",
      BANNER: {
        ACCEPTED: "Accepted",
        ACCEPTED_DESC: "Shipments accepted by the facility",
        CHECKED_IN_DESC: "Shipments checked in at the facility",
        CHECKED_OUT_DESC: "Shipments currently moving between facilities",
        CLOSED_DESC: "Shipments waiting on signatures",
        EXCEPTIONS: "Exceptions",
        EXCEPTIONS_DESC: "Shipments requiring attention",
        IN_TRANSIT: "In Transit",
        SIGNED_DESC: "Shipments signed and ready to check out",
        LOCKER_ASSIGNED_DESC: "Shipments with an assigned smart locker",
      },
      BOL_EXTRA_COUNT: " +{{count}}",
      BOL_PO_STRUCTURE: "BOL/PO Structure",
      BOL_SHORT: "BOL #",
      SHIPMENTS: "Shipments",
      CARRIER_SCAC: "Carrier SCAC",
      CLOSE_SHIPMENT_DETAILS: "Close shipment details",
      COLUMN: {
        APPT_TYPE: "Appt type",
        SEAL_SHORT: "Seal #",
        SHIP_TO: "Ship to",
        TRAILER_SHORT: "Trailer #",
        LOCKER: "Locker",
      },
      CUSTOMER: "Customer",
      CUSTOM_FIELDS: "Custom Fields",
      DATE_RANGE: "Date Range",
      DELIVERY_STOP: "Delivery Stop",
      DESCRIPTION:
        "Monitor electronic bills of lading, filter records quickly, and open a detail panel for the selected shipment.",
      DESTINATION: "Destination",
      DESTINATIONS: "Destination(s)",
      DETAILS: "Select a row to inspect its appointment and EBOL details.",
      DOCUMENT: {
        BILLS_OF_LADING: "Bills of Lading",
        BOL: "BOL",
        BOL_PREFIX: "BOL {{number}}",
        PACKING_SLIP: "Packing Slip",
        PACKING_SLIPS: "Packing slips",
        PACKING_SLIPS_MANIFESTS: "Packing Slips/Manifests",
        PROOF_OF_DELIVERY: "Proof of delivery",
        PROOF_OF_SHIPMENT: "Proof of shipment",
      },
      DOCUMENT_BOL: "Bill of Lading",
      DOCUMENT_PAGE_ERROR: "Unable to load the document right now.",
      DOCUMENT_UPLOAD_FAILED: "Couldn't upload the document. Try again.",
      DOCUMENT_UPLOAD_SUCCESS: "Document uploaded.",
      DOCUMENTS_SECTION: "Documents",
      EDIT_FIELD: "Edit {{field}}",
      EDIT_STATUS: "Edit {{status}} status",
      EMPTY_TABLE: "No EBOL records matched the current filters.",
      FILES_one: "{{count}} File",
      FILES_other: "{{count}} Files",
      FILTER_SEPARATOR: " | ",
      GO_BACK: "Go back",
      KPI_LINKED_APPOINTMENTS: "Matching EBOLs",
      KPI_SEAL_ASSIGNED: "Appointment Types",
      KPI_TOTAL: "Visible Appointments",
      KPI_TRAILER_ASSIGNED: "Carriers",
      LAST_UPDATED: "Last Updated",
      LOAD_ERROR: "Unable to load EBOL data right now. Try refreshing the page.",
      LOCKER: {
        ASSIGNED_LABEL: "Locker Assigned",
        HEADER_LABEL: "Locker",
        ACTIONS: "Locker actions",
        ASSIGN: "Assign",
        ASSIGN_FAILED: "Failed to assign locker",
        ASSIGNING: "Assigning...",
        UNASSIGN: "Unassign Locker {{name}}",
        UNASSIGN_CONFIRM_DESCRIPTION:
          "Are you sure you want to unassign Locker {{name}}?",
        UNASSIGN_CONFIRM_TITLE: "Unassign locker?",
        UNASSIGN_FAILED: "Failed to unassign locker",
        UNLOCK: "Unlock Locker {{name}}",
        UNLOCK_FAILED: "Failed to unlock locker",
      },
      MATCHING_BOLS: "Matching EBOLs",
      MIXED_STATUS: "Mixed",
      NO_DOCUMENTS: "No documents attached yet.",
      NO_RESULTS: "No results",
      NOT_AVAILABLE: "Not available",
      ADD_NOTE: "Add note",
      NOTE_PLACEHOLDER: "Add a note.",
      NOTE_SAVE_FAILED: "Couldn't save the note. Try again.",
      NOTE_SAVE_SUCCESS: "Note saved.",
      NOTES: "Notes",
      NOTES_PLACEHOLDER: "No notes added yet.",
      OVERVIEW: "Overview",
      PAGE_OF: "Page {{page}} of {{totalPages}}",
      PO_SHORT: "PO #",
      PREV: "Prev",
      PURCHASE_ORDERS: "Purchase Orders",
      QUICK_FILTERS: "Quick Filters",
      RDD: "RDD",
      ROUTE: "Route",
      ROUTE_ARROW: " -> ",
      ROUTE_EXTRA_STOPS: " +{{count}}",
      SAVE_NOTE: "Save",
      SHIP_DATE: "Ship Date",
      SHIP_FROM: "Ship From",
      SHIP_TO: "Ship To",
      SHOWING_RANGE: "Showing {{start}}-{{end}} of {{total}}",
      STATUS: {
        CHECKED_IN: "Checked In",
        CHECKED_OUT: "Checked Out",
        CLOSED: "Closed",
        COMPLETED: "Completed",
        DELIVERED: "Delivered",
        EXCEPTION: "Exception",
        MISSED: "Missed",
        OPEN: "Open",
        SIGNED: "Signed",
      },
      TABLE_PAGINATION: "Table pagination",
      TBA: "<TBA>",
      TRAILER_ASSIGNMENT_SECTION: "Trailer Assignment",
      TITLE: "EBOL Dashboard",
      TOGGLE_BANNERS: "Toggle Banners",
    },
    PRODUCT_NAME: "AVAC™",
    READ_AND_AGREE: "Read and agree to the <BUTTON>Waiver Form</BUTTON>",
    SAVING: "Saving...",
    SAVED: "Saved",
    SELECT_LANE: "Select Lane",
    SUBMITTING: "Submitting...",
    SUGGESTION: {
      EMAIL_OR_PHONE_NUMBER: "Fill in either email or phone number field",
    },
    VALIDATION: {
      INVALID_EMAIL: "Please enter a valid email address",
      INVALID_NAME: "Should only contain letters and spaces",
      INVALID_PHONE_NUMBER: "Please enter a valid 10-digit phone number",
      INVALID_TIME: "Invalid time. Use HH:MM.",
      TIME_INTERVAL_END_BEFORE_START: "End time cannot be earlier than start time.",
    },
    WELCOME: "Welcome to EAIGLE Dashboard",
    REGISTRATION_COMPLETED: "Registration Completed",
    OTP: "OTP",
    REGISTRATION_QR_CODE: "Registration QR Code",
    YARD_SIGHTING_SIMULATION: {
      ADD_ITEM: "Add {{item}}",
      CAMERA_ID: "Camera ID",
      CARRIER_NAMES: "Carrier names",
      CHANGE_DETECTED: "Change detected",
      CREATE_FAILED: "Could not create the sighting",
      CREATED: "Yard sighting created",
      DROP_IMAGES: "Click or drop images to attach",
      DROP_IMAGES_HINT: "Optional. Each image is sent as one observation.",
      DROP_IMAGES_REQUIRED: "At least one is needed to report a detected change.",
      IMAGE_READ_FAILED: "That image could not be read",
      IMAGE_TAKEN_AT: "Taken at",
      IMAGE_TYPE: "Image type",
      IMAGES: "Images",
      NO_CHANGE_RECORDED: "No change recorded; the pending sighting was refreshed",
      NO_CV_FACILITY: "The selected facility is not configured in CV",
      OBSERVED_AT: "Observed at",
      SPOT_PLACEHOLDER: "01",
      SPOTS: "Spots",
      SUBMIT: "Create sighting",
      TAB: "Yard Sighting",
      TITLE: "Yard Sighting Simulation",
      TRAILER_NUMBERS: "Trailer numbers",
      VACANT: "Spot is vacant",
    },
  },
  BRE: {
    ERRORS: {
      CTPAT_INCOMPLETE: "CTPAT Inspection Not Complete",
      INVALID_QR_CODE_OTP_SOURCE: "Invalid QR-code/OTP source",
      APPOINTMENT_NOT_FOUND: "No registered appointment found",
      DRIVER_NOT_FOUND: "No registered driver found",
      APPOINTMENT_EXPIRED: "Appointment expired",
      MAXIMUM_APPOINTMENT_USAGE_EXCEEDED: "Maximum appointment usage exceeded",
      CDL_VALIDATION_FAILED: "CDL validation failed",
      VEHICLE_NOT_CAPTURED: "No vehicle was captured by the camera",
      VEHICLE_IDENTIFICATION_ERROR: "Vehicle Identification Error",
      REQUIRED_INBOUND_DATA_MISSING: "Required inbound data missing in driver's form",
      REQUIRED_OUTBOUND_DATA_MISSING: "Required outbound data missing in driver's form",
      TRAILER_COUNT_MISMATCH: "Detected trailer count mismatch",
      TRAILERS_NOT_CAPTURED: "No trailers are captured by camera",
      UNEXPECTED_TRAILER_CAPTURED: "Unexpected trailer captured by camera",
      SHIPMENT_DOCUMENTS_NOT_FOUND: "No shipment documents were found",
      EBOL_NOT_SIGNED: "EBOL is not signed",
      TRAILER_NUMBER_MISMATCH:
        "Captured trailer number does not match the trailer number specified in the shipment document",
      SEAL_BROKEN: "Seal is broken",
      SEAL_NUMBER_MISMATCH: "Captured seal number does not match BOL seal number",
      INVALID_TRAILER_TEMPERATURE: "Temperature of the trailer is invalid",
      INVALID_TRAILER_FUEL_LEVEL: "Fuel level of the trailer is invalid",
      CUSTOMER_TRAILER_VALIDATION_FAILED: "Customer validation for trailer failed",
      SEAL_NUMBER_CAPTURED_FOR_EMPTY_TRAILER: "Seal number is captured for empty trailer",
      PICKUP_INFORMATION_VALIDATION_FAILED: "Pickup information validation failed",
      SITE_CHECK_IN_FAILED: "Site check-in operation failed",
      SITE_CHECK_OUT_FAILED: "Site check-out operation failed",
      CONFIGURATION_ERROR: "Configuration error",
      FIRST_PARTY_EXTERNAL_SYSTEM_INTEGRATION_ERROR:
        "First-party external system integration error",
      THIRD_PARTY_EXTERNAL_SYSTEM_INTEGRATION_ERROR:
        "Third-party external system integration error",
      GATE_OPEN_FAILED: "An error occurred while attempting to open the gate",
      MANUAL_GUARD_PROCESSING_REQUIRED: "Manual processing by the guard is required",
    },
    BURLINGTON: {
      ENTRY_TYPE_MISMATCH:
        "Appointment does not match lane. Please contact the gate operator.",
      FACILITY_PARAMS_ERROR:
        "Unable to retrieve facility configuration. Please contact the gate operator.",
      HAS_TRAILER_ERROR: "Trailer detected. Please contact the gate operator.",
      INVALID_APPOINTMENT: "Invalid QR Code Scanned; Please contact Gate Operator",
      INVALID_QRCODE_FORMAT:
        "Invalid QR Code Format. Please use a valid appointment QR code.",
      MANUAL_REVIEW_REQUIRED: "Please wait for entry approval ",
      NO_VEHICLE_DETECTED: "No vehicle detected. Please pull forward and try again.",
    },
    CIMENTOS: {
      ANOTHER_TRUCK_IN_SILO:
        "Another truck is currently in this silo.  Please wait for it to leave.",
      GO_TO_OUTBOUND: "Go to the outbound lane to get your BOL.",
      GO_TO_SILO: "Go to the silo and get your truck filled first.",
      LANE_PARAMS_ERROR:
        "Unable to retrieve lane configuration. Please contact the shipping officer.",
      NO_CREDIT_TITLE: "Unable to continue",
      NO_CREDIT: "Your company has no credit. Please contact the shipping officer.",
      NOT_PRINTER_LANE_ERROR:
        "Unable to reprint here.  Please go to an outbound kiosk with a printer.",
      WEIGHT_EXCEEDS_MAX_TITLE: "Weight too high",
      WEIGHT_EXCEEDS_MAX:
        "Load weight cannot exceed {{max}} tonnes at this facility. Enter net load weight only (do not include truck or trailer tare weight).",
      OUTBOUND_DONE:
        "Thank you for your business.  Please get your BOL from the printer.",
      PROCEED_TO_LANE: "Please proceed to {{lane}}",
      PROCEED_TO_LANE_RECORD_OTP: "Record the OTP {{otp}}\nThen proceed to {{lane}}",
      SILO_DONE:
        "{{delta}} tonnes of {{productName}} loaded with temperature {{temperature}}.  Please get your BOL at the hatch closing station.",
      SILO_EMPTY:
        "Could not find silo with enough product.  Please contact the shipping officer",
      SILO_NOT_DONE:
        "{{delta}} tonnes of {{productName}} loaded with temperature {{temperature}}.  Please ensure the spout is off your truck before leaving.",
      SILO_FAILURE: "Error communicating with silo.  Please contact the shipping officer",
      SILO_LOADING: "Please wait while {{weight}} tonnes of {{productName}} is loaded",
      SILO_PARK:
        "Welcome {{firstName}} {{lastName}}.  Please park your truck on the scale",
      SORRY_WRONG_SILO:
        "Sorry, there is not enough {{productName}} here.  Please go to {{lane}}.",
      TRAILER_NUMBER_DOES_NOT_MATCH: "Trailer Number Does Not Match.",
      TRUCK_FULL:
        "Your truck currently weighs {{tare}} tonnes.  Please empty your trailer before having it filled.",
    },
    DILLARDS: {
      CHECKIN_FAILED: "YMS Check-in failed",
      CHECKOUT_FAILED: "YMS Check-out failed",
      GUARD_INTERACTION_NEEDED: "Guard interaction needed",
      GUARD_CONTROL: "Gates should be opened by guard",
      INVALID_TRAILER_DATA: "Invalid trailer data was provided",
    },
    KRAFT: {
      APPOINTMENT_USAGE_EXCEEDED: "Appointment Usage Has Been Exceeded",
      BOL_CALL_FAILED: "BOL Call Failed",
      BOL_NOT_FOR_FACILITY: "BOL Not for this Facility",
      BOL_CALL_FAILED_NO_LANE_EVENT:
        "BOL Call Failed or InProgress CVLaneEvent not found",
      BOL_PO_MISSING_NO_LANE_EVENT:
        "BOL / PO Number Missing in Appointment and InProgress CVLaneEvent not found",
      BOL_PO_MISSING: "BOL / PO Number Missing in Appointment",
      CVLANE_EVENT_NOT_FOUND: "CVLaneEvent Does Not Exist",
      EVENT_OUTSIDE_OPERATION_HOURS: "Event outside of operation hours",
      FAILED_OBTAIN_BOL_INFO: "Failed to Obtain BOL Info",
      FUEL_LEVEL_BELOW_THRESHOLD:
        "Fuel level is below 0.75 and InProgress CVLaneEvent not found",
      FUEL_LEVEL_BELOW_THRESHOLD_NO_LANE_EVENT:
        "Fuel level is below 0.75 and InProgress CVLaneEvent not found",
      INTERNAL_FAILURE: "Internal Failure",
      INVALID_APPOINTMENT_ENTRY_SUBTYPE: "Invalid Appointment EntrySubType",
      INVALID_APPOINTMENT_ENTRY_TYPE: "Invalid Appointment EntryType",
      INVALID_APPOINTMENT_QR_CODE: "Invalid Appointment QR Code",
      INVALID_ENTRY_SUBTYPE: "Invalid EntrySubType",
      INVALID_ENTRY_SUBTYPE_IN_APPOINTMENT: "Invalid EntrySubType in Appointment",
      INVALID_ENTRY_SUBTYPE_NO_LANE_EVENT:
        "Invalid EntrySubType in Appointment and InProgress CVLaneEvent not found",
      INVALID_INBOUND_BOBTAIL_PLATE_NUMBER: "Invalid Inbound Bobtail Plate Number",
      INVALID_OUTBOUND_EMPTY_APPOINTMENT_USAGE:
        "Invalid Outbound Empty Appointment Usage",
      INVALID_QRCODE_SOURCE: "Invalid QRcode Source",
      MAX_APPOINTMENT_LIMIT_REACHED: "Maximum Appointment Limit Usage Reached",
      NO_CV_LANE_EVENT_FOUND_OR_UNSUPPORTED_APPOINTMENT_MISMATCH_USAGE:
        "No CV LaneEvent Found Or Unsupported Appointment Mismatch Usage",
      NO_INPROGRESS_LANE_EVENT_FOUND: "No InProgress LaneEvent Found",
      NO_INPROGRESS_LANE_EVENT_FOUND_OR_TRAILER_NUMBER_IS_PRESENT_IN_THE_RECORD:
        "No InProgress LaneEvent Found Or Trailer Number is Present in the Record",
      NO_VEHICLE_DETECTED: "No Vehicle Detected Or Invalid Vehicle Type",
      NO_VEHICLE_DETECTED_BOBTAIL: "No Vehicle Detected Or It is not Bobtail",
      NO_USER_INFO_RECEIVED: "No User Info Received",
      PLEASE_PROCEED_TO_DOCK_OFFICE: "Please proceed to the dock office",
      PLEASE_TURN_AROUND:
        "Please turn around to leave the facility\n Scan the QR code messaged on the Outbound Kiosk to exit",
      SEAL_NUMBER_MISMATCH: "Seal Number does not match",
      SEAL_NUMBER_MISSING: "Seal Number is Missing for Outbound Loaded Record",
      TEMPERATURE_EXCEEDS_LIMIT: "Temperature Exceeds the Limit",
      TEMPERATURE_INFO_MISSING:
        "Temperature info is missing and due to the current season, a temperature check cannot be bypassed",
      TEMPERATURE_INFO_MISSING_NO_LANE_EVENT:
        "Temperature info is missing and due to the current season, a temperature check cannot be bypassed. InProgress CVLaneEvent not found",
      TEMPERATURE_INFO_NOT_INCLUDED:
        "Temperature Info was not included in the appointment",
      TEMPERATURE_INFO_NOT_INCLUDED_NO_LANE_EVENT:
        "Temperature Info was not included in the appointment and InProgress CVLaneEvent not found",
      TRAILER_NUMBER_DOES_NOT_MATCH: "Trailer Number Does Not Match.",
      TRAILER_NUMBER_DOES_NOT_MATCH_WITH_RECORD:
        "Trailer Number Does Not Match With the Record",
      TRAILER_NUMBER_IS_NOT_AVAILABLE: "Trailer Number Is Not Available",
      TRAILER_NUMBER_MISSING: "Trailer Number Missing Or Does Not Match With the Record",
      TRAILER_NUMBER_NOT_PRESENT: "Trailer Number Not Present in the Appointment",
      TRAILER_NUMBER_SHOULD_NOT_EXIST: "Trailer Number Should Not Exist in the Record",
      UNABLE_TO_VALIDATE_TEMPERATURE: "Unable to validate temperature",
      UNSUPPORTED_APPOINTMENT_TYPE: "Unsupported appointment type mismatch",
      VEHICLE_OR_TRAILER_INFORMATION_MISMATCH:
        "Vehicle type or trailer information does not match the appointment record",
    },
    LACTALIS: {
      APPOINTMENT_DOES_NOT_EXIST: "Appointment does not exist",
      YMS_CHECKIN_FAILED: "YMS Checkin Failed. Please contact the gate operator",
      OUTBOUND_TRAFFIC_WORKING_HOURS:
        "Outbound traffic in working hours should use intercom",
      OFF_HOURS_OUTBOUND_TRAILER: "Off hours Outbound with trailer should use intercom",
    },
    LOBLAW: {
      ENTRY_APPROVED: "Entry Approved. please proceed to pad {{MESSAGE}}",
      INVALID_INFORMATION: "Invalid Information",
      PROCEED_TO_DISPATCH:
        "{{MESSAGE}} Please proceed to the dispatch office for details ",
      SEE_YOU_NEXT_TIME: "{{MESSAGE}} See you next time ",
      INVALID_QRCODE_SOURCE: "Invalid Appointment QR Code",
      INVALID_PO_LOADID: "Invalid PO or Load ID",
      INVALID_DC_CODE: "Invalid DC Code",
      DC58: {
        TID_TEXT_TO_INTERCOM_1: "Invalid PO; Please use intercom",
        TID_TEXT_TO_INTERCOM_2: "Invalid Temperature; Please use intercom",
        TID_TEXT_TO_INTERCOM_3: "Please use intercom",
        TID_TEXT_TO_INTERCOM_4: "Invalid Load ID; Please use intercom",
        TID_TEXT_TO_INTERCOM_5: "Plate Number not Detected; Please use intercom",
        TID_TEXT_TO_INTERCOM_6: "Error Validating PO or Load ID; Please use intercom",
        TID_TEXT_TO_ENTER_1: "Please Enter PO Number.",
        TID_TEXT_TO_ENTER_2: "Please Enter Load ID",
        TID_TEXT_TO_ENTER_TEMPERATURE_1: "Please Enter Reefer temperature",
        TID_TEXT_TO_EXIT: "Please exit the terminal",
        TID_TEXT_TO_LOCATION_1:
          "Entry Approved; Your allocated PAD is {{P1}}.Take the paperwork to the Receiving",
        TID_TEXT_TO_LOCATION_2: "Bobtail Entry Approved",
        TID_TEXT_TO_LOCATION_3: "Trailer Entry Approved",
        NO_INPROGRESS_CV_LANE_EVENT_FOUND:
          "No InProgress CV LaneEvent Found, Please use intercom",
        OCR_TRAILER_NUMBER_NOT_DETECTED: "Trailer Number is Not Detected By OCR",
        OCR_TRAILER_NUMBER_DETECTED_FOR_BOBTAIL:
          "Trailer Number is Detected By OCR for a Bobtail Appointment",
        APPOINTMENT_OCR_TRAILER_NUMBER_MISMATCH:
          "Trailer Number Read By OCR Does Not Match the Trailer Number in the Appointment",
        NSSL_GATE_IN_FAILED: "Gate Check In Failed. Please use intercom",
        NSSL_GATE_OUT_FAILED: "Gate Check Out Failed. Please use intercom",
        NSSL_DNU_TRAILER_FAILED: "Trailer is marked Do Not Use. Please use intercom",
      },
    },
    PORTCITY: {
      BOOKING_NUMBER_PROVIDED_NOT_VALID: "BookingNumber Provided is Not Valid",
      AFTER_HOURS_ENTRY:
        "For After Hours Entry, please use numerical keypad in Center Lane. Code provided by your dispatch",
      AFTER_HOURS_ENTRY_OUTBOUND:
        "For After Hours Departures, please pull forward. The Gates will open automatically",
      INVALID_EAIGLE_APPOINTMENT_RECORD: "Invalid Eaigle Appointment Record",
      INVALID_PROFILE_OR_EXPIRED_CREDENTIAL: "Invalid Profile or Expired Credential",
      IT_IS_NOT_A_BOBTAIL: "It is not a bobtail",
      IT_IS_NOT_AN_OUTBOUND_BOBTAIL: "It is not an outbound bobtail",
      LOADID_PROVIDED_IS_NOT_VALID: "LoadID Provided is Not Valid",
      NO_BOOKING_NUMBER_PROVIDED: "No Booking Number Provided",
      NO_INPROGRESS_CV_LANE_EVENT_FOUND: "No InProgress CV LaneEvent Found",
      NO_LOADID_PROVIDED: "No LoadID Provided",
      PICK_UP_BOL: "{{MESSAGE}} Pick up BOL between doors W025 & W027",
      PLEASE_CONTACT_SECURITY_TO_OPEN_GATE: "Please Contact Security to Open Gate",
      UNSUPPORTED_APPOINTMENT_TYPE: "Unsupported Appointment Type",
      UNSUPPORTED_OPERATION_TYPE: "Unsupported Operation Type",
    },
    TRIMAC: {
      NOT_A_VALID_REQUEST: "Not a valid request",
    },
    FAILED_TO_OPEN_GATE: "Failed to Open Gate",
    FAILED_TO_SEND_EMAIL: "Failed to Send Email",
    GATE_OPEN_FAILED: "Gate opening failed",
    INVALID_APPOINTMENT: "Invalid Appointment",
    APPOINTMENT_NOT_FOUND: "Appointment Not Found",
    EXPIRED_APPOINTMENT: "Expired Appointment",
    INVALID_QRCODE_FORMAT: "Invalid QRcode Format",
    INVALID_APPOINTMENT_ENTRY_TYPE: "Invalid Gate for Appointment",
    NO_VEHICLE_DETECTED: "No Vehicle Detected",
    FACILITY_ACCESS_DENIED: "You're not allowed to access this facility",
    YMS_INTEGRATION_ERROR: "YMS Integration Error",
    BAD_YMS_STATUS_FOR_CHECKOUT:
      "This trailer is forbidden for release due to its YMS status",
    BOBTAIL_TRAILER_DETECTED: "Detected trailer for Bobtail appointment",
    DRIVER_ACCESS_DENIED: "Entry denied at this time; Please contact Gate Operator",
    DRIVER_REGISTRATION_EXPIRED:
      "Driver registration is not valid. Please contact the gate operator.",
    FACILITY_LOOKUP_FAILED:
      "Unable to load site settings. Please contact the gate operator.",
    EXPECTED_TRAILER_NOT_DETECTED: "Expected trailer not detected",
    TRAILER_NUMBER_MISMATCH: "Incorrect number of trailers provided",
    APPOINTMENT_TYPE_MISMATCH: "Appointment Type Mismatch",
    BOL_MISMATCH: "Entered BOL does not match YMS record",
    INTERNAL_ERROR: "An unexpected internal error has occurred",
    ENTRY_APPROVED: "Entry Approved. Please Enter",
    EXIT_APPROVED: "Exit Approved. Please Exit",
    EBOL_DIGITAL_SIGNATURE_FAILED: "EBOL E-Signature Verification Failed",
  },
  CARRIER: {
    SCAC_AND_NAME: "{{SCAC}} ({{NAME}})",
    NAME_AND_SCAC: "{{NAME}} ({{SCAC}})",
    NAME_FIRST: "{{NAME}}",
  },
  CAMERA: {
    COMMAND: {
      CAPTURE: "Capture",
      CAPTURING: "Capturing...",
      SWITCH_CAMERA: "Switch Camera",
      TRY_AGAIN: "Try Again",
      TRY_BACK: "Try Back Camera",
      TRY_FRONT: "Try Front Camera",
    },
    ERROR: {
      BODY: "We couldn't access your camera. Please check permissions and try again.",
      HEADER: "Camera access error",
      NO_CAMERA:
        "No camera device accessible. Please connect your camera or try a different browser.",
      NO_SWITCH:
        "It is not possible to switch camera to different one because there is only one video device accessible.",
      PERMISSION_DENIED: "Permission denied. Please refresh and give camera permission.",
      UNSUPPORTED: "Canvas is not supported.",
    },
  },
  CATEGORY: {
    ACTUAL_TEMPERATURE: "Actual Temperature",
    ACTUAL_TEMPERATURE_F: "Actual Temperature °F",
    COMMENTS: "Comments",
    COMPANY: "Company information",
    DAMAGE_IMAGES: "Damage Images",
    DRIVER_ASSIST_REASON: "Driver Assist Reason",
    OTHER_DRIVER_ASSIST_REASON: "Other Driver Assist Reason",
    EBOL_SIGNATURE: "Bill of Lading Signature",
    EQUIPMENT_DETAILS: "Equipment Details",
    LOAD_DETAILS: "Load Details",
    PERSONAL: "Personal information",
    PURPOSE_DETAILS: "Purpose Details",
    REEFER_STATUS: "Reefer Status",
    REFUSAL_STATUS: "Refusal Status",
    REWORK_STATUS: "Rework Status",
    SAFETY: "Safety",
    SET_TEMPERATURE: "Set Temperature",
    SET_TEMPERATURE_F: "Set Temperature °F",
    SHIPPING_DETAILS: "Shipping Details",
    SHIPPING_DETAILS_WITH_VALIDATION: "Shipping Details with validation",
    SHIPPING_DETAILS_WITHOUT_VALIDATION: "Shipping Details without validation",
    VEHICLE_EQUIPMENT_DETAILS: "Vehicle/Equipment Details",
    VISIT_PURPOSE: "Purpose of Visit",
  },
  COMMAND: {
    ADD: "Add",
    ADD_NEW_DRIVER: "Add New Driver",
    APPLY: "Apply",
    APPROVE: "Approve",
    APPROVE_AND_OPEN_GATE: "Approve & Open Gate",
    BACK: "Back",
    BACK_TO_EVENTS: "Back to Events",
    CANCEL: "Cancel",
    CHECK_IN: "Check-in",
    CHECK_OUT: "Check-out",
    CHECKED_OUT: "Checked out",
    CLEAR: "Clear",
    CLEAR_SEARCH: "Clear search",
    CLEAR_SELECTION: "Clear selection",
    CLICK_TO_EDIT: "Click to edit",
    CLOSE: "Close",
    CLOSE_IMAGE_MODAL: "Close image modal",
    CLOSE_VIDEO_MODAL: "Close video modal",
    CONTINUE: "Continue",
    DELETE: "Delete",
    DELETE_GROUP: "Delete group",
    DOWNLOAD: "Download",
    DOWNLOAD_FAILED: "Download failed",
    EDIT: "Edit",
    ESCALATE: "Escalate",
    EXPORT: "Export",
    FILTER: "Filter",
    IMPORT: "Import",
    LIVE_MODE_OFF: "Live Mode Off",
    LIVE_MODE_ON: "Live Mode: Last 24 Hours",
    LOGOUT: "Logout",
    NEXT: "Next",
    NEW_CHECK_IN: "New Check-in",
    OK: "OK",
    OPEN_GATE: "Open Gate",
    PREVIOUS: "Previous",
    RESUME: "Resume Workflow",
    REFRESH: "Refresh",
    REJECT: "Reject",
    REMOVE: "Remove",
    REMOVE_DEPRECATED: "Remove Deprecated Parameters",
    RETURN: "Return",
    SELECT_END: "Select End",
    SELECT_START: "Select Start",
    SELECT_TEST_DATE: "Select Test Date",
    SSO_LOGIN: "Sign in with Azure AD",
    START_NEW_REGISTRATION: "Start New Registration",
    SAVE: "Save",
    SUBMIT: "Submit",
    TEST: "Test",
    TODAY: "Today",
    UPDATE: "Update All",
  },
  COMPONENTS: {
    COLOR_PICKER: {
      CLEAR_COLOR: "Clear color",
      SELECT_COLOR: "Select color",
    },
    PARAMETER_PANEL: {
      PARAMETER_TAG_PLACEHOLDER: "Type a value and press Comma or Enter to add it",
    },
    SPINNER: {
      PHRASES: [
        "Turning observations into insights",
        "Making manual work disappear",
        "Teaching cameras to do paperwork",
        "Taking a look in the yard",
        "Crunching vision data",
        "Thinking",
        "Computing",
        "Gathering data",
        "Analyzing",
        "Processing",
        "Working on it",
      ],
      LONG_WAIT_PHRASES: [
        "A few more things to check",
        "Just working through the last few details",
        "This is taking longer than expected",
        "Still working on it",
        "Hang tight, almost there",
        "Thanks for your patience",
        "Gathering everything up",
        "Just a bit longer",
      ],
    },
  },
  CTPAT: {
    CHECKLIST: {
      FRONT: "Front",
      RIGHT: "Right Side",
      ROOF: "Roof",
      FLOOR: "Floor/Undercarriage",
      LEFT: "Left Side",
      DOORS: "Doors",
    },
  },
  DATA: {
    DURATION_D_H_M_S: "{{DAYS}}d {{HOURS}}h {{MINS}}m {{SECS}}s",
  },
  DAY: {
    "0": "Sun",
    "1": "Mon",
    "2": "Tue",
    "3": "Wed",
    "4": "Thu",
    "5": "Fri",
    "6": "Sat",
  },
  EMAIL: {
    YARD_INVENTORY_SUBJECT:
      "Yard Inventory for {{COMPANY}} - {{FACILITY}} on {{REPORT_DATE}}",
    YARD_INVENTORY_BODY:
      "<p>Hello,</p>\n<p>Please find the daily yard inventory report for {{COMPANY}} - {{FACILITY}} on {{REPORT_DATE}} attached.</p>\nThanks,<br>\nEAIGLE Team<br>",
  },
  ERROR: {
    VIDEO_NOT_SUPPORTED: "Your browser does not support the video tag.",
  },
  ERROR_MODAL: {
    INVALID_X: "Invalid {{TITLE}}",
  },
  EVENT_STATUS: {
    APPROVED: "approved",
    FAILURE: "failure",
    INPROGRESS: "inprogress",
    INSPECTION_REQUIRED: "inspection required",
    PAUSED: "paused",
    REJECTED: "rejected",
    SUCCESS: "success",
  },
  FILE_TYPE: {
    CSV: "CSV",
    EXCEL: "Excel",
  },
  FILTER: {
    CARD: {
      EVENT_TYPE: "Event Type",
      STATUS: "Status",
      TIME: "Time",
      TRAILER_LOGO: "Trailer Logo",
    },
    EVENT_TYPE: {
      JB_HUNT: "JB Hunt",
    },
    LOGO: {
      AB: "AB",
      CD: "CD",
      DH: "DH",
      EF: "EF",
    },
    STATUS: {
      CLEAN: "Clean",
      DIRTY: "Dirty",
      EMPTY: "Empty",
      INBOUND: "Inbound",
      LOADED: "Loaded",
      OUTBOUND: "Outbound",
    },
    TIME: {
      LAST_24_HOURS: "L 24",
      LAST_MONTH: "L Month",
      LAST_WEEK: "L Week",
      LAST_YEAR: "L Year",
      TODAY: "Today",
    },
  },
  FORM_INPUT: {
    PREVIOUS: "Previous",
    NEXT: "Next",
    COMMAND: {
      ENTER_SCAC: "Click to enter SCAC manually",
      SELECT_SCAC: "Click to select from available SCAC codes",
      SHOW_LESS: "Show Less",
      SHOW_MORE: "Show More",
    },
    FIELD_IS_REQUIRED: "This field is required",
    NO_MATCHES: "No matches found",
    REQUIRED_LABEL: "{{TEXT}}*",
    SELECT: "Search or select...",
    SELECT_CARRIER: "Search or select carrier...",
    SELECT_DATE: "Select Date",
    SELECT_OPTIONS: "Select Options...",
    TRUNCATED: "{{TEXT}}...",
    TRAILER_SEARCH_HINT: "Please enter 3 characters to search",
    LOADING: "Loading…",
  },
  EBOL_SIGNING: {
    AWAITING_EMAIL: "Enter your email above to begin the signing ceremony.",
    AWAITING_INPUTS: "We need a few more details before signing can begin:",
    PHONE_LABEL: "Phone number",
    EMAIL_LABEL: "Email",
    OPTIONAL: "(optional)",
    REVIEW_ACCEPT: "Review & Accept the Shipment",
    RETRY: "Try again",
    SKIP_SIGNING: "Skip digital signing",
    SKIPPING: "Skipping digital signing…",
    LOADING: "Preparing your Bill of Lading for signing…",
    LOADING_PRECHECK: "Loading...",
    CONFIRM_HEADER: "Please confirm the following:",
    SEAL_NUMBER: "Seal number is {{SEAL}}.",
    TEMPERATURE_OK: "The temperature is within the acceptable range.",
    TEMPERATURE_OK_VALUE: "The temperature {{TEMP}}F is within the acceptable range.",
    ACCEPTANCE_NOTICE:
      "By accepting the Bills of Lading, you are confirming that the load is accurate and that you take responsibility for it during transit.",
    IFRAME_TITLE: "Bill of Lading Signature",
    COMPLETED: "Signature received. Submitting your appointment…",
    FIELDS: {
      FIRST_NAME: "First Name",
      LAST_NAME: "Last Name",
      EMAIL: "Email",
      SCAC: "Carrier (SCAC)",
      SEAL_NUMBER: "Seal Number",
      BOL_NUMBER: "BOL Number",
      ENTRY_TYPE: "Entry Type (Inbound/Outbound)",
      FACILITY: "Facility",
    },
    ERROR: {
      NOT_FOUND:
        "We couldn't find a Bill of Lading matching this load. Please verify your BOL number or see the MOTC.",
      BLOCKED: "Signing cannot proceed for this Bill of Lading. Please see the MOTC.",
      PREVIOUSLY_COMPLETED: "This Bill of Lading has already been signed.",
      FACILITY_MISMATCH:
        "This Bill of Lading isn't valid for this facility. Please see the MOTC.",
      GENERIC:
        "Something went wrong while preparing the signature. Please try again or see the MOTC.",
      CANCELED:
        "Signing was canceled. Please complete the signature to continue. If you need assistance, please see the MOTC.",
      FAILED: "Signing failed. Please try again or see the MOTC.",
    },
    AUTOMATED_SIGNING: {
      KRAFT: {
        CONSENT:
          "By accepting the BOLs you are confirming you have read all the BOLs below and agree with its contents",
      },
      CONSENT:
        "AUTOMATED_SIGNING placeholder consent text. By checking this box, I confirm that I have reviewed the Bill of Lading above, that the information is accurate, and that I authorize my signature below to be applied to the document on my behalf.",
      PREVIEW_LOADING: "Preparing your Bill of Lading preview…",
      PREVIEW_ERROR:
        "We couldn't load the Bill of Lading preview. Please try again or see the MOTC.",
      PRINTING: "Printing BOL",
      PRINT_COMPLETE: "BOL printed",
      VIEW_PREVIEW: "View Bill of Lading",
      SIGN_HERE: "Sign in the box below.",
      SIGN_INSTRUCTIONS: "Use your finger or mouse to draw your signature.",
      CLEAR: "Clear signature",
      SIGNATURE_TOO_SMALL:
        "Your signature is too small. Please sign again using more of the box.",
      SIGNATURE_REQUIRED: "Please sign before submitting.",
      SUBMIT: "Submit signature",
      SUBMITTING: "Submitting your signature…",
    },
  },
  FAILURE_PAGE: {
    HEADER: "Information Not Verified!",
    BODY: "Press the intercom button at the kiosk",
    FAILURE: "Failure",
    INTERCOM: "Intercom",
  },
  FORM_PAGE: {
    COMMAND: {
      NEXT: "Next",
      SUBMIT: "Submit",
    },
    ERROR: {
      UNABLE_TO_SUBMIT: "Unable to submit form. Please try again later.",
    },
    VALIDATING: "Validating...",
    UPLOADING: "Uploading {{percent}}%",
    PROCESSING: "Processing...",
  },
  EBOL_CAPTURE: {
    CAPTURED_ALT: "Captured e-BoL document",
    COMMAND: {
      CAPTURE: "Capture e-BoL",
      CAPTURING: "Capturing...",
      RETAKE: "Retake",
      UPLOAD_PHOTO: "Upload photo",
    },
    ERROR: {
      SAVE_FAILED: "Failed to save photo. Please try again.",
    },
    INSTRUCTIONS:
      "Position the e-BoL document within the frame and ensure it is readable.",
    PREVIEW_TIP:
      "Confirm the document is clear and readable, then upload the photo or retake.",
    PROCESSING: "Processing...",
  },
  IDCAPTURE: {
    COMMAND: {
      CAPTURE: "Capture ID",
      CAPTURING: "Capturing...",
      CHANGE_TYPE: "Change the ID type",
      DONE: "Done",
      RETAKE_PHOTOS: "Retake Photos",
      SUBMIT: "Submit",
      TRY_AGAIN: "Try Again",
      TRY_BACK: "Try Back Camera",
      TRY_FRONT: "Try Front Camera",
    },
    EMPLOYEE_ID_BACK: "Employee ID (Back)",
    EMPLOYEE_ID_BACK_ALT: "Employee ID Back",
    EMPLOYEE_ID_FRONT: "Employee ID (Front)",
    EMPLOYEE_ID_FRONT_ALT: "Employee ID Front",
    ERROR: {
      EXPIRED: "ID is expired. Please provide a valid ID.",
      EXPIRED_OR_UNREADABLE: "ID is either expired or unreadable.",
      GENERIC: "Something went wrong",
      UNREADABLE: "Could not read ID information.",
      UPLOAD_FAILED: "Failed to upload Employee ID images",
      UPLOAD_FAILED_TRY_AGAIN: "Failed to upload Employee ID images. Please try again.",
      VERIFY_FAILED_TRY_AGAIN: "Failed to verify ID. Please try again.",
    },
    ID_INFORMATION: "ID Information",
    ID_NOT_VERIFIED_MESSAGE:
      "We couldn't fully verify your ID. Please check the details below.",
    ID_NOT_VERIFIED_STATUS: "ID Verification Issues",
    ID_VERIFIED_MESSAGE: "Your identification has been verified successfully.",
    ID_VERIFIED_STATUS: "ID Verification Successful",
    INSTRUCTIONS: {
      DIGITAL_MX_CDL:
        "Digital Mexican CDLs are only supported in paper format. Photograph only the top half of the sheet.",
      DRIVERS_LICENSE:
        "Position your Driver's License within the frame and ensure good lighting.",
      EMPLOYEE_ID_BACK: "Now position the BACK of your Employee ID within the frame.",
      EMPLOYEE_ID_FRONT: "Position the FRONT of your Employee ID within the frame.",
    },
    PROCESSING: "Processing...",
    REMEMBER_ME: "Remember Me",
    SELECT_TYPE: "Select ID Type",
    TYPE: {
      DRIVERS_LICENSE: "Driver's License",
      EMPLOYEE_ID: "Employee ID",
    },
  },
  HINT: {
    CARRIER_NOT_LISTED_OTHER: "If your Carrier is not listed, please select OTHER.",
    CONFIRM_SEAL_NUMBER:
      "You are confirming that the seal is intact and physically matches the paperwork.",
    LOAD_ID_8_DIGITS: "Your Load ID is an 8-digit number that starts with 4",
    VISIT_TYPE_DROP_OPTIONS:
      "Drop & Go = Drop off a loaded trailer and departing without waiting or returning.\n\nDrop & Wait = Drop off a loaded trailer at the DC and return for empty pickup.",
    EDIT_SEAL_NUMBER: "* Edit the populated Seal number if needed.",
    OUTBOUND_BOL_LIVE: "Enter Outbound BOL if you are a Live Load",
    SCAC_NOT_LISTED_CPU9: "If your SCAC is not listed, please enter CPU9.",
    SCAC_NOT_LISTED_XXXX: "If your SCAC is not listed, please select XXXX.",
    EITHER_EMAIL_OR_PHONE: "You must provide either an email address or a phone number.",
    PO_NUMBER_NO_DASH:
      "Enter a single Purchase Order Number. Do not include dashes or digits after the dash -̶5̶8̶ . Valid PO’s start with 48 or 20, for example: 4871234567 or 2007123456.",
  },
  IMAGE_PREVIEW: {
    COMMAND: {
      RETAKE: "Retake",
      SUBMIT: "Submit",
    },
    CAPTURED_ID: "Captured ID",
    PLEASE_WAIT: "Please wait while we verify your information",
    PROCESSING_ID: "Processing your ID...",
    SUBMITTING: "Submitting...",
    TIP: "Make sure the image is clear and readable.",
  },
  KIOSK: {
    COMMAND: {
      REGISTER_NOW: "Register Now",
      SAVANNAH: "Register Here",
      ENTER: "Enter",
    },
    ERROR: {
      CONNECTION_CLOSED: "Connection closed",
      CONNECTION_ERROR: "Connection error",
      CONNECTION_LOST: "Connection lost",
      ENTRY_TYPE_INVALID: 'Entry Type "{{TYPE}}" is invalid',
      ENTRY_TYPE_MISSING: "Entry Type is missing",
      FAILED_TO_CONNECT: "Failed to establish connection",
      INFORMATION_NOT_VERIFIED_USE_INTERCOM: "Information Not Verified! Use Intercom",
      INTERACTION_TYPE_INVALID: 'Interaction Type "{{TYPE}}" is invalid',
      INTERACTION_TYPE_MISSING: "Interaction Type is missing",
      INVALID_OR_MISSING_PARAMS_HINT: "Invalid or missing entry parameters.",
      INTERMITTENT_CONNECTION:
        "Intermittent Connection Error\nIf the issue persists please contact EAIGLE support @ 1 888 771 1584",
      INTERMITTENT_CONNECTION_N:
        "Intermittent Connection Error {{N}}; If the issue persists please contact EAIGLE support @ 1 888 771 1584",
      MISSING_REQUIRED_INFO: "Missing required information",
      PROCESSING_ERROR: "Error in Processing your request. Use Intercom",
      RECONNECTING_AUTOMATICALLY: "Reconnecting automatically. Please wait.",
      VALIDATION_FAILED: "Validation process failed",
      VALIDATION_TIMEOUT: "Validation timeout",
    },
    VALIDATION: {
      PERSON_NAME: "Letters and spaces only",
      PHONE_NUMBER: "e.g., 1234567890",
    },
    EMAIL_SENT: "Email Sent",
    FOOTER: {
      NOT_REGISTERED: "Not Registered?",
      SAVANNAH: "Walmart Carrier--No Smart Phone?",
    },
    GATE_CLOSED: "Gate Closed",
    GATE_EXIT: "Exit Approved",
    GATE_OPEN: "Gate Open",
    GATE_OPEN_NEED_APPROVAL: "Entry Approved. Please wait for Gate Operator",
    WAIT_FOR_ENTRY_APPROVAL: "Please wait for entry approval",
    WAIT_FOR_ENTRY_APPROVAL_KEEP_DOOR_OPEN:
      "Please wait for entry approval. Keep the trailer door open.",
    STAPLES: {
      INBOUND_LOADED_DROP:
        "Entry Approved; Your allocated Slot is {{spot}}. Take the paperwork to the Receiving office. If it is closed, drop the Staples Copy of BOL in the box at Receiving office door.",
      INBOUND_LOADED_LIVELOAD:
        "Entry Approved; Your allocated door is {{spot}}. Take the paperwork to the Receiving office. If it is closed, drop the Staples Copy of BOL in the box at Receiving office door.",
      INBOUND_LOADED_RETURNS: "Entry Approved; Your allocated Slot is {{spot}}.",
      INBOUND_EMPTY_DROP: "Entry Approved; Your allocated Slot is {{spot}}.",
      INBOUND_EMPTY_PICKUP: "Entry Approved; Your door to pick up is {{spot}}.",
      INBOUND_BOBTAIL:
        "Entry Approved. Go to the shipping office to collect the necessary paperwork.",
      INBOUND_LAYOVER: "Please drop the trailer at Slot {{spot}}.",
      PROCEED_AFTER_GATE_OPEN: "Please proceed after the gate opens.",
      EXIT_DENIED: "Exit Denied! Please Contact Gate Operator",
      ENTRANCE_DENIED: "Entrance Denied! Please Contact Gate Operator",
    },
    INFORMATION_VERIFIED: "Information Verified!",
    INVALID_URL_PARAMETERS: "Invalid URL parameters",
    PLEASE_ROTATE_LANDSCAPE: "Please rotate your device to landscape mode",
    PLEASE_WAIT_X: "Please wait. {{TEXT}}",
    PRE_REGISTERED: "Pre-registered?",
    PROCEED_TO_EXIT: "Please proceed to exit",
    PROCEED_TO_ZONE: "Proceed to the assigned zone",
    REDIRECTING: "Redirecting...",
    REGISTRATION_COMPLETE: "Registration complete",
    REPRINT: {
      TITLE: "Reprinting BOL...",
    },
    SCAN_QR_AT_GATE: "Scan this code at the gate",
    SCAN_QR_CODE:
      "Hold your pre-registered <br/> QR code to the kiosk for <br/> scanning.",
    SECONDS_REMAINING: "{{N}} seconds remaining",
    SIGNING: {
      TITLE: "Please sign your Bill of Lading",
      BOL_NUMBER: "BOL: {{BOL}}",
    },
    TEST_PAGE_PRINTED: "Successfully printed test page",
    KEY: {
      BACKSPACE: "Backspace",
      CLEAR: "Clear",
      CLOSE: "Close",
    },
    KEY_PAD_INSTRUCTIONS: "Enter OTP",
    TROUBLE_SCANNING_QR_CODE:
      "Trouble Scanning QR Code - Press here to key in Appointment Code Manually",
    VERIFYING_INFORMATION: "Verifying Information...",
    VIDEO_NOT_AVAILABLE: "Live video not available",
    VIDEO_PLAYER_FAILED: "Live video unavailable",
    WAIT_VERIFY_QR: "Please wait for the QR code to be verified",
    WAIT_VERIFY_INFO: "Please wait while we verify your information",
  },
  LABEL: {
    ACTION: "Action",
    NO_DATA: "No data",
    ADD_ASSET_TO_YARD_INVENTORY: "Add Asset to Yard Inventory",
    ADD_TRAILER: "Add Trailer",
    ADD_GROUP: "Add group",
    ADD_NEW_GROUP: "Add new group",
    ADD: "Add",
    ALL: "All",
    ANALYTICS: "Analytics",
    APPOINTMENT_DATA: "Appointment Data *",
    APPROVED: "Approved",
    AREA: "Area",
    ASSETS: "Assets",
    C3YMS: "C3 YMS",
    CARRIER: "Carrier",
    CARRIER_NAME: "Carrier Name",
    CHASSIS_NUMBER: "Chassis Number",
    CHASSIS_PLATE_NUMBER: "Chassis Plate Number",
    CHECK_ICON: "Check icon",
    CHECK_IN_TIME: "Check-in Time",
    CHECK_OUT_TIME: "Check-out Time",
    CLICK_TO_UPLOAD_LOGO: "Click to upload logo",
    ADMIN: "Admin",
    DEFAULT: "Default",
    INVALID_NUMBER: "Invalid number",
    SYSTEM_HEALTH: "System Health",
    SYSTEM_HEALTH_SUBTITLE: "Internal kiosk and lane monitoring",
    SYSTEM_HEALTH_LOAD_ERROR: "Failed to load system health data.",
    SYSTEM_HEALTH_RETRY: "Retry",
    SYSTEM_HEALTH_REFRESH: "Refresh",
    SYSTEM_HEALTH_LAST_UPDATED: "Last updated {{time}}",
    SYSTEM_HEALTH_STATUS_HEALTHY: "Healthy",
    SYSTEM_HEALTH_STATUS_DEGRADED: "Degraded",
    SYSTEM_HEALTH_STATUS_UNHEALTHY: "Unhealthy",
    SYSTEM_HEALTH_STALE_LANES_TITLE: "Lanes need attention",
    SYSTEM_HEALTH_STALE_LANES_DESCRIPTION:
      "{{count}} of {{total}} lanes have had no CV lane events in the last {{minutes}} minutes.",
    SYSTEM_HEALTH_ALL_CLEAR:
      "All lanes have reported activity in the last {{minutes}} minutes.",
    KIOSK_STATUS: "Kiosk Status",
    LAST_LANE_EVENT_TIME: "Last Lane Event",
    EVENTS_LAST_HOUR: "Events (Last Hour)",
    LANE_ACTIVITY: "Activity",
    KIOSK_UP: "Up",
    KIOSK_DOWN: "Down",
    LANE_ACTIVE: "Active",
    NO_RECENT_LANE_ACTIVITY: "No events in the last {{N}} minutes",
    NO_LANES_FOUND: "No lanes found for this facility.",
    CONFIRM_DELETE: "Confirm Delete",
    CONTAINER: "Container",
    CV_EVENT_PARAMETERS: "Lane Event Cv parameters",
    DEGREE_FAHRENHEIT: "°F",
    DELETE_CANNOT_UNDO: "This action cannot be undone.",
    DATE_TIME_TZ: "{{DATE_TIME_TZ}}",
    DETENTION_TIME: "Detention Time",
    INDICATORS: "Indicators",
    DETENTION_TIME_HOURS: "Detention Time (Hrs)",
    DISCARD: "Discard",
    DRIVERS: "Drivers",
    EBOL: "EBOL",
    DRYVAN: "Dry Van",
    DURATION: "Duration",
    EDITED: "Edited",
    EDIT_SELECT: "Edit select",
    ENTER_OTP_CODE: "Enter OTP code",
    ERROR_ICON: "Error icon",
    EVENT_VALIDATION_IN_PROGRESS: "Event validation is in progress. Keep this page open",
    FILTERS: {
      FILTER_MENU: {
        MORE_FILTERS: "More Filters",
        FILTERS: {
          TAB: "Filters",
          TITLE: "More Filters",
          DESCRIPTION: "Refine table results",
        },
        VISIBILITY: {
          TAB: "Visibility",
          TITLE: "More Filters",
          DESCRIPTION: "Choose where each filter appears",
          FILTER_HEADER: "Quick Filter",
          CARD_HEADER: "KPI Card",
        },
      },
      FILTER_COLUMN_MENU: {
        LABEL: "Columns",
        TITLE: "Columns",
        DESCRIPTION: "Toggle columns",
        OFF: "Off",
      },
      SELECT: "Select...",
      SELECT_OPTION: "Select an option",
      SELECTED: "Selected",
      SEARCH: "Search...",
      SEARCH_OPTIONS: "Search options",
      NO_RESULTS: "No results.",
      NO_OPTIONS: "No options.",
      CLEAR_FILTER: "Clear filter",
      DATE_RANGE: {
        START_DATE: " Start Date",
        END_DATE: "End Date",
      },
      DONE: "Done",
      CLEAR: "Clear",
      RESET: "Reset",
      APPLY: "Apply",
      MIN: "Min",
      MAX: "Max",
      HOURS_ABBR: "hrs",
      DATE_RANGE_FILTER: "Date Range",
      END_BEFORE_START_ERROR: "End date/time must be on or after the start date/time",
    },
    APPROVING: "Approving...",
    ESCALATING: "Escalating...",
    RESUMING: "Resuming...",
    EVENT_CREATED: "Event created successfully",
    EVENT_WAS_NOT_CREATED: "Event was not created, try once more",
    MON: "Mon",
    TUE: "Tue",
    WED: "Wed",
    THU: "Thu",
    FRI: "Fri",
    SAT: "Sat",
    SUN: "Sun",
    START: "Start",
    END: "End",
    SELECT_TIME: "Select time",
    TO: "to",
    FIRST_NAME_LAST_NAME: "{{FIRST}} {{LAST}}",
    FLATBED: "Flatbed",
    FROM_DATE_TIME_TZ: "From: {{DATE_TIME_TZ}}",
    GATE_LOG: "Gate Log",
    GATE_OPEN: "Gate Opened",
    ISO_CODE: "ISO Code",
    INTERMODAL: "Intermodal",
    LAUNCH_CTPAT_INSPECTION: "Launch CTPAT Inspection",
    INCLUDE_TEST_IMAGE: "Include Test Image",
    INCLUDE_TEST_DAMAGE_IMAGE: "Include Test Damage Image",
    INCLUDE_TEST_REJECTED_DAMAGE_IMAGE: "Include Test Rejected Damage Image",
    INCLUDE_TEST_VIDEOS: "Include Test Videos",
    LANE: "Lane",
    LANE_REQUIRED: "LANE *",
    LIVE: "Live",
    LOCATION: "Location",
    CONTAINERS_IN_YARD: "Containers in yard",
    TRAILERS_IN_YARD: "Trailers in yard",
    CREATE_CTPAT_EVENT: "Create as CTPAT Event",
    CTPAT_FACILITY_NOT_CONFIGURED:
      "Selected facility is not configured for CTPAT inspections",
    NO_APPOINTMENT_DATA_PROVIDED:
      "No appointment data provided, upload QR-code or provide OTP Code",
    NO_OPTIONS: "No options",
    No_RESULTS_FOUND: "No results found",
    NO_TRAILERS_ADDED: "No trailers added. Click + to add a trailer.",
    NONE: "None",
    NOT_APPLICABLE: "N/A",
    OFF: "Off",
    OPENING: "Opening...",
    OR: "or",
    PAGINATION: {
      LABEL: "Pagination",
      NEXT: "Next page",
      PREV: "Previous Page",
      START: "Start",
      END: "End",
      ROWS_PER_PAGE: "Rows per page",
    },
    PARAMETERS: "Parameters",
    PLATE_NUMBER: "Plate Number",
    PNG_JPG_SVG_RECOMMENDED: "PNG, JPG, SVG recommended",
    POWER_UNIT_DATA_DEFAULT_VALUES:
      "Power Unit Data - if no data provided default values are used",
    POWER_UNIT_NUMBER: "Power Unit Number",
    POWER_UNIT_TYPE: "Power Unit Type",
    PROVIDE_ALL_REQUIRED_DATA: "Provide all required data",
    QR_CODE_READING_FAILURE:
      "Failed to read uploaded QR-code please provide one using input field",
    REEFER: "Reefer",
    REGISTRATION: "Registration",
    REMOVE: "Remove",
    REPLACE: "Replace",
    ROW: "Row",
    SEARCH: "Search",
    SECTION_N: "{{SECTION}} {{N}}",
    SELECT_A_LANE: "Select a lane",
    SELECT_DATES: "Select dates",
    SETTINGS: "Settings",
    SHOWING_N_OF_COUNT_RECORDS_one: "Showing {{N}} of {{count}} Record",
    SHOWING_N_OF_COUNT_RECORDS_other: "Showing {{N}} of {{count}} Records",
    SHOWING_RANGE: "Showing {{start}}-{{end}} of {{total}}",
    SIGN_IN_DOMAIN: "Sign in with",
    SIMULATE_LANE_EVENT: "Simulate Lane Event",
    CREATE_SIMULATED_CV_LANE_EVENT: "Create simulated CV lane event (No scan)",
    SIMULATION_MISC: "Miscellaneous",
    SPOT: "Spot",
    STAY: "Stay",
    STEP_N: "Step {{N}}",
    TANKER: "Tanker",
    TABLE_PAGINATION: "Table pagination",
    TEST_SIMULATION: "Testing",
    TIME: "Time",
    TIME_STAMP: "Time Stamp",
    TO_DATE_TIME_TZ: "To: {{DATE_TIME_TZ}}",
    TRAILER_N: "Trailer {{n}}",
    TRAILER_NUMBER: "Trailer Number",
    TRAILER_TYPE: "Trailer Type",
    TRAILERS: "Trailers",
    UNIT: "Unit",
    UNIT_1: "Unit 1",
    UNIT_HISTORY: "Unit History",
    UNIT_ID: "Unit ID",
    UNIT_TYPE: "Unit Type",
    UPLOAD_QR_CODE: "Upload QR-code",
    UPLOADED_SUCCESSFULLY: "Uploaded successfully",
    USDOT: "USDOT",
    YARD_CHECK: "Yard Check",
    YARD_INVENTORY: "Yard Inventory",
    ZOOMABLE_TYPE: "Zoomable {{TYPE}}",
    EDIT_TRAILER: "Edit trailer",
    DELETE_TRAILER: "Delete trailer",
    UPLOAD_CSV: "Upload CSV",
    UPLOAD: "Upload",
    UPLOADING: "Uploading…",
    TRAILER: "trailer",
    TRAILER_ADDED: "Trailer added",
    TRAILER_UPDATED: "Trailer updated",
    TRAILERS_ADDED_COUNT: "{{count}} trailer(s) added successfully.",
    UPLOAD_CSV_DESCRIPTION:
      "Upload a CSV with columns: trailer number, chassis number, length. First row may be a header.",
    NO_VALID_TRAILER_ROWS: "No valid trailer rows found in the CSV.",
    NO_VALID_CSV_ROWS: "No valid rows found in the CSV.",
    NO_ASSETS_FOUND: "No assets found",
    NO_RESULTS: "No results",
    SEARCH_TRAILER_NUMBER: "Search trailer number…",
    TRAILERS_COUNT_LABEL: "trailers",
    PLACEHOLDER_TRAILER_NUMBER: "e.g. TRL-227",
    PLACEHOLDER_CHASSIS_NUMBER: "e.g. CH-227",
    PLACEHOLDER_LENGTH: "e.g. 20",
    DELETE_FAILED: "Delete failed",
    SAVE_FAILED: "Save failed",
    SAVING: "Saving...",
    TRAILER_CONTAINER_NUMBER: "Trailer / Container #",
    EDIT: "Edit",
    DELETE: "Delete",
    CANCEL: "Cancel",
    CHASSIS: "Chassis",
    FIELD_REQUIRED: "This field is required.",
    LENGTH: "Length",
    MORE_ACTIONS: "More actions",
    NEW_TRAILER: "New Trailer",
    NEXT: "Next",
    NEXT_PAGE: "Next page",
    OF: "of",
    PAGE: "Page",
    PREVIOUS: "Previous",
    PREVIOUS_PAGE: "Previous page",
    ROWS_PER_PAGE: "Rows per page",
    RESULTS_PER_PAGE: "Results per page",
    SAVE: "Save",
    UNSAVED_CHANGES_DISCARD:
      "You have unsaved changes in this draft. Switching tabs will discard them.",
    "–": "–",
    YARD_MAP: "Yard Map",
  },
  ASSETS: {
    NO_ASSETS: "No assets",
    NO_TYPES_FOUND: "No asset types found. Add assets to get started.",
    NO_PARAMETERS_FOUND: "No asset parameters found. Add assets to get started.",
    SELECT_FACILITY_HINT:
      "Please confirm the correct facility is selected. Please select a correct facility and refresh the page.",
    CONTACT_ADMIN: "If the problem persists, please contact the administrator.",
    CSV_ROW_INVALID: "Row {{row}}: invalid value for {{field}}",
    RELOAD_PAGE: "Reload Page",
    SELECT_ASSET_TYPE: "Select an asset type to view",
    NO_TRAILERS_YET: "No trailers yet",
    NO_TRAILER_MATCHES: "No matching trailers found",
    NO_MATCHES: "No matches",
    NONE_YET: "Nothing here yet",
    TOAST: {
      SAVE_FAILED: "Couldn't save. Try again.",
      UPDATE_FAILED: "Update failed. Try again.",
      TRAILER_DELETED: "Trailer `{{trailerNumber}}` deleted",
      TRAILER_UPDATED: "Trailer `{{trailerNumber}}` updated",
      ASSET_UPDATED: "`{{name}}` updated",
      ASSET_DELETED: "`{{name}}` deleted",
    },
    CONFIRM_NEW_TYPE_TITLE: "Create asset type?",
    CONFIRM_NEW_PARAM_TITLE: "Add new parameter?",
    TRY_ADJUSTING_SEARCH: "Try adjusting your search to find a matching asset.",
    NOT_FOUND: "No {{object}} found",
    PARAMETERS_LABEL: "Parameters",
    IDENTIFIER: "Identifier – used to uniquely label each asset",
    NEW_ASSET: "New {{asset}}",
    ADD_ASSET: "Add a new {{asset}}",
    ADD_PARAMETER: "Add parameter",
    ADD_PARAMETERS: "Add Parameters",
    NEW_PARAMETERS: "New Parameters",
    CREATE_ASSET_TYPE: "Create New Asset Type",
    NEW_ASSET_TYPE_NAME: "Name",
    ASSET_ADDED: "Asset {{key}} added",
    ASSET_CREATED: "Asset {{name}} created",
    ASSET_UPDATED: "Asset {{name}} updated",
    PARAM_REQUIRED: "{{asset}} required",
    PARAM_EMPTY: "Parameter name is required",
    PARAM_DUPLICATE: "Parameter already exists",
    PARAM_TYPES: {
      string: "String",
      number: "Number",
      boolean: "Boolean",
    },
    SELECT_PARAM_TYPE: "Select parameter type",
    ASSET_NAME_REQUIRED: "Name is required",
    UNKNOWN_ASSET: "Unknown Asset",
    UNKNOWN_PARAMETER: "Unknown Parameter",
    ASSETS_ADDED_COUNT: "{{count}} asset(s) added successfully.",
    USE_FORM_TO_ADD_FIRST: "Use the form to add your first entry.",
    ASSETS_COUNT_LABEL: "assets",
    UPLOAD_CSV_DESCRIPTION:
      "Upload a CSV with columns: {{columns}}. First row may be a header.",
    TRAILER: {
      LABEL: "Trailer",
      LABEL_PLURAL: "Trailers",
      PARAMETERS: {
        TRAILERNUMBER: "Trailer Number",
        CHASSISNUMBER: "Chassis Number",
        LENGTH: "Length",
        MAXWEIGHTTONNES: "Max Weight Tonnes",
      },
      PLACEHOLDER: {
        TRAILERNUMBER: "Trailer Number",
        CHASSISNUMBER: "Chassis Number",
        LENGTH: "Length",
        MAXWEIGHTTONNES: "Max Weight Tonnes",
      },
    },
    CONTAINER: {
      LABEL: "Container",
      LABEL_PLURAL: "Containers",
      PARAMETERS: {
        NUMBER: "Number",
      },
      PLACEHOLDER: {
        NUMBER: "Number",
      },
    },
    SILO: {
      LABEL: "Silo",
      LABEL_PLURAL: "Silos",
      PARAMETERS: {
        LANE: "Lane",
        NAME: "Name",
        BLOCK: "Block",
      },
      PLACEHOLDER: {
        LANE: "Lane",
        NAME: "Name",
        BLOCK: "Block",
      },
    },
    PRODUCT: {
      LABEL: "Product",
      LABEL_PLURAL: "Products",
      PARAMETERS: {
        NAME: "Name",
        SHOWINDRIVERS: "Show In Drivers",
        PRODUCTCODE: "Product Code",
        HSCODE: "Hs Code",
        USDPERTON: "Usd Per Ton",
        PRODUCTDESCRIPTION: "Product Description",
      },
      PLACEHOLDER: {
        NAME: "Name",
        SHOWINDRIVERS: "Show In Drivers",
        PRODUCTCODE: "Product Code",
        HSCODE: "Hs Code",
        USDPERTON: "Usd Per Ton",
        PRODUCTDESCRIPTION: "Product Description",
      },
    },
  },
  MONTH: {
    "1": "January",
    "2": "February",
    "3": "March",
    "4": "April",
    "5": "May",
    "6": "June",
    "7": "July",
    "8": "August",
    "9": "September",
    "10": "October",
    "11": "November",
    "12": "December",
  },
  NAVBAR: {
    COMMAND: {
      PREVIOUS: "Previous",
    },
    DRIVER_REGISTRATION: "Driver Registration",
    LOGO: "Logo",
  },
  PASSCODE_PAGE: {
    COMMAND: {
      VERIFY: "Verify",
    },
    ENTER_PASSCODE: "Enter passcode",
    ERROR: {
      INVALID_PASSCODE: "Invalid passcode",
    },
  },
  ANSWER: {
    CARRIER: {
      LCL: "LCL",
      "3PL": "3PL",
      MEAT: "MEAT",
      DSD: "DSD",
      GFS: "GFS",
      BREAD: "BREAD",
      FLOWERS: "FLOWERS",
      PEPSI: "PEPSI",
      COKE: "COKE",
    },
    CARRIER_TYPE: {
      THIRD_PARTY: "Third Party",
      DOMICILE: "Domicile",
    },
    DRIVER_ASSIST_REASON: {
      DRIVER_OLD_PHONE: "Driver Old phone",
      DRIVER_LICENSE_NOT_SCANNING: "Driver License Not Scanning",
      DRIVER_CAMERA_NOT_SCANNING_QR: "Driver Camera Not Scanning QR",
      DRIVER_REFUSES: "Driver Refuses",
      TURNAROUND_OFFICE_CLOSED:
        "Turnaround (Outbound lane: Live appointment but office is closed, Inbound full on the exit lane)",
      TURNAROUND_WRONG_BUILDING:
        "Turnaround (Wrong building – with a trailer, bobtail [Back out on inbound])",
      TURNAROUND_BOBTAIL_LUNCH:
        "Turnaround (Bobtail in because of lunch and OB live load)",
      TURNAROUND_REWORK_IN: "Turnaround: Rework IN",
      WALMART_DRIVERS: "Walmart Drivers",
      LANGUAGE_BARRIER: "Language Barrier",
      OTHER: "Other (please fill section)",
    },
    DRIVER_TYPE: {
      CONTRACTOR: "Contractor",
      DELIVERY: "Delivery",
      FLEET_DRIVER: "Fleet Driver",
      GULFSTREAM: "Gulfstream",
      MAINTENANCE: "Maintenance",
      PERSONAL_VEHICLE: "Personal Vehicle",
      SERVICE: "Service",
      SHUNT_DRIVER: "Shunt Driver",
      SHUTTLE_DRIVER: "Shuttle Driver",
    },
    FROM_FACILITY: {
      DSD_ROUTE: "DSD-Route",
      LINEHAUL_ROUTE: "Linehaul route",
    },
    LOAD_STATUS: {
      PARTIALLY_LOADED: "Partially Loaded",
      TRAILER_EMPTY: "Trailer Empty",
    },
    SUB_LOAD_TYPE: {
      CASES: "Cases",
      FRESH_RETURNS: "Fresh Returns",
    },
    CONTINUE_LOADING: {
      CONTINUE: "Continue loading",
      PAUSE: "Pause loading",
    },
    DUNNAGE: {
      NONE: "None",
      "1_4": "1/4",
      "1_2": "1/2",
      "3_4": "3/4",
      FULL: "Full",
    },
    ENTRY_PURPOSE: {
      APPOINTMENT: "Appointment",
      BOBTAIL: "Bobtail",
      CARRIER_LOADED: "Carrier Loaded",
      CLEANOUT: "Cleanout",
      CONTRACTOR: "Contractor",
      CONTRACTOR_VISITOR: "Contractor/Visitor",
      DROP: "Drop",
      PICKUP: "Pickup",
      LIVELOAD: "Liveload",
      RETURNS: "Returns",
      LTL: "LTL",
      DROP_EMPTY: "Drop Empty",
      DROP_HOOK: "Drop Hook",
      DROP_MISC: "Drop Miscellaneous",
      DELIVERY: "Delivery",
      EMPTY: "Empty",
      EMPTY_TRAILER: "Empty Trailer",
      FOODBANK: "Foodbank",
      FUEL: "Fuel",
      GARBAGE_COLLECTION: "Garbage collection",
      INBOUND_BOBTAIL_OUTBOUND_BOBTAIL: "Inbound Bobtail / Outbound Bobtail",
      INBOUND_BOBTAIL_OUTBOUND_TRAILER: "Inbound Bobtail / Outbound Trailer",
      INBOUND_TRAILER_OUTBOUND_BOBTAIL: "Inbound Trailer / Outbound Bobtail",
      INBOUND_TRAILER_OUTBOUND_TRAILER: "Inbound Trailer / Outbound Trailer",
      IN_TRANSIT: "In transit",
      LAYOVER: "Layover",
      LIVE_LOAD: "Live Load",
      LOADED: "Loaded",
      MISC: "Miscellaneous",
      NFI_LOADED: "NFI Loaded",
      OTHERS: "Others",
      PARKING: "Parking",
      PICK_UP: "PickUp",
      PICKUP_EMPTY: "Pickup Empty",
      PICKUP_LOAD: "Pickup Load",
      PLANT_LOADED: "Plant Loaded",
      PRIVATE: "Private",
      SPECIAL_EQUIPMENT: "Special Equipment",
      TURN_AROUND: "Turn Around",
      VISITOR: "Visitor",
      REPAIR: "Repair",
      WAAS_FAAS: "WAAS/FAAS",
      WASH: "Wash",
      WITH_TRAILER: "With Trailer",
      SERVICE: "Service",
      USPS: "USPS",
      UPS: "UPS",
      FEDEX: "Fedex",
      CHARITY_DONATION: "Charity Donation",
      TJX: {
        FACILITIES: "Facilities",
        PROJECT: "Project",
        SUPPLIES_CORRUGATE: "Supplies / Corrugate",
        SUPPLIES: "Supplies",
        CORRUGATE: "Corrugate",
        BRS: "BRS",
        BRS_LTL: "BRS / FEDEX / UPS / LTL",
        FEDEX_UPS_LTL: "FEDEX / UPS / LTL",
        LOADED_IN: "Loaded In",
        LOADED_OUT: "Loaded Out",
        EMPTY_IN: "Empty In",
      },
    },
    ENTRY_TYPE: {
      CONTRACTOR: "Contractor",
      INBOUND: "Inbound",
      INBOUND_ARRIVAL: "Inbound / \nArrival",
      INBOUND_DROP: "Inbound / Drop",
      MAINTENANCE: "Maintenance",
      MISCELLANEOUS: "Miscellaneous",
      OUTBOUND: "Outbound",
      OUTBOUND_DEPARTURE: "Outbound / \nDeparture",
      OUTBOUND_PICKUP: "Outbound / Pickup",
      WALMART_CARRIERS: "Walmart Carriers",
      YARD_STORAGE: "Yard Storage",
      VENDORS_COURIERS: "Vendors / Couriers",
    },
    AWG: {
      PALLET_PLASTIC_CARDBOARD: "Pallet / Plastic / Cardboard Loads",
      ITEM_TYPE: {
        PALLET: "Pallet",
        CARDBOARD: "Cardboard",
        PLASTIC: "Plastic",
        PRODUCT_RECOVERY: "Product Recovery",
      },
      VISIT_LOCATION: {
        WAREHOUSE: "Warehouse",
        GARAGE: "Garage",
        FUEL: "Fuel",
        DISPATCH: "Dispatch",
        OTHER: "Other",
      },
    },
    CIMENTOS: {
      WEIGHT_ENTRY_MODE: {
        NET: "Net Weight",
        GROSS: "Gross Weight",
      },
    },
    INITIATE_LOADING: {
      START: "Start or continue loading",
      STOP: "Stop loading and create BOL",
    },
    PEPSI: {
      DROP_LOAD_APPOINTMENT: "Drop load",
      LIVE_LOAD_APPOINTMENT: "Live load",
      EMPTY_DROPS_NO_APPOINTMENT: "Empty drops",
      DROPS_MISCELLANEOUS_NO_APPOINTMENT: "Drops - Miscellaneous",
      LOADED_TRAILER: "Loaded Trailer",
      EMPTY: "Empty",
      MISCELLANEOUS_NO_APPOINTMENT: "Miscellaneous",
      VISITORS_CONTRACTORS: "Visitors / Contractors",
      KIOSK: {
        DROP_LOAD_APPOINTMENT: "Drop w/ appointment",
        LIVE_LOAD_APPOINTMENT: "Live w/ appointment",
        EMPTY_DROPS_NO_APPOINTMENT: "Empty drops",
        DROPS_MISCELLANEOUS_NO_APPOINTMENT: "Miscellaneous",
        VISITORS_CONTRACTORS: "Visitors / Contractors",
      },
    },
    STAPLES: {
      LOAD_TYPE: {
        MISC_SHIPMENT: "Misc Shipment",
        RETAIL_STORE_DELIVERY: "Retail Store Delivery",
        RETURN_TO_VENDOR: "Return to Vendor",
        LIQUIDATION: "Liquidation",
        TRANSFERS: "Transfers",
        OUTBOUND_CROSSDOCK: "Outbound Crossdock",
        DONATIONS: "Donations",
      },
    },
    DILLARDS: {
      PRIVATE_FLEET: "Dillards Private Fleet",
    },
    EQUIPMENT_LENGTH: {
      "20": "20",
      "24": "24",
      "28": "28",
      "30": "30",
      "35": "35",
      "36": "36",
      "40": "40",
      "48": "48",
      "53": "53",
      "60": "60",
      STRAIGHT_TRUCK_TAILGATE: "Straight Truck Tailgate",
      STRAIGHT_TRUCK_NON_TAILGATE: "Straight Truck Non-Tailgate",
    },
    EQUIPMENT_TYPE: {
      BOBTAIL: "Bobtail",
      CHASSIS: "Chassis",
      CHILLER: "Chiller",
      CONTAINER: "Container",
      FLATBED: "Flatbed",
      GENERATOR: "Generator",
      HST: "Hard-sided Trailer (HST)",
      MULTI_TRAILER: "Multi Trailer",
      TRAILER_TANKER: "Trailer",
      REEFER: "Reefer",
      REGULAR_VEHICLE: "Regular Vehicle",
      SST: "Soft-sided Trailer (SST)",
      TANKER: "Tanker",
      TRACTOR: "Tractor",
      VAN: "Van",
      OTHER: "Other",
    },
    FACILITY: {
      MDC: "MDC",
      MDC_TEST: "MDC Test",
      OSHAWA: "Oshawa",
      OSHAWA_TEST: "Oshawa Test",
    },
    FUEL_LEVEL: {
      EMPTY: "Empty",
      "1_8": "1/8",
      "1_4": "1/4",
      "3_8": "3/8",
      "1_2": "1/2",
      "5_8": "5/8",
      "3_4": "3/4",
      "7_8": "7/8",
      FULL: "Full",
    },
    GENERIC: {
      YES: "YES",
      NO: "NO",
    },
    LOAD_DETAILS: {
      DRY: "DRY",
      FROZEN: "FROZEN",
      "MULTI TEMP": "MULTI TEMP",
      HEAT: "HEAT",
      REEFER: "REEFER",
      CONVERTER_1X: "CONVERTER_1X",
      CONVERTER_2X: "CONVERTER_2X",
    },
    LOADED_STATUS: {
      EMPTY: "Empty",
      LOADED: "Loaded",
    },
    LOAD_TYPE: {
      EMPTY: "Empty",
      LOADED: "Loaded",
      BOBTAIL: "Bobtail",
      OTHERS: "Others",
      REFRIGERATED: "Refrigerated",
    },
    PURPOSE_OF_VISIT: {
      FACILITIES: "Facilities",
      FEDEX: "Fedex",
      OTHER: "Other",
      PICKUPS: "Pickups",
      PROJECT: "Project",
      REPAIRS: "Repairs",
      USPS: "USPS",
    },
    REEFER: {
      ON: "On",
      OFF: "Off",
    },
    TRAILER_PRECENSE: {
      YES: "Yes",
      NO: "No",
      ONE_TRAILER: "One",
      TWO_TRAILERS: "Two",
    },
    TRAILER_TYPE: {
      DRY: "Dry",
      HEATER: "Heater",
      REEFER: "Reefer",
      BARN: "Barn",
      BARN_DOOR_REEFER: "Barn Door Reefer",
      BARN_DOOR_DRY: "Barn Door Dry",
      BARN_DOOR_HEATER: "Barn Door Heater",
      ROLL_UP: "Roll-up",
      ROLL_UP_DRY: "Roll Up Dry",
      ROLL_UP_REEFER: "Roll Up Reefer",
      ROLL_UP_HEATER: "Roll Up Heater",
      MULTI_TEMP: "Multi Temp",
      TJX: {
        "45_FT_TRAILER": "45 FT TRAILER",
        "48_FT_TRAILER": "48 FT TRAILER",
        CONTAINER: "Container",
        E_TRACK_ROLL_DOORS: "E-Track Roll Doors",
        E_TRACK_SWING_DOORS: "E-Track Swing Doors",
        FLATBED: "Flatbed",
        LIFT_GATES: "Lift Gates",
        PUPS: "PUPS",
        ROLL_DOORS: "Roll Doors",
        SWING_DOORS: "Swing Doors",
      },
      WALMART: {
        "48BARN": "48 BARN",
        "48REEFER": "48 REEFER",
        "48ROLL": "48 ROLL",
        "53BARN": "53 BARN",
        "53HEATER": "53 HEATER",
        "53REEFER": "53 REEFER",
        "53ROLL": "53 ROLL",
        "53TriaxleB": "53 Triaxle BARN",
        "53TriaxleR": "53 Triaxle ROLL",
        "60ROLL": "60 ROLL",
        STORAGE: "STORAGE",
        STR: "Straight Truck or Box truck",
      },
    },
    USAGE: {
      INBOUND_SINGLE: "Single Usage (Inbound)",
      INBOUND_MULTIPLE: "Multiple Usage (Inbound)",
      OUTBOUND_SINGLE: "Single Usage (Outbound)",
      OUTBOUND_MULTIPLE: "Multiple Usage (Outbound)",
    },
    VEHICLE_TYPE: {
      BOBTAIL: "Bobtail",
      TRAILER: "Trailer",
    },
    VISIT_TYPE: {
      DROP_AND_GO: "Drop & Go",
      DROP_AND_GO_SUBLABEL: "(Drop Unload)",
      DROP_AND_WAIT: "Drop & Wait",
      DROP_AND_WAIT_SUBLABEL: "(Live Unload)",
      DROP_EMPTY: "Drop Empty",
      DROP_OFF_TRAILER: "Drop Off Trailer",
      OTHER: "Other",
      PICK_UP_TRAILER: "Pick up trailer",
      PICKUP_EMPTY: "Pickup Empty",
      OUTBOUND_TRAILER: "Outbound trailer",
      BOBTAIL_EXIT: "Bobtail exit",
    },
  },
  PLACEHOLDER: {
    ACCORD_TRAILER: "Accord Trailer",
    ACTUAL_TEMPERATURE_F: "Actual Temperature (°F)",
    SET_TEMPERATURE_F: "Set Temperature (°F)",
    APPOINTMENT_NUMBER: "Appointment Number",
    APPOINTMENT_PO_DELIVERY_NUMBER: "Appointment# / PO# / Delivery#",
    APPOINTMENT_TYPE: "Appointment Type",
    SELECT_ASSET: "Select an asset",
    IS_LIVE_LOAD: "I am here for a live load",
    BOL_OR_PO_NUMBERS: "BOL(s) / PO(s)",
    SELECT_BOL: "Select BOL",
    BOL: "BOL",
    STATE: "State",
    BOL_OR_RELEASE_NUMBER: "BOL / Release Number",
    DESTINATION: "Destination",
    BOOKING_NUMBER: "Booking Number",
    CARRIER: "Carrier",
    CARRIER_NAME: "Carrier Name",
    CARRIER_NAME_PARENT_SCAC: "Carrier Name (Parent SCAC Code)",
    CARRIER_NUMBER: "Carrier Number",
    CARRIER_SCAC: "Enter Carrier SCAC",
    CARRIER_SEAL_NUMBER: "Carrier Seal Number",
    CARRIER_TYPE: "Enter Carrier Type",
    CATEGORY: "Category",
    COMMENTS: "Comments",
    COMPANY_NAME: "Company Name",
    ROUTE_TYPE: "Route Type",
    SHIPMENT_NUMBER: "Shipment #",
    PALLET_COUNT: "Pallet Count",
    PIN: "Enter PIN",
    ADMIN_SETTINGS: "Admin Settings",
    CURRENT_TEMPERATURE_F: "Current Temperature (°F)",
    CVIP_DATE: "CVIP Date",
    DAYS_OF_WEEK_ACCESS_ENABLED: "Days of week access enabled",
    DOOR_NUMBER: "Door Number",
    DRIVER_FIRST_NAME: "Driver First Name",
    EBOL_SIGNATURE: "Sign the Bill of Lading",
    EBOL_SKIP_SIGNATURE: "The digital signature is not required for this visit.",
    DRIVER_LAST_NAME: "Driver Last Name",
    DRIVER_NAME: "Driver Name",
    DRIVER_TYPE: "Driver Type",
    DUNNAGE: "Dunnage",
    EMAIL: "Email",
    EMAIL_ADDRESS: "Email Address",
    EXPIRY_DATE: "Expiry Date",
    EQUIPMENT_LENGTH: "Equipment Length",
    EQUIPMENT_LOADED_STATUS: "Equipment Loaded Status",
    EQUIPMENT_NUMBER: "Equipment Number",
    EQUIPMENT_TYPE: "Equipment Type",
    ENTRY_TYPE_REASON: "Entry Type (Reason of the visit)",
    FACILITY: "Facility",
    FIRST_NAME: "First Name",
    FIVE_TON_TRAILER: "5-Ton Trailer",
    FROM_FACILITY: "From Facility",
    ROUTE_NUMBER: "Route Number",
    SCAC: "SCAC",
    SCAC_CODE: "SCAC Code",
    STOP_LOCATION_ID: "Stop Location ID",
    TRIP_NUMBER: "Trip Number",
    TRUCK_NUMBER: "Truck Number",
    TRUCK_TYPE: "Truck Type",
    CARRIER_COMPANY: "Carrier Company",
    LOAD_STATUS: "Load Status",
    REPAIRS_NEEDED: "Repairs Needed",
    LOAD_TYPE: "Load Type",
    PICKUP_OR_DELIVERY: "Pickup or Delivery",
    PICKUP_NUMBER_OR_MSC_NUMBER: "Pickup Number / MSC Number",
    PURPOSE_OF_VISIT: "Purpose of Visit",
    SUB_LOAD_TYPE: "Sub Load Type",
    FRESH_RETURNS_NUMBER: "Fresh Returns Number",
    FUEL_LEVEL: "Fuel Level",
    HAS_BOL: "I have a BOL Number",
    HAS_TRAILER: "Do you have a trailer?",
    I_AGREE: "I Agree",
    ID_LAST_DIGITS: "Last 4 digits of ID Number",
    ID_VALIDATION: "ID Validation",
    IN_TRANSIT: "In transit",
    INBOUND_TRAILER_NUMBER: "Inbound Trailer Number",
    INBOUND_VEHICLE_TYPE: "Inbound Vehicle Type",
    INBOUND_USAGE: "Inbound Usage",
    INBOUND_BOL: "Inbound BOL",
    IB_REFUSAL: "Select here if Refusal",
    IS_PARCEL: "Is this a parcel delivery?",
    IS_PICKUP_EMPTY: "Are you here for a pickup?",
    LAST_NAME: "Last Name",
    LICENSE_PLATE: "License Plate",
    LOAD_ID: "Load ID",
    LOAD_ID_OPTIONAL: "Load ID (Optional)",
    LOAD_ID_NUMBER: "Load ID Number",
    LOBLAW_LOAD_ID_OPTIONAL: "Loblaw Load ID (Optional)",
    MSC_NUMBER: "MSC Number",
    NEW_GROUP_NAME: "New group name",
    OUTBOUND_BOL: "Outbound BOL",
    OUTBOUND_TRAILER_NUMBER: "Outbound Trailer Number",
    OUTBOUND_TRAILER_NUMBER_PRIMARY: "Outbound Trailer Number (Primary)",
    OUTBOUND_TRAILER_NUMBER_SECONDARY: "Outbound Trailer Number (Secondary)",
    OUTBOUND_VEHICLE_TYPE: "Outbound Vehicle Type",
    OUTBOUND_USAGE: "Outbound Usage",
    OTHER_REASON: "Other Reason",
    PHONE_NUMBER: "Phone Number",
    PICKUP_NUMBER: "Pickup Number",
    PLATE_NUMBER: "Plate Number",
    PO_NUMBER: "PO Number",
    PO_NUMBER_NO_DASH: "PO Number (no dashes or digits after a dash)",
    PO_NUMBER_OR_LOAD_ID: "Enter only one PO Number, ASN, or Load ID / Reference ID",
    PO_NUMBER_OR_APPOINTMENT_OR_LOAD_ID: "Appointment #/ PO #/ Load ID",
    POINT_OF_CONTACT: "Point of Contact",
    PPE_DOCK_SAFETY: "PPE & Dock Safety",
    PPE_DOCK_SAFETY_ASSISTANCE:
      "If you need assistance with dock safety or have concerns regarding PPE, please see the designated personnel at the checkpoint station. \n\nThank You",
    PPE_DOCK_SAFETY_COMPLIANCE:
      "By selecting YES you agree to comply with all applicable laws and our policies. Unauthorized use, modification, or distribution is prohibited. We are not liable for any damages. For more, review our Privacy Policy and full terms.\n\nFailure to comply with dock safety or PPE requirements may result in fines. If you need assistance with dock safety or have concerns regarding PPE, please see the designated personnel at the checkpoint station. Providing this information allows us to notify you when to check in.",
    REASON_FOR_ENTRY: "Reason For Entry",
    RESCAN_ID: "Rescan your ID",
    REEFER_FUEL_LEVEL: "Reefer Fuel Level",
    REEFER_OFF: "Reefer Off",
    REEFER_ON: "Reefer/Heater On / Off",
    REFERENCE: "Reference",
    REWORK: "Select here if Rework",
    SEAL_NUMBER: "Seal Number",
    SEAL_NUMBER_PRIMARY: "Seal Number (Primary)",
    SEAL_NUMBER_SECONDARY: "Seal Number (Secondary)",
    SEARCH_CARRIER: "Search for a carrier...",
    SELECT_FACILITY: "Select facility...",
    SELECT_REASON: "Select reason...",
    SELECT_X: "Select {{X}}",
    SIGNATURE: "Signature",
    SHIP_TO: "Ship To",
    CARRIER_ASSET: "Carrier Trailer",
    WEIGHT_IN_TONNES: "Weight (tonnes)",
    GROSS_WEIGHT_IN_TONNES: "Gross Weight (tonnes)",
    REUSE_QR: "Reuse QR Code",
    TEMPERATURE_C: "Temperature (°C)",
    TEMPERATURE_F: "Temperature (°F)",
    TRACTOR_CARRIER_NAME: "Tractor Carrier Name",
    TRACTOR_NUMBER: "Tractor Number",
    TRAILER_CARRIER_NAME: "Trailer Carrier Name",
    TRAILER_MIDDLE: "Middle",
    TRAILER_NOSE: "Nose",
    TRAILER_NUMBER: "Trailer Number",
    TRAILER_NUMBER_PRIMARY: "Trailer Number (Primary)",
    TRAILER_NUMBER_SECONDARY: "Trailer Number (Secondary)",
    PICKUP_TRAILER_NUMBER: "Pickup Trailer Number",
    LAST_STORE_NUMBER_VISITED: "Last Store Number Visited",
    TIME_INTERVAL_OF_DAY_ACCESS_ENABLED: "Time interval of day access enabled",
    TRAILER_TAIL: "Tail",
    TRAILER_SIZE: "Trailer Size",
    TRAILER_TYPE: "Trailer Type",
    USAGE: "Usage",
    USDOT_NUMBER: "USDOT Number",
    VALIDATION_PERIOD: "Validation Period",
    VEHICLE_NUMBER: "Vehicle Number",
    PEPSI: {
      POINT_OF_CONTACT: "Point of Contact",
      CAR_MOVE_FO_TU_NUMBER: "Enter Car Move / FO / TU #",
      LOAD_ID: "Enter Load ID",
    },
  },
  WAIVER: {
    AWG: "The following rules have been adopted by our company and are to be followed by all who work in or visit our facilities. We hold ourselves to a very high standard of conduct and expect our suppliers, contractors and visitors to do the same. The U.S. Food & Drug Administration and the U.S. Department of Agriculture also require these rules for maintaining a sanitary food warehousing operation.\n\nGOOD MANUFACTURING PRACTICES\n1. Wear clean outer garments and maintain a high degree of personal cleanliness.\n2. Persons, while infected with a communicable disease, have boils, open sores or infected wounds, shall not be allowed in production areas.\n3. Personnel with minor cuts or injuries will be allowed to work on production floor provided the cuts are bandaged and covered with an impermeable sanitary material.\n4. Wash hands thoroughly before starting work, after each break, after every visit to the rest room and any time hands become soiled or contaminated.\n5. Gloves and insulated outerwear, if used for food handling, shall be maintained in a sanitary condition.\n6. Eating foods, chewing gum, drinking beverages, candies, throat lozenges, electronic cigarettes and using tobacco is confined to the designated non production areas.\n7. Spitting, holding objects including toothpicks in the mouth is not permitted in the facility.\n8. Clothing and other personal belongings, including lunches or other food items, must be stored in designated areas ONLY.\n\nSAFETY PROCEDURES\n1. Driver must wear reflective safety vest at all times while on property.\n2. Driver will utilize flashers while vehicle is moving at all times while on property; follow all posted speed limit signs and safety procedures.\n3. Driver will not move trailer if dock light is red where applicable, ramp is in trailer or dock door is open.\n4. Driver will not move trailer from dock door until driver receives his/her signed paperwork stating driver's load is complete and cleared to proceed.\n5. Driver must stop at guard shack upon exiting property, driver is to give his/her Indemnity Agreement to the guard and return safety vest, if supplied.\n\nACTIVE SHOOTER\n1. Active shooter is an individual actively engaged in killing or attempting to kill people incidents, in many cases, there is no pattern or method to the selection of victims, which results in an unpredictable and evolving situation.\n2. You can survive an active shooter event by remembering 3 simple words. RUN-HIDE-FIGHT\n\nINDEMNITY AGREEMENT\nDriver agrees as follows: Any person brought by Driver onto the premises of Associated Wholesale Grocers, Inc. (AWG) is, and shall be considered for all purposes to be, the employee of Driver. Driver is solely responsible for any injury or damage by, or to, such person while on the AWG premises. Driver shall indemnify and hold harmless AWG, its employees, managers, officers, agents, representatives, members, affiliates, insurers, and owners of the premises from all responsibility, liability, claims, damages, losses, and expenses of any kind whatsoever, including without limitation attorney's fees, for any illness, injury or damage to person or property occurring at any time while on the AWG premises (1) to anyone due to any negligent, intentional or other act of Driver or his employee(s), or (2) to Driver or his employee(s).\n\nBy signing this you are acknowledging that you have read and are bound by this agreement and shall follow all safety and food safety requirements contained herein.",
    PORTCITY:
      'WHEREAS, I, {{FIRST_NAME}} {{LAST_NAME}} desire to enter upon the premises located at {{ADDRESS}} (hereinafter "the Property") which is owned and/or operated by Port City Logistics, Inc. for a lawful business purpose; and \n WHEREAS, the Property is currently used in the business of Port City Logistics, Inc. as part of their warehousing and logistics business. \n THEREFORE, in consideration of being granted the right to access the Property, I, the undersigned, acknowledge that I am fully aware of the risks and hazards connected with entering, touring or occupying the Property including, but not limited to, physical injury and/or property damage due to (1) tractor collisions, (2) forklift collisions, (3) slips, trips and falls, and (4) other hazardous events which may develop on the Property and understand that these risks and hazards may cause severe and substantial harm or even death, and I warrant and agree as follows: \n I agree to release, discharge, waive, indemnify and hold harmless from and against all liabilities, actions, causes of action, suits, damages, losses, judgments, claims and demands whatsoever, in law or in equity, including legal fees and disbursements, which I, any company or business entity that I represent, or my heirs, executors, administrators, legal representatives, successors, or assigns may now or hereafter have against Port City Logistics, Inc. and any of the directors, officers, employees and agents of Port City Logistics, Inc. (the "Released Parties"). \n I hereby assume all risk of accidents, personal injury, death and property loss or damage sustained or incurred as a result of my presence at the Property (including, but not limited to, during my participation in any site tours, logistics operations), including those caused as a result of negligence on the part of the Released Parties or other third parties which occur on the premises. \n I acknowledge that it is my sole responsibility to evaluate carefully the risks inherent in visiting the Property and that I have fully considered those risks, including, without limitation, dangers posed by willful or negligent conduct of myself and/or by others. \n I acknowledge and agree that I shall not conduct any invasive tests or inspections on the Property, and shall bear full responsibility, including costs and expenses, to repair any damage to the Property, or the goods stored within the Property, as a result of my entry upon the Property. \n I acknowledge and agree that I shall bear full responsibility, including costs and expenses, to repair any damage to any machinery or equipment, even machinery owned by third parties, which is damaged as a result of my entry upon the Property. \n I agree that if any portion of this document is held invalid, the remaining provisions shall be binding and continue in full force and effect. \n I agree that I will follow all the instructions specified by any site managers, or representatives or agents of Port City Logistics, Inc. while on the Property and that they may revoke permission to remain on the Property at any time and I will leave immediately upon being instructed to do so. \n By signing this release, I acknowledge and represent that I have read the foregoing Waiver of Liability, Assumption of the Risk, and Hold Harmless Agreement carefully, that I understand the terms and conditions contained in the Agreement, and that I am here voluntarily. I further acknowledge and represent that no oral representations, statements or inducements, apart from the foregoing written agreements, have been made by any employee, agent or representative of Port City Logistics, Inc.',
    PORTCITY_KIOSK:
      'WHEREAS, I, desire to enter upon the premises which is owned and/or operated by Port City Logistics, Inc. for a lawful business purpose; and WHEREAS, the Property is currently used in the business of Port City Logistics, Inc. as part of their warehousing and logistics business. \n THEREFORE, in consideration of being granted the right to access the Property, I, the undersigned, acknowledge that I am fully aware of the risks and hazards connected with entering, touring or occupying the Property including, but not limited to, physical injury and/or property damage due to (1) tractor collisions, (2) forklift collisions, (3) slips, trips and falls, and (4) other hazardous events which may develop on the Property and understand that these risks and hazards may cause severe and substantial harm or even death, and I warrant and agree as follows: \n I agree to release, discharge, waive, indemnify and hold harmless from and against all liabilities, actions, causes of action, suits, damages, losses, judgments, claims and demands whatsoever, in law or in equity, including legal fees and disbursements, which I, any company or business entity that I represent, or my heirs, executors, administrators, legal representatives, successors, or assigns may now or hereafter have against Port City Logistics, Inc. and any of the directors, officers, employees and agents of Port City Logistics, Inc. (the "Released Parties"). \n I hereby assume all risk of accidents, personal injury, death and property loss or damage sustained or incurred as a result of my presence at the Property (including, but not limited to, during my participation in any site tours, logistics operations), including those caused as a result of negligence on the part of the Released Parties or other third parties which occur on the premises. \n I acknowledge that it is my sole responsibility to evaluate carefully the risks inherent in visiting the Property and that I have fully considered those risks, including, without limitation, dangers posed by willful or negligent conduct of myself and/or by others. \n I acknowledge and agree that I shall not conduct any invasive tests or inspections on the Property, and shall bear full responsibility, including costs and expenses, to repair any damage to the Property, or the goods stored within the Property, as a result of my entry upon the Property. \n I acknowledge and agree that I shall bear full responsibility, including costs and expenses, to repair any damage to any machinery or equipment, even machinery owned by third parties, which is damaged as a result of my entry upon the Property. \n I agree that if any portion of this document is held invalid, the remaining provisions shall be binding and continue in full force and effect. \n I agree that I will follow all the instructions specified by any site managers, or representatives or agents of Port City Logistics, Inc. while on the Property and that they may revoke permission to remain on the Property at any time and I will leave immediately upon being instructed to do so. \n By signing this release, I acknowledge and represent that I have read the foregoing Waiver of Liability, Assumption of the Risk, and Hold Harmless Agreement carefully, that I understand the terms and conditions contained in the Agreement, and that I am here voluntarily. I further acknowledge and represent that no oral representations, statements or inducements, apart from the foregoing written agreements, have been made by any employee, agent or representative of Port City Logistics, Inc.',
  },
  QUESTION: {
    ACTUAL_TEMPERATURE_F: "Actual Temperature °F",
    APPOINTMENT_DETAILS: "Appointment details",
    ASSET_SELECTION: "Asset Selection",
    CARRIER_TYPE: "Carrier Type",
    COMMENTS: "Comments",
    COMPANY_INFO: "Company information",
    CONFIRM_SEAL_AND_TRAILER_NUMBER:
      "Confirm seal is intact and the trailer number is correct",
    CONFIRM_LOADED_TRAILER_CONDITION: "Confirm the tandems are slid back.",
    CONFIRM_LOADED_HEATER_TRAILER_CONDITION:
      "Confirm the tandems are slid back, and the heater is working.",
    CONFIRM_LOADED_REEFER_TRAILER_CONDITION:
      "Confirm the tandems are slid back, and the reefer is working.",
    CONFIRM_TRAILER_CONDITION:
      "Confirm the trailer is free of debris, the tandems are slid back.",
    CONFIRM_HEATER_TRAILER_CONDITION:
      "Confirm the trailer is free of debris, the tandems are slid back, and the heater is working.",
    CONFIRM_REEFER_TRAILER_CONDITION:
      "Confirm the trailer is free of debris, the tandems are slid back, and the reefer is working.",
    CONTINUE_LOADING: "Continue Loading",
    DRIVER_NAME: "Driver Information",
    DRIVER_TYPE: "Driver Type",
    EBOL_PHOTO: "Capture a photo of your e-BoL (Bill of Lading)",
    EBOL_SIGNATURE: "Sign your Bill of Lading",
    EBOL_SKIP_SIGNATURE: "E-Signature Acknowledgement",
    ENTRY_PURPOSE: "Select Entry Purpose",
    OUTBOUND_PIN: "Enter your PIN to access outbound",
    ENTRY_TYPE: "Choose your entry type",
    EQUIPMENT_DETAILS: "Equipment Details",
    EXPIRY_DATE: "Expiry Date",
    AWG: {
      ITEM_TYPE: "Select item type",
      VISIT_LOCATION: "Where are you going?",
    },
    FIRST_TRAILER_LOAD_STATUS: "First trailer load status",
    SECOND_TRAILER_LOAD_STATUS: "Second trailer load status",
    GENERIC: "Fill out the information",
    HAS_TRAILER: "Do you have a trailer?",
    IN_TRANSIT: "In transit",
    INITIATE_LOADING: "Initiate Loading",
    LOAD_DETAILS: "Load details",
    LOAD_TYPE: "Select load type",
    NUMBER_OF_TRAILERS: "Number of trailers",
    OTHER_REASON_FOR_DRIVER_ASSIST: "Please specify other reason for driver assistance",
    PERSONAL_INFO: "Personal information",
    PICKUP_NUMBER: "Pickup number",
    PPE_DOCK_SAFETY_COMPLIANCE:
      'Dear Valued Independent Carrier,\n\nDock Safety and the protection of colleagues are extremely important priorities to Loblaw Companies Limited.\n\nPROCEDURES\n\n**ARRIVING**\nReport to Distribution Centre Checkpoint and present your Dock Safety Certification Card or agree to the below to obtain your door assignment.\nBack into door only on a **GREEN** light. Do not back up to a door or trailer on a red light.\nRelease dump valve (releases air from suspension).\nDock restraint system will be engaged by loader/receiver.\n*For non-restraint facilities:*\nProperly place wheel chock under wheel.\nDisconnect air supply line from trailer and lower legs until 1" from ground.\nDetach tractor from trailer, move forward fully to maintain 6 feet between back of tractor and front of trailer\n\n**DEPARTING**\nReport to your Distribution Centre Checkpoint to obtain clearance and paperwork from dispatch/supervisor before moving trailer from door.\nRestraints will be disengaged by loader/receiver when load is complete. Only move your tractor when the light is green.\n*For non-restraint facilities:*\nOnly back up to a trailer when the light is green. Place wheel chock in holder when load is complete.\nOnly pull away on a **GREEN** light.\n\nReport back to Distribution Centre Checkpoint, if any problems are experienced with the above procedures.\n\nAdditional measures may be required, as applicable.\n\nI have reviewed the applicable Dock Safety procedures at this Distribution Centre and agree to abide to these procedures.\nI understand that failure to follow these instructions may result in a penalty of up to and including **$25,000** and/or potential loss of services/access to Loblaw Companies Limited facilities.\nI agree to wear **CSA approved (or equivalent) safety footwear** and **CSA approved high visibility reflective vest (Class 2)** as long as I am on property, within the yard or concourse and in the truck travel path.\nFailure to comply may result in a penalty of **$1000** and/or removal from site.\n\nI attest\nto following the Dock Safety Certification procedures above\nhaving and wearing the required CSA approved Personal Protective Equipment (PPE)\nthat Vehicle Inspections will be completed in — accordance to D.O.T. Federal Motor Carrier Regulations\nI have read and agree to the terms and conditions — above\n\nThank you for your concern and cooperation in this matter and for taking the time to help us ensure that you, and all who work here, are protected from serious injury.',
    PPE_DOCK_SAFETY: "PPE & Dock Safety",
    REASON_FOR_DRIVER_ASSIST: "Reason for Driver Assistance",
    REASON_FOR_ENTRY: "Reason for Entry",
    RESCAN_ID: "Rescan your ID",
    REEFER_STATUS: "Reefer Status",
    SET_TEMPERATURE_F: "Set Temperature °F",
    SHIPPING_DETAILS: "Shipping details",
    TERMS_AND_CONDITIONS: "Terms and Conditions",
    TRAILER_SIZE: "Trailer Size",
    TRAILER_SUBTYPE: "Trailer Subtype",
    TRAILER_TYPE: "Trailer Type",
    TRAILER_OR_CONTAINER_DETAILS: "Trailer/Container Details",
    TRANSACTION_TYPE: "Choose Transaction Type",
    TRUCK_NUMBER: "Truck Number",
    TRUCK_TYPE: "Truck Type",
    UPLOAD_SEAL: "Upload a photo of the seal",
    UPLOAD_BOL: "Upload one or more BOL PDF documents or images",
    VEHICLE_DETAILS: "Vehicle details",
    VISIT_TYPE: "Choose your visit type",
    VISITOR: "Visitor Entry",
    WAIVER: "Waiver",
    WEIGHT_ENTRY_MODE: "How would you like to enter the load weight?",
    PEPSI: {
      CAR_MOVE_FO_TU_NUMBER: "Car Move / FO / TU #",
      CARRIER: "Carrier Name",
      INBOUND_ENTRY_SUBTYPE: "Select inbound load type",
      LOAD_ID: "Load ID",
      OUTBOUND_ENTRY_SUBTYPE: "Select outbound load type",
      PHONE_NUMBER: "Driver Phone Number",
      POINT_OF_CONTACT: "Point of Contact",
      SEAL_NUMBER: "Seal Number",
      TRAILER_ID: "Trailer ID",
    },
  },
  STATUS: {
    ACTIVE: "Active",
    EXPIRED: "Expired",
    EXPIRING_SOON: "Expiring Soon",
  },
  SEPARATOR: {
    OR: "OR",
  },
  SUCCESS_PAGE: {
    COMMAND: {
      DOWNLOAD: "Download",
      EMAIL: "Email",
      HOME: "Home",
      MESSAGE: "Message",
      START_OVER: "Start Over",
    },
    GENERATING_QR_CODE: "QR code is being generated!",
    PLEASE_SCAN_CODE: "Please scan your QR code at the kiosk",
    APPOINTMENT_CODE: "Appointment Code: ",
    PLEASE_CHECK_DASHBOARD: "Check the AVAC Dashboard for the status",
    PLEASE_WAIT: "Please wait...",
    QR_CODE_GENERATED: "QR code generated!",
    DRIVER_CHECK_IN_SUCCESS: "Check-In Successfully Initiated",
    DRIVER_CHECK_OUT_SUCCESS: "Check-Out Successfully Initiated",
    SMART_LOCKER_PICKUP: "Pick up your documents from locker {{LOCKER}}",
    PAPER_PICKUP_MOTC_OFFICE: "Please pick up paper at the MOTC office.",
  },
  SUGGESTION: {
    PO_NUMBER_OR_LOAD_ID: "Fill in either PO Number or Load ID field",
  },
  TITLE: {
    ACTION: "Action",
    ACTIONS: "Actions",
    ACTUAL_TEMPERATURE_NOSE: "Actual Temperature (Nose)",
    ACTUAL_TEMPERATURE_MIDDLE: "Actual Temperature (Middle)",
    ACTUAL_TEMPERATURE_TAIL: "Actual Temperature (Tail)",
    APPOINTMENT: "Appointment",
    ASSIGNED_ZONE: "Assigned Zone",
    AVAC_EVENT: "AVAC Event",
    CARRIER: "Carrier",
    CARRIER1: "Carrier 1",
    CARRIER2: "Carrier 2",
    CATEGORY: "Category",
    COMPANY_NAME: "Company Name",
    CVIPDATE: "CVIP Date",
    DAMAGE_DETECTED: "Damage Detected",
    DAMAGE_STATUS: "Damage Status",
    DRIVER: "Driver",
    DRIVER_FIRST_NAME: "Driver First Name",
    DRIVER_ID: "Driver ID",
    DRIVER_LAST_NAME: "Driver Last Name",
    DRIVER_NAME: "Driver Name",
    DRIVER_TYPE: "Driver Type",
    EMAIL: "Email",
    EMAIL_ADDRESS: "Email Address",
    ENTRY_TYPE: "Entry Type",
    ENTRY_SUB_TYPE: "Entry Sub Type",
    OUTBOUND_ENTRY_SUB_TYPE: "Outbound Entry Sub Type",
    EVENT_SUB_TYPE: "Event Sub Type",
    EXP_DATE: "Exp. Date",
    FIRST_NAME: "First Name",
    FULL_NAME: "Full Name",
    ID: "ID",
    INITIATION_STATUS: "Initiation Status",
    INTACT_TIME: "Intact Time",
    LAST_NAME: "Last Name",
    LOAD: "Load",
    LOAD_ID: "Load ID",
    LOCATION: "Location",
    LOCOMOTIVE: "Locomotive",
    PASSCODE: "Passcode",
    PEPSI_FLEET: "Pepsi Fleet",
    PHONE: "Phone",
    PHONE_NUMBER: "Phone Number",
    PLATE_NUMBER: "Plate Number",
    PO_LOAD_DETAILS_AND_ASSIGNED_LOCATIONS: "PO / Load Details and Assigned Locations",
    POWER_UNIT: "Power Unit",
    QR_CODE: "QR Code",
    RAILCAR: "Railcar",
    REASON_FOR_ENTRY: "Reason For Entry",
    REFERENCE_NUMBER: "Reference Number",
    REFERENCE: "Reference",
    PRODUCT: "Product",
    SEAL_NUMBER: "Seal Number",
    FIRST_SEAL_NUMBER: "First Seal Number",
    SECOND_SEAL_NUMBER: "Second Seal Number",
    SET_TEMPERATURE_NOSE: "Set Temperature (Nose)",
    SET_TEMPERATURE_MIDDLE: "Set Temperature (Middle)",
    SET_TEMPERATURE_TAIL: "Set Temperature (Tail)",
    SIGNATURE: "Signature",
    SOURCE: "Source",
    SPOT: "Spot",
    STATUS: "Status",
    TAMPERED_TIME: "Tampered Time",
    TEMPERATURE: "Temperature",
    TEST_FIELD: "Test Field",
    TRAILER_NUMBER: "Trailer Number",
    TRAILERS: "Trailers",
    TRAILER_TYPE1: "Trailer Type 1",
    TRAILER_TYPE2: "Traielr Type 2",
    TYPE: "Type",
    UNIT: "Unit",
    UNITS: "Units",
    UNIT_NUMBER1: "Unit Number 1",
    UNIT_NUMBER2: "Unit Number 2",
    USDOT_NUMBER: "USDOT Number",
    VALIDATION_PERIOD: "Validation Period",
    VEHICLE: "Vehicle",
    VEHICLE_NUMBER: "Vehicle Number",
    VEHICLE_TYPE: "Vehicle Type",
    YMS: "YMS",
    ZONE: "Zone",
  },
  TOOLTIP: {
    ADD: "Add",
    ARROW: "arrow",
    COMPANY_LOGO: "Company Logo",
    COPY_TO_CLIPBOARD: "Copy to clipboard",
    DOWNLOAD: "download",
    LOGO: "Logo",
    MENU: "menu",
    SORT_ASC: "sort ascending",
    SORT_DESC: "sort descending",
  },
  VALIDATION: {
    ERROR: {
      INVALID_BOOKING_NUMBER: "Invalid Booking Number",
      INVALID_FACILITY: "Invalid facility",
      INVALID_LOAD_ID: "Invalid Load ID",
      INVALID_LOAD_ID_TRY_AGAIN: "Invalid Load ID. Please check and try again.",
      LOAD_ID_VALIDATION_FAILED: "Load ID Number validation failed",
      BOL_VALIDATION_FAILED: "Failed to validate reference number.",
      STAPLES_REFERENCE_VALIDATION_FAILED: "Invalid PO Number / Appt Number / Load Id",
      PO_VALIDATION_FAILED:
        "Invalid PO. Retry or contact your Dispatch or see Inbound Clerk.",
      PO_VALIDATION_OVERRIDE:
        "Invalid PO. Press NEXT to override, or re-enter the PO to verify.",
      FUEL_VALIDATION_FAILED: "Failed to get reefer stats",
      TRAILER_VALIDATION_FAILED: "Failed to validate trailer details",
      APPOINTMENT_VALIDATION_FAILED:
        "Appointment not found. Please check the number and try again.",
      CAR_MOVE_NOT_FOUND:
        "Load ID was not found in the Shipment Plan. Please enter the correct Load ID.",
      CONTACT_GATE_OPERATOR_OUTBOUND_SLIP:
        "Contact Gate Operator to get an outbound slip",
    },
    OUTBOUND_BOL_OR_CARRIER_SCAC: "Please provide either Outbound BOL or Carrier SCAC",
    CVIP_DATE_EXPIRED: "Trailer CVIP date not valid, see Inbound Clerk",
    EMAIL_ADDRESS: "Please enter a valid email address",
    FLOAT: "Please enter valid numbers (e.g. 123 or 123.45)",
    SIGNED_FLOAT: "Please enter a valid number (e.g. -123, 123, or -123.45)",
    NUMERIC: "Please enter numbers only",
    ALPHANUMERIC: "Only alphanumeric characters allowed",
    FIX_LENGTH: "Must be exactly {{count}} characters",
    MAX_LENGTH: "Maximum {{count}} characters allowed",
    MIN_LENGTH: "Minimum {{count}} characters required",
    MIN_VALUE: "Value must be at least {{count}}",
    MAX_VALUE: "Value must be at most {{count}}",
    DECIMAL_PLACES: "Please enter at most {{count}} decimal place",
    PERSON_NAME: "Should only contain letters and spaces",
    PHONE_NUMBER: "Enter a valid phone number (e.g., 1234567890)",
    PO_NUMBER_OR_LOAD_ID: "Please provide either PO Number or Load ID",
    TEMPERATURE_FROM_N20F_TO_P100F: "Temperature must be between -20°F and 100°F",
    VALIDATING_REFERENCE_NUMBER: "Validating reference number",
    VALIDATING_PIN: "Validating PIN",
    VALIDATING_TRAILER_DETAILS: "Validating trailer details",
    VALIDATING_PO_NUMBER: "Validating PO number",
    VALIDATING_LOAD_ID: "Validating Load ID",
    VALIDATING_APPOINTMENT: "Validating appointment",
  },
  APPOINTMENT_INSTRUCTIONS: {
    KRAFT: {
      INBOUND: {
        GENERIC: "You can use this on exit if driving bobtail / empty",
        CONTRACTOR: "You can use this on exit",
      },
    },
    DILLARDS: {
      INBOUND: {
        CONTRACTOR: "You can use this on exit",
      },
    },
  },
} as const;
